var _keyboard;

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { MathUtils, Texture, LinearFilter, SphereGeometry, Mesh, Quaternion, ShaderMaterial, Vector3, SplineCurve, Vector2, WebGLRenderer, Scene, PerspectiveCamera, Group, Raycaster, FileLoader, Euler } from '../../three/build/three.module.js';
/*!
 * PhotoSphereViewer 5.0.1
 * @copyright 2014-2015 Jérémy Heleine
 * @copyright 2022 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */

var __defProp = Object.defineProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
}; // src/data/constants.ts


var constants_exports = {};

__export(constants_exports, {
  ACTIONS: function ACTIONS() {
    return _ACTIONS;
  },
  ANIMATION_MIN_DURATION: function ANIMATION_MIN_DURATION() {
    return _ANIMATION_MIN_DURATION;
  },
  CTRLZOOM_TIMEOUT: function CTRLZOOM_TIMEOUT() {
    return _CTRLZOOM_TIMEOUT;
  },
  DBLCLICK_DELAY: function DBLCLICK_DELAY() {
    return _DBLCLICK_DELAY;
  },
  DEFAULT_TRANSITION: function DEFAULT_TRANSITION() {
    return _DEFAULT_TRANSITION;
  },
  EASINGS: function EASINGS() {
    return _EASINGS;
  },
  IDS: function IDS() {
    return _IDS;
  },
  INERTIA_WINDOW: function INERTIA_WINDOW() {
    return _INERTIA_WINDOW;
  },
  KEY_CODES: function KEY_CODES() {
    return _KEY_CODES;
  },
  LONGTOUCH_DELAY: function LONGTOUCH_DELAY() {
    return _LONGTOUCH_DELAY;
  },
  MOVE_THRESHOLD: function MOVE_THRESHOLD() {
    return _MOVE_THRESHOLD;
  },
  SPHERE_RADIUS: function SPHERE_RADIUS() {
    return _SPHERE_RADIUS;
  },
  TWOFINGERSOVERLAY_DELAY: function TWOFINGERSOVERLAY_DELAY() {
    return _TWOFINGERSOVERLAY_DELAY;
  },
  VIEWER_DATA: function VIEWER_DATA() {
    return _VIEWER_DATA;
  }
});

var _DEFAULT_TRANSITION = 1500;
var _ANIMATION_MIN_DURATION = 500;
var _MOVE_THRESHOLD = 4;
var _DBLCLICK_DELAY = 300;
var _LONGTOUCH_DELAY = 500;
var _TWOFINGERSOVERLAY_DELAY = 100;
var _CTRLZOOM_TIMEOUT = 2e3;
var _INERTIA_WINDOW = 300;
var _SPHERE_RADIUS = 10;
var _VIEWER_DATA = "photoSphereViewer";

var _ACTIONS = /* @__PURE__ */function (ACTIONS2) {
  ACTIONS2["ROTATE_UP"] = "ROTATE_UP";
  ACTIONS2["ROTATE_DOWN"] = "ROTATE_DOWN";
  ACTIONS2["ROTATE_RIGHT"] = "ROTATE_RIGHT";
  ACTIONS2["ROTATE_LEFT"] = "ROTATE_LEFT";
  ACTIONS2["ZOOM_IN"] = "ZOOM_IN";
  ACTIONS2["ZOOM_OUT"] = "ZOOM_OUT";
  return ACTIONS2;
}(_ACTIONS || {});

var _IDS = {
  MENU: "menu",
  TWO_FINGERS: "twoFingers",
  CTRL_ZOOM: "ctrlZoom",
  ERROR: "error",
  DESCRIPTION: "description"
};
var _KEY_CODES = {
  Enter: "Enter",
  Control: "Control",
  Escape: "Escape",
  Space: " ",
  PageUp: "PageUp",
  PageDown: "PageDown",
  ArrowLeft: "ArrowLeft",
  ArrowUp: "ArrowUp",
  ArrowRight: "ArrowRight",
  ArrowDown: "ArrowDown",
  Delete: "Delete",
  Plus: "+",
  Minus: "-"
};
var _EASINGS = {
  linear: function linear(t) {
    return t;
  },
  inQuad: function inQuad(t) {
    return t * t;
  },
  outQuad: function outQuad(t) {
    return t * (2 - t);
  },
  inOutQuad: function inOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  inCubic: function inCubic(t) {
    return t * t * t;
  },
  outCubic: function outCubic(t) {
    return --t * t * t + 1;
  },
  inOutCubic: function inOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  inQuart: function inQuart(t) {
    return t * t * t * t;
  },
  outQuart: function outQuart(t) {
    return 1 - --t * t * t * t;
  },
  inOutQuart: function inOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  inQuint: function inQuint(t) {
    return t * t * t * t * t;
  },
  outQuint: function outQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  inOutQuint: function inOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  },
  inSine: function inSine(t) {
    return 1 - Math.cos(t * (Math.PI / 2));
  },
  outSine: function outSine(t) {
    return Math.sin(t * (Math.PI / 2));
  },
  inOutSine: function inOutSine(t) {
    return 0.5 - 0.5 * Math.cos(Math.PI * t);
  },
  inExpo: function inExpo(t) {
    return Math.pow(2, 10 * (t - 1));
  },
  outExpo: function outExpo(t) {
    return 1 - Math.pow(2, -10 * t);
  },
  inOutExpo: function inOutExpo(t) {
    return (t = t * 2 - 1) < 0 ? 0.5 * Math.pow(2, 10 * t) : 1 - 0.5 * Math.pow(2, -10 * t);
  },
  inCirc: function inCirc(t) {
    return 1 - Math.sqrt(1 - t * t);
  },
  outCirc: function outCirc(t) {
    return Math.sqrt(1 - (t - 1) * (t - 1));
  },
  inOutCirc: function inOutCirc(t) {
    return (t *= 2) < 1 ? 0.5 - 0.5 * Math.sqrt(1 - t * t) : 0.5 + 0.5 * Math.sqrt(1 - (t -= 2) * t);
  }
}; // src/utils/index.ts

var utils_exports = {};

__export(utils_exports, {
  Animation: function Animation() {
    return _Animation;
  },
  Dynamic: function Dynamic() {
    return _Dynamic;
  },
  MultiDynamic: function MultiDynamic() {
    return _MultiDynamic;
  },
  Slider: function Slider() {
    return _Slider;
  },
  SliderDirection: function SliderDirection() {
    return _SliderDirection;
  },
  addClasses: function addClasses() {
    return _addClasses;
  },
  applyEulerInverse: function applyEulerInverse() {
    return _applyEulerInverse;
  },
  cleanCssPosition: function cleanCssPosition() {
    return _cleanCssPosition;
  },
  clone: function clone() {
    return _clone;
  },
  createTexture: function createTexture() {
    return _createTexture;
  },
  cssPositionIsOrdered: function cssPositionIsOrdered() {
    return _cssPositionIsOrdered;
  },
  dasherize: function dasherize() {
    return _dasherize;
  },
  deepEqual: function deepEqual() {
    return _deepEqual;
  },
  deepmerge: function deepmerge() {
    return _deepmerge;
  },
  distance: function distance() {
    return _distance;
  },
  firstNonNull: function firstNonNull() {
    return _firstNonNull;
  },
  getAbortError: function getAbortError() {
    return _getAbortError;
  },
  getAngle: function getAngle() {
    return _getAngle;
  },
  getClosest: function getClosest() {
    return _getClosest;
  },
  getConfigParser: function getConfigParser() {
    return _getConfigParser;
  },
  getElement: function getElement() {
    return _getElement;
  },
  getPosition: function getPosition() {
    return _getPosition;
  },
  getShortestArc: function getShortestArc() {
    return _getShortestArc;
  },
  getStyle: function getStyle() {
    return _getStyle;
  },
  getXMPValue: function getXMPValue() {
    return _getXMPValue;
  },
  greatArcDistance: function greatArcDistance() {
    return _greatArcDistance;
  },
  hasParent: function hasParent() {
    return _hasParent;
  },
  isAbortError: function isAbortError() {
    return _isAbortError;
  },
  isEmpty: function isEmpty() {
    return _isEmpty;
  },
  isExtendedPosition: function isExtendedPosition() {
    return _isExtendedPosition;
  },
  isNil: function isNil() {
    return _isNil;
  },
  isPlainObject: function isPlainObject() {
    return _isPlainObject;
  },
  logWarn: function logWarn() {
    return _logWarn;
  },
  parseAngle: function parseAngle() {
    return _parseAngle;
  },
  parsePoint: function parsePoint() {
    return _parsePoint;
  },
  parseSpeed: function parseSpeed() {
    return _parseSpeed;
  },
  positionCompat: function positionCompat() {
    return _positionCompat;
  },
  removeClasses: function removeClasses() {
    return _removeClasses;
  },
  sum: function sum() {
    return _sum;
  },
  throttle: function throttle() {
    return _throttle;
  },
  toggleClass: function toggleClass() {
    return _toggleClass;
  },
  wrap: function wrap() {
    return _wrap;
  }
}); // src/utils/browser.ts


function _getElement(selector) {
  if (typeof selector === "string") {
    return selector.match(/^[a-z]/i) ? document.getElementById(selector) : document.querySelector(selector);
  } else {
    return selector;
  }
}

function _toggleClass(element, className, active) {
  if (active === void 0) {
    element.classList.toggle(className);
  } else if (active) {
    element.classList.add(className);
  } else if (!active) {
    element.classList.remove(className);
  }
}

function _addClasses(element, className) {
  var _element$classList;

  (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(className.split(" ")));
}

function _removeClasses(element, className) {
  var _element$classList2;

  (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(className.split(" ")));
}

function _hasParent(el, parent) {
  var test = el;

  do {
    if (test === parent) {
      return true;
    }

    test = test.parentElement;
  } while (test);

  return false;
}

function _getClosest(el, selector) {
  if (!(el !== null && el !== void 0 && el.matches)) {
    return null;
  }

  var test = el;

  do {
    if (test.matches(selector)) {
      return test;
    }

    test = test.parentElement;
  } while (test);

  return null;
}

function _getPosition(el) {
  var x = 0;
  var y = 0;
  var test = el;

  while (test) {
    x += test.offsetLeft - test.scrollLeft + test.clientLeft;
    y += test.offsetTop - test.scrollTop + test.clientTop;
    test = test.offsetParent;
  }

  return {
    x: x,
    y: y
  };
}

function _getStyle(elt, prop) {
  return window.getComputedStyle(elt, null)[prop];
} // src/utils/math.ts


function _wrap(value, max) {
  var result = value % max;

  if (result < 0) {
    result += max;
  }

  return result;
}

function _sum(array) {
  return array.reduce(function (a, b) {
    return a + b;
  }, 0);
}

function _distance(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}

function _getShortestArc(from, to) {
  var candidates = [0, Math.PI * 2, -Math.PI * 2];
  return candidates.reduce(function (value, candidate) {
    var newCandidate = to - from + candidate;
    return Math.abs(newCandidate) < Math.abs(value) ? newCandidate : value;
  }, Infinity);
}

function _getAngle(position1, position2) {
  return Math.acos(Math.cos(position1.pitch) * Math.cos(position2.pitch) * Math.cos(position1.yaw - position2.yaw) + Math.sin(position1.pitch) * Math.sin(position2.pitch));
}

function _greatArcDistance(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
      lon1 = _ref3[0],
      lat1 = _ref3[1];

  var _ref4 = _slicedToArray(_ref2, 2),
      lon2 = _ref4[0],
      lat2 = _ref4[1];

  var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
  var y = lat2 - lat1;
  return Math.sqrt(x * x + y * y);
} // src/utils/misc.ts


function _dasherize(str) {
  return str.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, function (s, i) {
    return (i > 0 ? "-" : "") + s.toLowerCase();
  });
}

function _throttle(callback, wait) {
  var paused = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!paused) {
      paused = true;
      setTimeout(function () {
        callback.apply(_this, args);
        paused = false;
      }, wait);
    }
  };
}

function _isPlainObject(value) {
  if (_typeof(value) !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }

  if (Object.getPrototypeOf(value) === null) {
    return true;
  }

  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

function _deepmerge(target, src) {
  var first = src;
  return function merge(target2, src2) {
    if (Array.isArray(src2)) {
      if (!target2 || !Array.isArray(target2)) {
        target2 = [];
      } else {
        target2.length = 0;
      }

      src2.forEach(function (e, i) {
        target2[i] = merge(null, e);
      });
    } else if (_typeof(src2) === "object") {
      if (!target2 || Array.isArray(target2)) {
        target2 = {};
      }

      Object.keys(src2).forEach(function (key) {
        if (_typeof(src2[key]) !== "object" || !src2[key] || !_isPlainObject(src2[key])) {
          target2[key] = src2[key];
        } else if (src2[key] != first) {
          if (!target2[key]) {
            target2[key] = merge(null, src2[key]);
          } else {
            merge(target2[key], src2[key]);
          }
        }
      });
    } else {
      target2 = src2;
    }

    return target2;
  }(target, src);
}

function _clone(src) {
  return _deepmerge(null, src);
}

function _isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0 && obj.constructor === Object;
}

function _isNil(val) {
  return val === null || val === void 0;
}

function _firstNonNull() {
  for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    values[_key2] = arguments[_key2];
  }

  for (var _i2 = 0, _values = values; _i2 < _values.length; _i2++) {
    var val = _values[_i2];

    if (!_isNil(val)) {
      return val;
    }
  }

  return null;
}

function _deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  } else if (isObject(obj1) && isObject(obj2)) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }

    for (var _i3 = 0, _Object$keys = Object.keys(obj1); _i3 < _Object$keys.length; _i3++) {
      var prop = _Object$keys[_i3];

      if (!_deepEqual(obj1[prop], obj2[prop])) {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
}

function isObject(obj) {
  return _typeof(obj) === "object" && obj != null;
} // src/PSVError.ts


var PSVError = /*#__PURE__*/function (_Error) {
  _inherits(PSVError, _Error);

  var _super = _createSuper(PSVError);

  function PSVError(message) {
    var _Error$captureStackTr;

    var _this2;

    _classCallCheck(this, PSVError);

    _this2 = _super.call(this, message);
    _this2.name = "PSVError";
    (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 ? void 0 : _Error$captureStackTr.call(Error, _assertThisInitialized(_this2), PSVError);
    return _this2;
  }

  return _createClass(PSVError);
}( /*#__PURE__*/_wrapNativeSuper(Error)); // src/utils/psv.ts


function _positionCompat(position) {
  return _objectSpread(_objectSpread({}, position), {}, {
    get longitude() {
      _logWarn("longitude is deprecated, use yaw instead");

      return this.yaw;
    },

    get latitude() {
      _logWarn("latitude is deprecated, use pitch instead");

      return this.pitch;
    }

  });
}

function _getAbortError() {
  var error = new Error("Loading was aborted.");
  error.name = "AbortError";
  return error;
}

function _isAbortError(err) {
  return (err === null || err === void 0 ? void 0 : err.name) === "AbortError";
}

function _logWarn(message) {
  console.warn("PhotoSphereViewer: ".concat(message));
}

function _isExtendedPosition(object) {
  if (!object) {
    return false;
  }

  return [["textureX", "textureY"], ["yaw", "pitch"], ["x", "y"], ["longitude", "latitude"]].some(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key1 = _ref6[0],
        key2 = _ref6[1];

    return object[key1] !== void 0 && object[key2] !== void 0;
  });
}

function _getXMPValue(data, attr) {
  var result = data.match("<GPano:" + attr + ">(.*)</GPano:" + attr + ">");

  if (result !== null) {
    var val = parseInt(result[1], 10);
    return isNaN(val) ? null : val;
  }

  result = data.match("GPano:" + attr + '="(.*?)"');

  if (result !== null) {
    var _val = parseInt(result[1], 10);

    return isNaN(_val) ? null : _val;
  }

  return null;
}

var CSS_POSITIONS = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
};
var X_VALUES = ["left", "center", "right"];
var Y_VALUES = ["top", "center", "bottom"];
var POS_VALUES = [].concat(X_VALUES, Y_VALUES);
var CENTER = "center";

function _parsePoint(value) {
  if (!value) {
    return {
      x: 0.5,
      y: 0.5
    };
  }

  if (_typeof(value) === "object") {
    return value;
  }

  var tokens = value.toLocaleLowerCase().split(" ").slice(0, 2);

  if (tokens.length === 1) {
    if (CSS_POSITIONS[tokens[0]]) {
      tokens = [tokens[0], CENTER];
    } else {
      tokens = [tokens[0], tokens[0]];
    }
  }

  var xFirst = tokens[1] !== "left" && tokens[1] !== "right" && tokens[0] !== "top" && tokens[0] !== "bottom";
  tokens = tokens.map(function (token) {
    return CSS_POSITIONS[token] || token;
  });

  if (!xFirst) {
    tokens.reverse();
  }

  var parsed = tokens.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);

  if (parsed) {
    return {
      x: parseFloat(parsed[1]) / 100,
      y: parseFloat(parsed[2]) / 100
    };
  } else {
    return {
      x: 0.5,
      y: 0.5
    };
  }
}

function _cleanCssPosition(value) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    allowCenter: true,
    cssOrder: true
  },
      allowCenter = _ref7.allowCenter,
      cssOrder = _ref7.cssOrder;

  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    value = value.split(" ");
  }

  if (value.length === 1) {
    if (value[0] === CENTER) {
      value = [CENTER, CENTER];
    } else if (X_VALUES.indexOf(value[0]) !== -1) {
      value = [CENTER, value[0]];
    } else if (Y_VALUES.indexOf(value[0]) !== -1) {
      value = [value[0], CENTER];
    }
  }

  if (value.length !== 2 || POS_VALUES.indexOf(value[0]) === -1 || POS_VALUES.indexOf(value[1]) === -1) {
    _logWarn("Unparsable position ".concat(value));

    return null;
  }

  if (!allowCenter && value[0] === CENTER && value[1] === CENTER) {
    _logWarn("Invalid position center center");

    return null;
  }

  if (cssOrder && !_cssPositionIsOrdered(value)) {
    value = [value[1], value[0]];
  }

  if (value[1] === CENTER && X_VALUES.indexOf(value[0]) !== -1) {
    value = [CENTER, value[0]];
  }

  if (value[0] === CENTER && Y_VALUES.indexOf(value[1]) !== -1) {
    value = [value[1], CENTER];
  }

  return value;
}

function _cssPositionIsOrdered(value) {
  return Y_VALUES.indexOf(value[0]) !== -1 && X_VALUES.indexOf(value[1]) !== -1;
}

function _parseSpeed(speed) {
  var parsed;

  if (typeof speed === "string") {
    var speedStr = speed.toString().trim();
    var speedValue = parseFloat(speedStr.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
    var speedUnit = speedStr.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();

    if (speedUnit.match(/(pm|per minute)$/)) {
      speedValue /= 60;
    }

    switch (speedUnit) {
      case "dpm":
      case "degrees per minute":
      case "dps":
      case "degrees per second":
        parsed = MathUtils.degToRad(speedValue);
        break;

      case "rdpm":
      case "radians per minute":
      case "rdps":
      case "radians per second":
        parsed = speedValue;
        break;

      case "rpm":
      case "revolutions per minute":
      case "rps":
      case "revolutions per second":
        parsed = speedValue * Math.PI * 2;
        break;

      default:
        throw new PSVError("Unknown speed unit \"".concat(speedUnit, "\""));
    }
  } else {
    parsed = speed;
  }

  return parsed;
}

function _parseAngle(angle) {
  var zeroCenter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var halfCircle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : zeroCenter;
  var parsed;

  if (typeof angle === "string") {
    var match = angle.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);

    if (!match) {
      throw new PSVError("Unknown angle \"".concat(angle, "\""));
    }

    var value = parseFloat(match[1]);
    var unit = match[2];

    if (unit) {
      switch (unit) {
        case "deg":
        case "degs":
          parsed = MathUtils.degToRad(value);
          break;

        case "rad":
        case "rads":
          parsed = value;
          break;

        default:
          throw new PSVError("Unknown angle unit \"".concat(unit, "\""));
      }
    } else {
      parsed = value;
    }
  } else if (typeof angle === "number" && !isNaN(angle)) {
    parsed = angle;
  } else {
    throw new PSVError("Unknown angle \"".concat(angle, "\""));
  }

  parsed = _wrap(zeroCenter ? parsed + Math.PI : parsed, Math.PI * 2);
  return zeroCenter ? MathUtils.clamp(parsed - Math.PI, -Math.PI / (halfCircle ? 2 : 1), Math.PI / (halfCircle ? 2 : 1)) : parsed;
}

function _createTexture(img) {
  var texture = new Texture(img);
  texture.needsUpdate = true;
  texture.minFilter = LinearFilter;
  texture.generateMipmaps = false;
  return texture;
}

var quaternion = new Quaternion();

function _applyEulerInverse(vector, euler) {
  quaternion.setFromEuler(euler).invert();
  vector.applyQuaternion(quaternion);
}

function _getConfigParser(defaults, parsers) {
  return function (userConfig) {
    if (!userConfig) {
      return _clone(defaults);
    }

    var rawConfig = _clone(_objectSpread(_objectSpread({}, defaults), userConfig));

    var config = {};

    for (var _i4 = 0, _Object$entries = Object.entries(rawConfig); _i4 < _Object$entries.length; _i4++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i4], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (parsers && key in parsers) {
        value = parsers[key](value, {
          rawConfig: rawConfig,
          defValue: defaults[key]
        });
      } else if (!(key in defaults)) {
        _logWarn("Unknown option ".concat(key));

        continue;
      }

      config[key] = value;
    }

    return config;
  };
} // src/utils/Animation.ts


var _Animation = /*#__PURE__*/function () {
  function _Animation(options) {
    var _this3 = this;

    _classCallCheck(this, _Animation);

    this.easing = _EASINGS["linear"];
    this.callbacks = [];
    this.resolved = false;
    this.cancelled = false;
    this.options = options;

    if (options) {
      if (options.easing) {
        this.easing = typeof options.easing === "function" ? options.easing : _EASINGS[options.easing] || _EASINGS["linear"];
      }

      if (options.delay) {
        this.delayTimeout = setTimeout(function () {
          _this3.delayTimeout = void 0;
          _this3.animationFrame = window.requestAnimationFrame(function (t) {
            return _this3.__run(t);
          });
        }, options.delay);
      } else {
        this.animationFrame = window.requestAnimationFrame(function (t) {
          return _this3.__run(t);
        });
      }
    } else {
      this.resolved = true;
    }
  }

  _createClass(_Animation, [{
    key: "__run",
    value: function __run(timestamp) {
      var _this4 = this;

      if (this.cancelled) {
        return;
      }

      if (!this.start) {
        this.start = timestamp;
      }

      var progress = (timestamp - this.start) / this.options.duration;
      var current = {};

      if (progress < 1) {
        for (var _i5 = 0, _Object$entries2 = Object.entries(this.options.properties); _i5 < _Object$entries2.length; _i5++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i5], 2),
              name = _Object$entries2$_i[0],
              prop = _Object$entries2$_i[1];

          if (prop) {
            var value = prop.start + (prop.end - prop.start) * this.easing(progress);
            current[name] = value;
          }
        }

        this.options.onTick(current, progress);
        this.animationFrame = window.requestAnimationFrame(function (t) {
          return _this4.__run(t);
        });
      } else {
        for (var _i6 = 0, _Object$entries3 = Object.entries(this.options.properties); _i6 < _Object$entries3.length; _i6++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i6], 2),
              _name = _Object$entries3$_i[0],
              _prop = _Object$entries3$_i[1];

          if (_prop) {
            current[_name] = _prop.end;
          }
        }

        this.options.onTick(current, 1);

        this.__resolve(true);

        this.animationFrame = void 0;
      }
    }
  }, {
    key: "__resolve",
    value: function __resolve(value) {
      if (value) {
        this.resolved = true;
      } else {
        this.cancelled = true;
      }

      this.callbacks.forEach(function (cb) {
        return cb(value);
      });
      this.callbacks.length = 0;
    }
  }, {
    key: "then",
    value: function then(onFulfilled) {
      var _this5 = this;

      if (this.resolved || this.cancelled) {
        return Promise.resolve(this.resolved).then(onFulfilled);
      }

      return new Promise(function (resolve) {
        _this5.callbacks.push(resolve);
      }).then(onFulfilled);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (!this.cancelled && !this.resolved) {
        this.__resolve(false);

        if (this.delayTimeout) {
          window.clearTimeout(this.delayTimeout);
          this.delayTimeout = void 0;
        }

        if (this.animationFrame) {
          window.cancelAnimationFrame(this.animationFrame);
          this.animationFrame = void 0;
        }
      }
    }
  }]);

  return _Animation;
}();

var _Dynamic = /*#__PURE__*/function () {
  function _Dynamic(fn, config) {
    _classCallCheck(this, _Dynamic);

    this.fn = fn;
    this.mode = 0
    /* STOP */
    ;
    this.speed = 0;
    this.speedMult = 0;
    this.currentSpeed = 0;
    this.target = 0;
    this.__current = 0;
    this.min = config.min;
    this.max = config.max;
    this.wrap = config.wrap;
    this.current = config.defaultValue;

    if (this.wrap && this.min !== 0) {
      throw new PSVError("invalid config");
    }

    if (this.fn) {
      this.fn(this.current);
    }
  }

  _createClass(_Dynamic, [{
    key: "current",
    get: function get() {
      return this.__current;
    },
    set: function set(current) {
      this.__current = current;
    }
  }, {
    key: "setSpeed",
    value: function setSpeed(speed) {
      this.speed = speed;
    }
  }, {
    key: "goto",
    value: function goto(position) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.mode = 2
      /* POSITION */
      ;
      this.target = this.wrap ? _wrap(position, this.max) : MathUtils.clamp(position, this.min, this.max);
      this.speedMult = speedMult;
    }
  }, {
    key: "step",
    value: function step(_step) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (this.mode !== 2
      /* POSITION */
      ) {
        this.target = this.current;
      }

      this["goto"](this.target + _step, speedMult);
    }
  }, {
    key: "roll",
    value: function roll() {
      var invert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.mode = 1
      /* INFINITE */
      ;
      this.target = invert ? -Infinity : Infinity;
      this.speedMult = speedMult;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.mode = 0
      /* STOP */
      ;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.target = this.wrap ? _wrap(value, this.max) : MathUtils.clamp(value, this.min, this.max);
      this.mode = 0
      /* STOP */
      ;
      this.currentSpeed = 0;

      if (this.target !== this.current) {
        this.current = this.target;

        if (this.fn) {
          this.fn(this.current);
        }

        return true;
      }

      return false;
    }
  }, {
    key: "update",
    value: function update(elapsed) {
      if (this.mode === 2
      /* POSITION */
      ) {
        if (this.wrap && Math.abs(this.target - this.current) > this.max / 2) {
          this.current = this.current < this.target ? this.current + this.max : this.current - this.max;
        }

        var dstStop = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);

        if (Math.abs(this.target - this.current) <= dstStop) {
          this.mode = 0
          /* STOP */
          ;
        }
      }

      var targetSpeed = this.mode === 0
      /* STOP */
      ? 0 : this.speed * this.speedMult;

      if (this.target < this.current) {
        targetSpeed = -targetSpeed;
      }

      if (this.currentSpeed < targetSpeed) {
        this.currentSpeed = Math.min(targetSpeed, this.currentSpeed + elapsed / 1e3 * this.speed * this.speedMult * 2);
      } else if (this.currentSpeed > targetSpeed) {
        this.currentSpeed = Math.max(targetSpeed, this.currentSpeed - elapsed / 1e3 * this.speed * this.speedMult * 2);
      }

      var next = null;

      if (this.current > this.target && this.currentSpeed) {
        next = Math.max(this.target, this.current + this.currentSpeed * elapsed / 1e3);
      } else if (this.current < this.target && this.currentSpeed) {
        next = Math.min(this.target, this.current + this.currentSpeed * elapsed / 1e3);
      }

      if (next !== null) {
        next = this.wrap ? _wrap(next, this.max) : MathUtils.clamp(next, this.min, this.max);

        if (next !== this.current) {
          this.current = next;

          if (this.fn) {
            this.fn(this.current);
          }

          return true;
        }
      }

      return false;
    }
  }]);

  return _Dynamic;
}(); // src/utils/MultiDynamic.ts


var _MultiDynamic = /*#__PURE__*/function () {
  function _MultiDynamic(fn, dynamics) {
    _classCallCheck(this, _MultiDynamic);

    this.fn = fn;
    this.dynamics = dynamics;

    if (this.fn) {
      this.fn(this.current);
    }
  }

  _createClass(_MultiDynamic, [{
    key: "current",
    get: function get() {
      return Object.entries(this.dynamics).reduce(function (values, _ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            name = _ref9[0],
            dynamic = _ref9[1];

        values[name] = dynamic.current;
        return values;
      }, {});
    }
  }, {
    key: "setSpeed",
    value: function setSpeed(speed) {
      for (var _i7 = 0, _Object$values = Object.values(this.dynamics); _i7 < _Object$values.length; _i7++) {
        var d = _Object$values[_i7];
        d.setSpeed(speed);
      }
    }
  }, {
    key: "goto",
    value: function goto(positions) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      for (var _i8 = 0, _Object$entries4 = Object.entries(positions); _i8 < _Object$entries4.length; _i8++) {
        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i8], 2),
            name = _Object$entries4$_i[0],
            position = _Object$entries4$_i[1];

        this.dynamics[name]["goto"](position, speedMult);
      }
    }
  }, {
    key: "step",
    value: function step(steps) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      for (var _i9 = 0, _Object$entries5 = Object.entries(steps); _i9 < _Object$entries5.length; _i9++) {
        var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i9], 2),
            name = _Object$entries5$_i[0],
            step = _Object$entries5$_i[1];

        this.dynamics[name].step(step, speedMult);
      }
    }
  }, {
    key: "roll",
    value: function roll(rolls) {
      var speedMult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      for (var _i10 = 0, _Object$entries6 = Object.entries(rolls); _i10 < _Object$entries6.length; _i10++) {
        var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i10], 2),
            name = _Object$entries6$_i[0],
            roll = _Object$entries6$_i[1];

        this.dynamics[name].roll(roll, speedMult);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      for (var _i11 = 0, _Object$values2 = Object.values(this.dynamics); _i11 < _Object$values2.length; _i11++) {
        var d = _Object$values2[_i11];
        d.stop();
      }
    }
  }, {
    key: "setValue",
    value: function setValue(values) {
      var hasUpdates = false;

      for (var _i12 = 0, _Object$entries7 = Object.entries(values); _i12 < _Object$entries7.length; _i12++) {
        var _Object$entries7$_i = _slicedToArray(_Object$entries7[_i12], 2),
            name = _Object$entries7$_i[0],
            value = _Object$entries7$_i[1];

        hasUpdates = this.dynamics[name].setValue(value) || hasUpdates;
      }

      if (hasUpdates && this.fn) {
        this.fn(this.current);
      }

      return hasUpdates;
    }
  }, {
    key: "update",
    value: function update(elapsed) {
      var hasUpdates = false;

      for (var _i13 = 0, _Object$values3 = Object.values(this.dynamics); _i13 < _Object$values3.length; _i13++) {
        var d = _Object$values3[_i13];
        hasUpdates = d.update(elapsed) || hasUpdates;
      }

      if (hasUpdates && this.fn) {
        this.fn(this.current);
      }

      return hasUpdates;
    }
  }]);

  return _MultiDynamic;
}(); // src/utils/Slider.ts


var _SliderDirection = /* @__PURE__ */function (SliderDirection2) {
  SliderDirection2["VERTICAL"] = "VERTICAL";
  SliderDirection2["HORIZONTAL"] = "HORIZONTAL";
  return SliderDirection2;
}(_SliderDirection || {});

var _Slider = /*#__PURE__*/function () {
  function _Slider(container, direction, listener) {
    _classCallCheck(this, _Slider);

    this.container = container;
    this.direction = direction;
    this.listener = listener;
    this.mousedown = false;
    this.mouseover = false;
    this.container.addEventListener("click", this);
    this.container.addEventListener("mousedown", this);
    this.container.addEventListener("mouseenter", this);
    this.container.addEventListener("mouseleave", this);
    this.container.addEventListener("touchstart", this);
    this.container.addEventListener("mousemove", this, true);
    this.container.addEventListener("touchmove", this, true);
    window.addEventListener("mouseup", this);
    window.addEventListener("touchend", this);
  }

  _createClass(_Slider, [{
    key: "isVertical",
    get: function get() {
      return this.direction === "VERTICAL"
      /* VERTICAL */
      ;
    }
  }, {
    key: "isHorizontal",
    get: function get() {
      return this.direction === "HORIZONTAL"
      /* HORIZONTAL */
      ;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("mouseup", this);
      window.removeEventListener("touchend", this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "click":
          e.stopPropagation();
          break;

        case "mousedown":
          this.__onMouseDown(e);

          break;

        case "mouseenter":
          this.__onMouseEnter(e);

          break;

        case "mouseleave":
          this.__onMouseLeave(e);

          break;

        case "touchstart":
          this.__onTouchStart(e);

          break;

        case "mousemove":
          this.__onMouseMove(e);

          break;

        case "touchmove":
          this.__onTouchMove(e);

          break;

        case "mouseup":
          this.__onMouseUp(e);

          break;

        case "touchend":
          this.__onTouchEnd(e);

          break;
      }
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown(evt) {
      this.mousedown = true;

      this.__update(evt.clientX, evt.clientY, true);
    }
  }, {
    key: "__onMouseEnter",
    value: function __onMouseEnter(evt) {
      this.mouseover = true;

      this.__update(evt.clientX, evt.clientY, true);
    }
  }, {
    key: "__onTouchStart",
    value: function __onTouchStart(evt) {
      this.mouseover = true;
      this.mousedown = true;
      var touch = evt.changedTouches[0];

      this.__update(touch.clientX, touch.clientY, true);
    }
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(evt) {
      if (this.mousedown || this.mouseover) {
        evt.stopPropagation();

        this.__update(evt.clientX, evt.clientY, true);
      }
    }
  }, {
    key: "__onTouchMove",
    value: function __onTouchMove(evt) {
      if (this.mousedown || this.mouseover) {
        evt.stopPropagation();
        var touch = evt.changedTouches[0];

        this.__update(touch.clientX, touch.clientY, true);
      }
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp(evt) {
      if (this.mousedown) {
        this.mousedown = false;

        this.__update(evt.clientX, evt.clientY, false);
      }
    }
  }, {
    key: "__onMouseLeave",
    value: function __onMouseLeave(evt) {
      if (this.mouseover) {
        this.mouseover = false;

        this.__update(evt.clientX, evt.clientY, true);
      }
    }
  }, {
    key: "__onTouchEnd",
    value: function __onTouchEnd(evt) {
      if (this.mousedown) {
        this.mouseover = false;
        this.mousedown = false;
        var touch = evt.changedTouches[0];

        this.__update(touch.clientX, touch.clientY, false);
      }
    }
  }, {
    key: "__update",
    value: function __update(clientX, clientY, moving) {
      var boundingClientRect = this.container.getBoundingClientRect();
      var cursor = this.isVertical ? clientY : clientX;
      var pos = boundingClientRect[this.isVertical ? "bottom" : "left"];
      var size = boundingClientRect[this.isVertical ? "height" : "width"];
      var val = Math.abs((pos - cursor) / size);
      this.listener({
        value: val,
        click: !moving,
        mousedown: this.mousedown,
        mouseover: this.mouseover,
        cursor: {
          clientX: clientX,
          clientY: clientY
        }
      });
    }
  }]);

  return _Slider;
}(); // src/events.ts


var events_exports = {};

__export(events_exports, {
  BeforeAnimateEvent: function BeforeAnimateEvent() {
    return _BeforeAnimateEvent2;
  },
  BeforeRenderEvent: function BeforeRenderEvent() {
    return _BeforeRenderEvent2;
  },
  BeforeRotateEvent: function BeforeRotateEvent() {
    return _BeforeRotateEvent2;
  },
  ClickEvent: function ClickEvent() {
    return _ClickEvent2;
  },
  ConfigChangedEvent: function ConfigChangedEvent() {
    return _ConfigChangedEvent2;
  },
  DoubleClickEvent: function DoubleClickEvent() {
    return _DoubleClickEvent2;
  },
  FullscreenEvent: function FullscreenEvent() {
    return _FullscreenEvent2;
  },
  HideNotificationEvent: function HideNotificationEvent() {
    return _HideNotificationEvent2;
  },
  HideOverlayEvent: function HideOverlayEvent() {
    return _HideOverlayEvent2;
  },
  HidePanelEvent: function HidePanelEvent() {
    return _HidePanelEvent2;
  },
  HideTooltipEvent: function HideTooltipEvent() {
    return _HideTooltipEvent2;
  },
  KeypressEvent: function KeypressEvent() {
    return _KeypressEvent2;
  },
  LoadProgressEvent: function LoadProgressEvent() {
    return _LoadProgressEvent2;
  },
  ObjectEnterEvent: function ObjectEnterEvent() {
    return _ObjectEnterEvent2;
  },
  ObjectEvent: function ObjectEvent() {
    return _ObjectEvent;
  },
  ObjectHoverEvent: function ObjectHoverEvent() {
    return _ObjectHoverEvent2;
  },
  ObjectLeaveEvent: function ObjectLeaveEvent() {
    return _ObjectLeaveEvent2;
  },
  PanoramaLoadedEvent: function PanoramaLoadedEvent() {
    return _PanoramaLoadedEvent2;
  },
  PositionUpdatedEvent: function PositionUpdatedEvent() {
    return _PositionUpdatedEvent2;
  },
  ReadyEvent: function ReadyEvent() {
    return _ReadyEvent2;
  },
  RenderEvent: function RenderEvent() {
    return _RenderEvent2;
  },
  ShowNotificationEvent: function ShowNotificationEvent() {
    return _ShowNotificationEvent2;
  },
  ShowOverlayEvent: function ShowOverlayEvent() {
    return _ShowOverlayEvent2;
  },
  ShowPanelEvent: function ShowPanelEvent() {
    return _ShowPanelEvent2;
  },
  ShowTooltipEvent: function ShowTooltipEvent() {
    return _ShowTooltipEvent2;
  },
  SizeUpdatedEvent: function SizeUpdatedEvent() {
    return _SizeUpdatedEvent2;
  },
  StopAllEvent: function StopAllEvent() {
    return _StopAllEvent2;
  },
  ViewerEvent: function ViewerEvent() {
    return _ViewerEvent;
  },
  ZoomUpdatedEvent: function ZoomUpdatedEvent() {
    return _ZoomUpdatedEvent2;
  }
}); // src/lib/TypedEventTarget.ts


var TypedEvent = /*#__PURE__*/function (_Event) {
  _inherits(TypedEvent, _Event);

  var _super2 = _createSuper(TypedEvent);

  function TypedEvent(type) {
    var cancelable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, TypedEvent);

    return _super2.call(this, type, {
      cancelable: cancelable
    });
  }

  _createClass(TypedEvent, [{
    key: "target",
    get: function get() {
      return _get(_getPrototypeOf(TypedEvent.prototype), "target", this);
    }
  }]);

  return TypedEvent;
}( /*#__PURE__*/_wrapNativeSuper(Event));

var TypedEventTarget = /*#__PURE__*/function (_EventTarget) {
  _inherits(TypedEventTarget, _EventTarget);

  var _super3 = _createSuper(TypedEventTarget);

  function TypedEventTarget() {
    _classCallCheck(this, TypedEventTarget);

    return _super3.apply(this, arguments);
  }

  _createClass(TypedEventTarget, [{
    key: "dispatchEvent",
    value: function dispatchEvent(e) {
      return _get(_getPrototypeOf(TypedEventTarget.prototype), "dispatchEvent", this).call(this, e);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, callback, options) {
      _get(_getPrototypeOf(TypedEventTarget.prototype), "addEventListener", this).call(this, type, callback, options);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback, options) {
      _get(_getPrototypeOf(TypedEventTarget.prototype), "removeEventListener", this).call(this, type, callback, options);
    }
  }]);

  return TypedEventTarget;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget)); // src/events.ts


var _ViewerEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_ViewerEvent, _TypedEvent);

  var _super4 = _createSuper(_ViewerEvent);

  function _ViewerEvent() {
    _classCallCheck(this, _ViewerEvent);

    return _super4.apply(this, arguments);
  }

  return _createClass(_ViewerEvent);
}(TypedEvent);

var _BeforeAnimateEvent = /*#__PURE__*/function (_ViewerEvent2) {
  _inherits(_BeforeAnimateEvent, _ViewerEvent2);

  var _super5 = _createSuper(_BeforeAnimateEvent);

  function _BeforeAnimateEvent(position, zoomLevel) {
    var _this6;

    _classCallCheck(this, _BeforeAnimateEvent);

    _this6 = _super5.call(this, _BeforeAnimateEvent.type, true);
    _this6.position = position;
    _this6.zoomLevel = zoomLevel;
    return _this6;
  }

  return _createClass(_BeforeAnimateEvent);
}(_ViewerEvent);

var _BeforeAnimateEvent2 = _BeforeAnimateEvent;
_BeforeAnimateEvent2.type = "before-animate";

var _BeforeRenderEvent = /*#__PURE__*/function (_ViewerEvent3) {
  _inherits(_BeforeRenderEvent, _ViewerEvent3);

  var _super6 = _createSuper(_BeforeRenderEvent);

  function _BeforeRenderEvent(timestamp, elapsed) {
    var _this7;

    _classCallCheck(this, _BeforeRenderEvent);

    _this7 = _super6.call(this, _BeforeRenderEvent.type);
    _this7.timestamp = timestamp;
    _this7.elapsed = elapsed;
    return _this7;
  }

  return _createClass(_BeforeRenderEvent);
}(_ViewerEvent);

var _BeforeRenderEvent2 = _BeforeRenderEvent;
_BeforeRenderEvent2.type = "before-render";

var _BeforeRotateEvent = /*#__PURE__*/function (_ViewerEvent4) {
  _inherits(_BeforeRotateEvent, _ViewerEvent4);

  var _super7 = _createSuper(_BeforeRotateEvent);

  function _BeforeRotateEvent(position) {
    var _this8;

    _classCallCheck(this, _BeforeRotateEvent);

    _this8 = _super7.call(this, _BeforeRotateEvent.type, true);
    _this8.position = position;
    return _this8;
  }

  return _createClass(_BeforeRotateEvent);
}(_ViewerEvent);

var _BeforeRotateEvent2 = _BeforeRotateEvent;
_BeforeRotateEvent2.type = "before-rotate";

var _ClickEvent = /*#__PURE__*/function (_ViewerEvent5) {
  _inherits(_ClickEvent, _ViewerEvent5);

  var _super8 = _createSuper(_ClickEvent);

  function _ClickEvent(data) {
    var _this9;

    _classCallCheck(this, _ClickEvent);

    _this9 = _super8.call(this, _ClickEvent.type);
    _this9.data = data;
    return _this9;
  }

  return _createClass(_ClickEvent);
}(_ViewerEvent);

var _ClickEvent2 = _ClickEvent;
_ClickEvent2.type = "click";

var _ConfigChangedEvent = /*#__PURE__*/function (_ViewerEvent6) {
  _inherits(_ConfigChangedEvent, _ViewerEvent6);

  var _super9 = _createSuper(_ConfigChangedEvent);

  function _ConfigChangedEvent(options) {
    var _this10;

    _classCallCheck(this, _ConfigChangedEvent);

    _this10 = _super9.call(this, _ConfigChangedEvent.type);
    _this10.options = options;
    return _this10;
  }

  _createClass(_ConfigChangedEvent, [{
    key: "containsOptions",
    value: function containsOptions() {
      var _this11 = this;

      for (var _len3 = arguments.length, options = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        options[_key3] = arguments[_key3];
      }

      return options.some(function (option) {
        return _this11.options.includes(option);
      });
    }
  }]);

  return _ConfigChangedEvent;
}(_ViewerEvent);

var _ConfigChangedEvent2 = _ConfigChangedEvent;
_ConfigChangedEvent2.type = "config-changed";

var _DoubleClickEvent = /*#__PURE__*/function (_ViewerEvent7) {
  _inherits(_DoubleClickEvent, _ViewerEvent7);

  var _super10 = _createSuper(_DoubleClickEvent);

  function _DoubleClickEvent(data) {
    var _this12;

    _classCallCheck(this, _DoubleClickEvent);

    _this12 = _super10.call(this, _DoubleClickEvent.type);
    _this12.data = data;
    return _this12;
  }

  return _createClass(_DoubleClickEvent);
}(_ViewerEvent);

var _DoubleClickEvent2 = _DoubleClickEvent;
_DoubleClickEvent2.type = "dblclick";

var _FullscreenEvent = /*#__PURE__*/function (_ViewerEvent8) {
  _inherits(_FullscreenEvent, _ViewerEvent8);

  var _super11 = _createSuper(_FullscreenEvent);

  function _FullscreenEvent(fullscreenEnabled) {
    var _this13;

    _classCallCheck(this, _FullscreenEvent);

    _this13 = _super11.call(this, _FullscreenEvent.type);
    _this13.fullscreenEnabled = fullscreenEnabled;
    return _this13;
  }

  return _createClass(_FullscreenEvent);
}(_ViewerEvent);

var _FullscreenEvent2 = _FullscreenEvent;
_FullscreenEvent2.type = "fullscreen";

var _HideNotificationEvent = /*#__PURE__*/function (_ViewerEvent9) {
  _inherits(_HideNotificationEvent, _ViewerEvent9);

  var _super12 = _createSuper(_HideNotificationEvent);

  function _HideNotificationEvent(notificationId) {
    var _this14;

    _classCallCheck(this, _HideNotificationEvent);

    _this14 = _super12.call(this, _HideNotificationEvent.type);
    _this14.notificationId = notificationId;
    return _this14;
  }

  return _createClass(_HideNotificationEvent);
}(_ViewerEvent);

var _HideNotificationEvent2 = _HideNotificationEvent;
_HideNotificationEvent2.type = "hide-notification";

var _HideOverlayEvent = /*#__PURE__*/function (_ViewerEvent10) {
  _inherits(_HideOverlayEvent, _ViewerEvent10);

  var _super13 = _createSuper(_HideOverlayEvent);

  function _HideOverlayEvent(overlayId) {
    var _this15;

    _classCallCheck(this, _HideOverlayEvent);

    _this15 = _super13.call(this, _HideOverlayEvent.type);
    _this15.overlayId = overlayId;
    return _this15;
  }

  return _createClass(_HideOverlayEvent);
}(_ViewerEvent);

var _HideOverlayEvent2 = _HideOverlayEvent;
_HideOverlayEvent2.type = "hide-overlay";

var _HidePanelEvent = /*#__PURE__*/function (_ViewerEvent11) {
  _inherits(_HidePanelEvent, _ViewerEvent11);

  var _super14 = _createSuper(_HidePanelEvent);

  function _HidePanelEvent(panelId) {
    var _this16;

    _classCallCheck(this, _HidePanelEvent);

    _this16 = _super14.call(this, _HidePanelEvent.type);
    _this16.panelId = panelId;
    return _this16;
  }

  return _createClass(_HidePanelEvent);
}(_ViewerEvent);

var _HidePanelEvent2 = _HidePanelEvent;
_HidePanelEvent2.type = "hide-panel";

var _HideTooltipEvent = /*#__PURE__*/function (_ViewerEvent12) {
  _inherits(_HideTooltipEvent, _ViewerEvent12);

  var _super15 = _createSuper(_HideTooltipEvent);

  function _HideTooltipEvent(tooltipData) {
    var _this17;

    _classCallCheck(this, _HideTooltipEvent);

    _this17 = _super15.call(this, _HideTooltipEvent.type);
    _this17.tooltipData = tooltipData;
    return _this17;
  }

  return _createClass(_HideTooltipEvent);
}(_ViewerEvent);

var _HideTooltipEvent2 = _HideTooltipEvent;
_HideTooltipEvent2.type = "hide-tooltip";

var _KeypressEvent = /*#__PURE__*/function (_ViewerEvent13) {
  _inherits(_KeypressEvent, _ViewerEvent13);

  var _super16 = _createSuper(_KeypressEvent);

  function _KeypressEvent(key) {
    var _this18;

    _classCallCheck(this, _KeypressEvent);

    _this18 = _super16.call(this, _KeypressEvent.type, true);
    _this18.key = key;
    return _this18;
  }

  return _createClass(_KeypressEvent);
}(_ViewerEvent);

var _KeypressEvent2 = _KeypressEvent;
_KeypressEvent2.type = "key-press";

var _LoadProgressEvent = /*#__PURE__*/function (_ViewerEvent14) {
  _inherits(_LoadProgressEvent, _ViewerEvent14);

  var _super17 = _createSuper(_LoadProgressEvent);

  function _LoadProgressEvent(progress) {
    var _this19;

    _classCallCheck(this, _LoadProgressEvent);

    _this19 = _super17.call(this, _LoadProgressEvent.type);
    _this19.progress = progress;
    return _this19;
  }

  return _createClass(_LoadProgressEvent);
}(_ViewerEvent);

var _LoadProgressEvent2 = _LoadProgressEvent;
_LoadProgressEvent2.type = "load-progress";

var _PanoramaLoadedEvent = /*#__PURE__*/function (_ViewerEvent15) {
  _inherits(_PanoramaLoadedEvent, _ViewerEvent15);

  var _super18 = _createSuper(_PanoramaLoadedEvent);

  function _PanoramaLoadedEvent(data) {
    var _this20;

    _classCallCheck(this, _PanoramaLoadedEvent);

    _this20 = _super18.call(this, _PanoramaLoadedEvent.type);
    _this20.data = data;
    return _this20;
  }

  return _createClass(_PanoramaLoadedEvent);
}(_ViewerEvent);

var _PanoramaLoadedEvent2 = _PanoramaLoadedEvent;
_PanoramaLoadedEvent2.type = "panorama-loaded";

var _PositionUpdatedEvent = /*#__PURE__*/function (_ViewerEvent16) {
  _inherits(_PositionUpdatedEvent, _ViewerEvent16);

  var _super19 = _createSuper(_PositionUpdatedEvent);

  function _PositionUpdatedEvent(position) {
    var _this21;

    _classCallCheck(this, _PositionUpdatedEvent);

    _this21 = _super19.call(this, _PositionUpdatedEvent.type);
    _this21.position = position;
    return _this21;
  }

  return _createClass(_PositionUpdatedEvent);
}(_ViewerEvent);

var _PositionUpdatedEvent2 = _PositionUpdatedEvent;
_PositionUpdatedEvent2.type = "position-updated";

var _ReadyEvent = /*#__PURE__*/function (_ViewerEvent17) {
  _inherits(_ReadyEvent, _ViewerEvent17);

  var _super20 = _createSuper(_ReadyEvent);

  function _ReadyEvent() {
    _classCallCheck(this, _ReadyEvent);

    return _super20.call(this, _ReadyEvent.type);
  }

  return _createClass(_ReadyEvent);
}(_ViewerEvent);

var _ReadyEvent2 = _ReadyEvent;
_ReadyEvent2.type = "ready";

var _RenderEvent = /*#__PURE__*/function (_ViewerEvent18) {
  _inherits(_RenderEvent, _ViewerEvent18);

  var _super21 = _createSuper(_RenderEvent);

  function _RenderEvent() {
    _classCallCheck(this, _RenderEvent);

    return _super21.call(this, _RenderEvent.type);
  }

  return _createClass(_RenderEvent);
}(_ViewerEvent);

var _RenderEvent2 = _RenderEvent;
_RenderEvent2.type = "render";

var _ShowNotificationEvent = /*#__PURE__*/function (_ViewerEvent19) {
  _inherits(_ShowNotificationEvent, _ViewerEvent19);

  var _super22 = _createSuper(_ShowNotificationEvent);

  function _ShowNotificationEvent(notificationId) {
    var _this22;

    _classCallCheck(this, _ShowNotificationEvent);

    _this22 = _super22.call(this, _ShowNotificationEvent.type);
    _this22.notificationId = notificationId;
    return _this22;
  }

  return _createClass(_ShowNotificationEvent);
}(_ViewerEvent);

var _ShowNotificationEvent2 = _ShowNotificationEvent;
_ShowNotificationEvent2.type = "show-notification";

var _ShowOverlayEvent = /*#__PURE__*/function (_ViewerEvent20) {
  _inherits(_ShowOverlayEvent, _ViewerEvent20);

  var _super23 = _createSuper(_ShowOverlayEvent);

  function _ShowOverlayEvent(overlayId) {
    var _this23;

    _classCallCheck(this, _ShowOverlayEvent);

    _this23 = _super23.call(this, _ShowOverlayEvent.type);
    _this23.overlayId = overlayId;
    return _this23;
  }

  return _createClass(_ShowOverlayEvent);
}(_ViewerEvent);

var _ShowOverlayEvent2 = _ShowOverlayEvent;
_ShowOverlayEvent2.type = "show-overlay";

var _ShowPanelEvent = /*#__PURE__*/function (_ViewerEvent21) {
  _inherits(_ShowPanelEvent, _ViewerEvent21);

  var _super24 = _createSuper(_ShowPanelEvent);

  function _ShowPanelEvent(panelId) {
    var _this24;

    _classCallCheck(this, _ShowPanelEvent);

    _this24 = _super24.call(this, _ShowPanelEvent.type);
    _this24.panelId = panelId;
    return _this24;
  }

  return _createClass(_ShowPanelEvent);
}(_ViewerEvent);

var _ShowPanelEvent2 = _ShowPanelEvent;
_ShowPanelEvent2.type = "show-panel";

var _ShowTooltipEvent = /*#__PURE__*/function (_ViewerEvent22) {
  _inherits(_ShowTooltipEvent, _ViewerEvent22);

  var _super25 = _createSuper(_ShowTooltipEvent);

  function _ShowTooltipEvent(tooltip, tooltipData) {
    var _this25;

    _classCallCheck(this, _ShowTooltipEvent);

    _this25 = _super25.call(this, _ShowTooltipEvent.type);
    _this25.tooltip = tooltip;
    _this25.tooltipData = tooltipData;
    return _this25;
  }

  return _createClass(_ShowTooltipEvent);
}(_ViewerEvent);

var _ShowTooltipEvent2 = _ShowTooltipEvent;
_ShowTooltipEvent2.type = "show-tooltip";

var _SizeUpdatedEvent = /*#__PURE__*/function (_ViewerEvent23) {
  _inherits(_SizeUpdatedEvent, _ViewerEvent23);

  var _super26 = _createSuper(_SizeUpdatedEvent);

  function _SizeUpdatedEvent(size) {
    var _this26;

    _classCallCheck(this, _SizeUpdatedEvent);

    _this26 = _super26.call(this, _SizeUpdatedEvent.type);
    _this26.size = size;
    return _this26;
  }

  return _createClass(_SizeUpdatedEvent);
}(_ViewerEvent);

var _SizeUpdatedEvent2 = _SizeUpdatedEvent;
_SizeUpdatedEvent2.type = "size-updated";

var _StopAllEvent = /*#__PURE__*/function (_ViewerEvent24) {
  _inherits(_StopAllEvent, _ViewerEvent24);

  var _super27 = _createSuper(_StopAllEvent);

  function _StopAllEvent() {
    _classCallCheck(this, _StopAllEvent);

    return _super27.call(this, _StopAllEvent.type);
  }

  return _createClass(_StopAllEvent);
}(_ViewerEvent);

var _StopAllEvent2 = _StopAllEvent;
_StopAllEvent2.type = "stop-all";

var _ZoomUpdatedEvent = /*#__PURE__*/function (_ViewerEvent25) {
  _inherits(_ZoomUpdatedEvent, _ViewerEvent25);

  var _super28 = _createSuper(_ZoomUpdatedEvent);

  function _ZoomUpdatedEvent(zoomLevel) {
    var _this27;

    _classCallCheck(this, _ZoomUpdatedEvent);

    _this27 = _super28.call(this, _ZoomUpdatedEvent.type);
    _this27.zoomLevel = zoomLevel;
    return _this27;
  }

  return _createClass(_ZoomUpdatedEvent);
}(_ViewerEvent);

var _ZoomUpdatedEvent2 = _ZoomUpdatedEvent;
_ZoomUpdatedEvent2.type = "zoom-updated";

var _ObjectEvent = /*#__PURE__*/function (_ViewerEvent26) {
  _inherits(_ObjectEvent, _ViewerEvent26);

  var _super29 = _createSuper(_ObjectEvent);

  function _ObjectEvent(type, originalEvent, object, viewerPoint, userDataKey) {
    var _this28;

    _classCallCheck(this, _ObjectEvent);

    _this28 = _super29.call(this, type);
    _this28.originalEvent = originalEvent;
    _this28.object = object;
    _this28.viewerPoint = viewerPoint;
    _this28.userDataKey = userDataKey;
    return _this28;
  }

  return _createClass(_ObjectEvent);
}(_ViewerEvent);

var _ObjectEnterEvent = /*#__PURE__*/function (_ObjectEvent2) {
  _inherits(_ObjectEnterEvent, _ObjectEvent2);

  var _super30 = _createSuper(_ObjectEnterEvent);

  function _ObjectEnterEvent(originalEvent, object, viewerPoint, userDataKey) {
    _classCallCheck(this, _ObjectEnterEvent);

    return _super30.call(this, _ObjectEnterEvent.type, originalEvent, object, viewerPoint, userDataKey);
  }

  return _createClass(_ObjectEnterEvent);
}(_ObjectEvent);

var _ObjectEnterEvent2 = _ObjectEnterEvent;
_ObjectEnterEvent2.type = "enter-object";

var _ObjectLeaveEvent = /*#__PURE__*/function (_ObjectEvent3) {
  _inherits(_ObjectLeaveEvent, _ObjectEvent3);

  var _super31 = _createSuper(_ObjectLeaveEvent);

  function _ObjectLeaveEvent(originalEvent, object, viewerPoint, userDataKey) {
    _classCallCheck(this, _ObjectLeaveEvent);

    return _super31.call(this, _ObjectLeaveEvent.type, originalEvent, object, viewerPoint, userDataKey);
  }

  return _createClass(_ObjectLeaveEvent);
}(_ObjectEvent);

var _ObjectLeaveEvent2 = _ObjectLeaveEvent;
_ObjectLeaveEvent2.type = "leave-object";

var _ObjectHoverEvent = /*#__PURE__*/function (_ObjectEvent4) {
  _inherits(_ObjectHoverEvent, _ObjectEvent4);

  var _super32 = _createSuper(_ObjectHoverEvent);

  function _ObjectHoverEvent(originalEvent, object, viewerPoint, userDataKey) {
    _classCallCheck(this, _ObjectHoverEvent);

    return _super32.call(this, _ObjectHoverEvent.type, originalEvent, object, viewerPoint, userDataKey);
  }

  return _createClass(_ObjectHoverEvent);
}(_ObjectEvent);

var _ObjectHoverEvent2 = _ObjectHoverEvent;
_ObjectHoverEvent2.type = "hover-object";

var _AbstractAdapter = /*#__PURE__*/function () {
  function _AbstractAdapter(viewer) {
    _classCallCheck(this, _AbstractAdapter);

    this.viewer = viewer;
  }

  _createClass(_AbstractAdapter, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "supportsTransition",
    value: function supportsTransition(panorama) {
      return false;
    }
  }, {
    key: "supportsPreload",
    value: function supportsPreload(panorama) {
      return false;
    }
  }], [{
    key: "createOverlayMaterial",
    value: function createOverlayMaterial() {
      var _objectSpread2;

      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          additionalUniforms = _ref10.additionalUniforms,
          overrideVertexShader = _ref10.overrideVertexShader;

      return new ShaderMaterial({
        uniforms: _objectSpread(_objectSpread({}, additionalUniforms), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, _AbstractAdapter.OVERLAY_UNIFORMS.panorama, {
          value: new Texture()
        }), _defineProperty(_objectSpread2, _AbstractAdapter.OVERLAY_UNIFORMS.overlay, {
          value: new Texture()
        }), _defineProperty(_objectSpread2, _AbstractAdapter.OVERLAY_UNIFORMS.globalOpacity, {
          value: 1
        }), _defineProperty(_objectSpread2, _AbstractAdapter.OVERLAY_UNIFORMS.overlayOpacity, {
          value: 1
        }), _objectSpread2)),
        vertexShader: overrideVertexShader || "\nvarying vec2 vUv;\n\nvoid main() {\n  vUv = uv;\n  gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}",
        fragmentShader: "\nuniform sampler2D ".concat(_AbstractAdapter.OVERLAY_UNIFORMS.panorama, ";\nuniform sampler2D ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.overlay, ";\nuniform float ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.globalOpacity, ";\nuniform float ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.overlayOpacity, ";\n\nvarying vec2 vUv;\n\nvoid main() {\n  vec4 tColor1 = texture2D( ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.panorama, ", vUv );\n  vec4 tColor2 = texture2D( ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.overlay, ", vUv );\n  gl_FragColor = vec4(\n    mix( tColor1.rgb, tColor2.rgb, tColor2.a * ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.overlayOpacity, " ),\n    ").concat(_AbstractAdapter.OVERLAY_UNIFORMS.globalOpacity, "\n  );\n}")
      });
    }
  }]);

  return _AbstractAdapter;
}();

var AbstractAdapter = _AbstractAdapter;
AbstractAdapter.supportsDownload = false;
AbstractAdapter.supportsOverlay = false;
AbstractAdapter.OVERLAY_UNIFORMS = {
  panorama: "panorama",
  overlay: "overlay",
  globalOpacity: "globalOpacity",
  overlayOpacity: "overlayOpacity"
};

function adapterInterop(adapter) {
  if (adapter) {
    for (var _i14 = 0, _arr2 = [["_", adapter]].concat(_toConsumableArray(Object.entries(adapter))); _i14 < _arr2.length; _i14++) {
      var _arr2$_i = _slicedToArray(_arr2[_i14], 2),
          p = _arr2$_i[1];

      if (p.prototype instanceof AbstractAdapter) {
        return p;
      }
    }
  }

  return null;
} // src/data/system.ts


var LOCALSTORAGE_TOUCH_SUPPORT = "".concat(_VIEWER_DATA, "_touchSupport");
var SYSTEM = {
  loaded: false,
  pixelRatio: 1,
  isWebGLSupported: false,
  maxTextureWidth: 0,
  isTouchEnabled: null,
  __maxCanvasWidth: null,

  get maxCanvasWidth() {
    if (this.__maxCanvasWidth === null) {
      this.__maxCanvasWidth = getMaxCanvasWidth(this.maxTextureWidth);
    }

    return this.__maxCanvasWidth;
  },

  load: function load() {
    if (!this.loaded) {
      var ctx = getWebGLCtx();
      this.pixelRatio = window.devicePixelRatio || 1;
      this.isWebGLSupported = ctx !== null;
      this.maxTextureWidth = ctx ? ctx.getParameter(ctx.MAX_TEXTURE_SIZE) : 0;
      this.isTouchEnabled = isTouchEnabled();
      this.loaded = true;
    }

    if (!SYSTEM.isWebGLSupported) {
      throw new PSVError("WebGL is not supported.");
    }

    if (SYSTEM.maxTextureWidth === 0) {
      throw new PSVError("Unable to detect system capabilities");
    }
  }
};

function getWebGLCtx() {
  var canvas = document.createElement("canvas");
  var names = ["webgl2", "webgl", "experimental-webgl", "moz-webgl", "webkit-3d"];
  var context = null;

  if (!canvas.getContext) {
    return null;
  }

  if (names.some(function (name) {
    try {
      context = canvas.getContext(name);
      return context !== null;
    } catch (e) {
      return false;
    }
  })) {
    return context;
  } else {
    return null;
  }
}

function isTouchEnabled() {
  var initial = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  if (LOCALSTORAGE_TOUCH_SUPPORT in localStorage) {
    initial = localStorage[LOCALSTORAGE_TOUCH_SUPPORT] === "true";
  }

  var promise = new Promise(function (resolve) {
    var clear = function clear() {
      window.removeEventListener("mousedown", listenerMouse);
      window.removeEventListener("touchstart", listenerTouch);
      clearTimeout(listenerTimeoutId);
    };

    var listenerMouse = function listenerMouse() {
      clear();
      localStorage[LOCALSTORAGE_TOUCH_SUPPORT] = false;
      resolve(false);
    };

    var listenerTouch = function listenerTouch() {
      clear();
      localStorage[LOCALSTORAGE_TOUCH_SUPPORT] = true;
      resolve(true);
    };

    var listenerTimeout = function listenerTimeout() {
      clear();
      localStorage[LOCALSTORAGE_TOUCH_SUPPORT] = initial;
      resolve(initial);
    };

    window.addEventListener("mousedown", listenerMouse, false);
    window.addEventListener("touchstart", listenerTouch, false);
    var listenerTimeoutId = setTimeout(listenerTimeout, 1e4);
  });
  return {
    initial: initial,
    promise: promise
  };
}

function getMaxCanvasWidth(maxWidth) {
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  canvas.width = maxWidth;
  canvas.height = maxWidth / 2;

  while (canvas.width > 1024) {
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, 1, 1);

    try {
      if (ctx.getImageData(0, 0, 1, 1).data[0] > 0) {
        return canvas.width;
      }
    } catch (e) {}

    canvas.width /= 2;
    canvas.height /= 2;
  }

  throw new PSVError("Unable to detect system capabilities");
} // src/adapters/EquirectangularAdapter.ts


var getConfig = _getConfigParser({
  resolution: 64,
  blur: false
}, {
  resolution: function resolution(_resolution) {
    if (!_resolution || !MathUtils.isPowerOfTwo(_resolution)) {
      throw new PSVError("EquirectangularAdapter resolution must be power of two");
    }

    return _resolution;
  }
});

var EquirectangularAdapter = /*#__PURE__*/function (_AbstractAdapter2) {
  _inherits(EquirectangularAdapter, _AbstractAdapter2);

  var _super33 = _createSuper(EquirectangularAdapter);

  function EquirectangularAdapter(viewer, config) {
    var _this29;

    _classCallCheck(this, EquirectangularAdapter);

    _this29 = _super33.call(this, viewer);
    _this29.config = getConfig(config);
    _this29.SPHERE_SEGMENTS = _this29.config.resolution;
    _this29.SPHERE_HORIZONTAL_SEGMENTS = _this29.SPHERE_SEGMENTS / 2;
    return _this29;
  }

  _createClass(EquirectangularAdapter, [{
    key: "supportsTransition",
    value: function supportsTransition() {
      return true;
    }
  }, {
    key: "supportsPreload",
    value: function supportsPreload() {
      return true;
    }
  }, {
    key: "loadTexture",
    value: function () {
      var _loadTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(panorama, newPanoData) {
        var _this30 = this,
            _newPanoData,
            _xmpPanoData,
            _newPanoData2,
            _xmpPanoData2,
            _newPanoData3,
            _xmpPanoData3,
            _newPanoData4,
            _xmpPanoData4,
            _newPanoData5,
            _xmpPanoData5,
            _newPanoData6,
            _xmpPanoData6,
            _newPanoData7,
            _xmpPanoData7,
            _newPanoData8,
            _xmpPanoData8,
            _newPanoData9,
            _xmpPanoData9;

        var useXmpPanoData,
            img,
            xmpPanoData,
            panoData,
            texture,
            _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                useXmpPanoData = _args.length > 2 && _args[2] !== undefined ? _args[2] : this.viewer.config.useXmpData;

                if (!(typeof panorama !== "string")) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new PSVError("Invalid panorama url, are you using the right adapter?")));

              case 3:
                if (!useXmpPanoData) {
                  _context.next = 12;
                  break;
                }

                _context.next = 6;
                return this.loadXMP(panorama, function (p) {
                  return _this30.viewer.loader.setProgress(p);
                });

              case 6:
                xmpPanoData = _context.sent;
                _context.next = 9;
                return this.viewer.textureLoader.loadImage(panorama);

              case 9:
                img = _context.sent;
                _context.next = 15;
                break;

              case 12:
                _context.next = 14;
                return this.viewer.textureLoader.loadImage(panorama, function (p) {
                  return _this30.viewer.loader.setProgress(p);
                });

              case 14:
                img = _context.sent;

              case 15:
                if (typeof newPanoData === "function") {
                  newPanoData = newPanoData(img);
                }

                panoData = {
                  fullWidth: _firstNonNull((_newPanoData = newPanoData) === null || _newPanoData === void 0 ? void 0 : _newPanoData.fullWidth, (_xmpPanoData = xmpPanoData) === null || _xmpPanoData === void 0 ? void 0 : _xmpPanoData.fullWidth, img.width),
                  fullHeight: _firstNonNull((_newPanoData2 = newPanoData) === null || _newPanoData2 === void 0 ? void 0 : _newPanoData2.fullHeight, (_xmpPanoData2 = xmpPanoData) === null || _xmpPanoData2 === void 0 ? void 0 : _xmpPanoData2.fullHeight, img.height),
                  croppedWidth: _firstNonNull((_newPanoData3 = newPanoData) === null || _newPanoData3 === void 0 ? void 0 : _newPanoData3.croppedWidth, (_xmpPanoData3 = xmpPanoData) === null || _xmpPanoData3 === void 0 ? void 0 : _xmpPanoData3.croppedWidth, img.width),
                  croppedHeight: _firstNonNull((_newPanoData4 = newPanoData) === null || _newPanoData4 === void 0 ? void 0 : _newPanoData4.croppedHeight, (_xmpPanoData4 = xmpPanoData) === null || _xmpPanoData4 === void 0 ? void 0 : _xmpPanoData4.croppedHeight, img.height),
                  croppedX: _firstNonNull((_newPanoData5 = newPanoData) === null || _newPanoData5 === void 0 ? void 0 : _newPanoData5.croppedX, (_xmpPanoData5 = xmpPanoData) === null || _xmpPanoData5 === void 0 ? void 0 : _xmpPanoData5.croppedX, 0),
                  croppedY: _firstNonNull((_newPanoData6 = newPanoData) === null || _newPanoData6 === void 0 ? void 0 : _newPanoData6.croppedY, (_xmpPanoData6 = xmpPanoData) === null || _xmpPanoData6 === void 0 ? void 0 : _xmpPanoData6.croppedY, 0),
                  poseHeading: _firstNonNull((_newPanoData7 = newPanoData) === null || _newPanoData7 === void 0 ? void 0 : _newPanoData7.poseHeading, (_xmpPanoData7 = xmpPanoData) === null || _xmpPanoData7 === void 0 ? void 0 : _xmpPanoData7.poseHeading, 0),
                  posePitch: _firstNonNull((_newPanoData8 = newPanoData) === null || _newPanoData8 === void 0 ? void 0 : _newPanoData8.posePitch, (_xmpPanoData8 = xmpPanoData) === null || _xmpPanoData8 === void 0 ? void 0 : _xmpPanoData8.posePitch, 0),
                  poseRoll: _firstNonNull((_newPanoData9 = newPanoData) === null || _newPanoData9 === void 0 ? void 0 : _newPanoData9.poseRoll, (_xmpPanoData9 = xmpPanoData) === null || _xmpPanoData9 === void 0 ? void 0 : _xmpPanoData9.poseRoll, 0)
                };

                if (panoData.croppedWidth !== img.width || panoData.croppedHeight !== img.height) {
                  _logWarn("Invalid panoData, croppedWidth and/or croppedHeight is not coherent with loaded image.\n              panoData: ".concat(panoData.croppedWidth, "x").concat(panoData.croppedHeight, ", image: ").concat(img.width, "x").concat(img.height));
                }

                if ((newPanoData || xmpPanoData) && panoData.fullWidth !== panoData.fullHeight * 2) {
                  _logWarn("Invalid panoData, fullWidth should be twice fullHeight");
                }

                texture = this.createEquirectangularTexture(img, panoData);
                return _context.abrupt("return", {
                  panorama: panorama,
                  texture: texture,
                  panoData: panoData
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadTexture(_x, _x2) {
        return _loadTexture.apply(this, arguments);
      }

      return loadTexture;
    }()
  }, {
    key: "loadXMP",
    value: function () {
      var _loadXMP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(panorama, onProgress) {
        var blob, binary, a, b, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.viewer.textureLoader.loadFile(panorama, onProgress);

              case 2:
                blob = _context2.sent;
                _context2.next = 5;
                return this.loadBlobAsString(blob);

              case 5:
                binary = _context2.sent;
                a = binary.indexOf("<x:xmpmeta");
                b = binary.indexOf("</x:xmpmeta>");
                data = binary.substring(a, b);

                if (!(a !== -1 && b !== -1 && data.includes("GPano:"))) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", {
                  fullWidth: _getXMPValue(data, "FullPanoWidthPixels"),
                  fullHeight: _getXMPValue(data, "FullPanoHeightPixels"),
                  croppedWidth: _getXMPValue(data, "CroppedAreaImageWidthPixels"),
                  croppedHeight: _getXMPValue(data, "CroppedAreaImageHeightPixels"),
                  croppedX: _getXMPValue(data, "CroppedAreaLeftPixels"),
                  croppedY: _getXMPValue(data, "CroppedAreaTopPixels"),
                  poseHeading: _getXMPValue(data, "PoseHeadingDegrees"),
                  posePitch: _getXMPValue(data, "PosePitchDegrees"),
                  poseRoll: _getXMPValue(data, "PoseRollDegrees")
                });

              case 11:
                return _context2.abrupt("return", null);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadXMP(_x3, _x4) {
        return _loadXMP.apply(this, arguments);
      }

      return loadXMP;
    }()
  }, {
    key: "loadBlobAsString",
    value: function loadBlobAsString(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
          return resolve(reader.result);
        };

        reader.onerror = reject;
        reader.readAsText(blob);
      });
    }
  }, {
    key: "createEquirectangularTexture",
    value: function createEquirectangularTexture(img, panoData) {
      if (this.config.blur || panoData.fullWidth > SYSTEM.maxTextureWidth || panoData.croppedWidth !== panoData.fullWidth || panoData.croppedHeight !== panoData.fullHeight) {
        var ratio = Math.min(1, SYSTEM.maxCanvasWidth / panoData.fullWidth);
        var resizedPanoData = {
          fullWidth: panoData.fullWidth * ratio,
          fullHeight: panoData.fullHeight * ratio,
          croppedWidth: panoData.croppedWidth * ratio,
          croppedHeight: panoData.croppedHeight * ratio,
          croppedX: panoData.croppedX * ratio,
          croppedY: panoData.croppedY * ratio
        };
        var buffer = document.createElement("canvas");
        buffer.width = resizedPanoData.fullWidth;
        buffer.height = resizedPanoData.fullHeight;
        var ctx = buffer.getContext("2d");

        if (this.config.blur) {
          ctx.filter = "blur(1px)";
        }

        ctx.drawImage(img, resizedPanoData.croppedX, resizedPanoData.croppedY, resizedPanoData.croppedWidth, resizedPanoData.croppedHeight);
        return _createTexture(buffer);
      }

      return _createTexture(img);
    }
  }, {
    key: "createMesh",
    value: function createMesh() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var geometry = new SphereGeometry(_SPHERE_RADIUS * scale, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1);
      var material = AbstractAdapter.createOverlayMaterial();
      return new Mesh(geometry, material);
    }
  }, {
    key: "setTexture",
    value: function setTexture(mesh, textureData) {
      this.__setUniform(mesh, AbstractAdapter.OVERLAY_UNIFORMS.panorama, textureData.texture);

      this.setOverlay(mesh, null, 1);
    }
  }, {
    key: "setOverlay",
    value: function setOverlay(mesh, textureData, opacity) {
      this.__setUniform(mesh, AbstractAdapter.OVERLAY_UNIFORMS.overlayOpacity, opacity);

      if (!textureData) {
        this.__setUniform(mesh, AbstractAdapter.OVERLAY_UNIFORMS.overlay, new Texture());
      } else {
        this.__setUniform(mesh, AbstractAdapter.OVERLAY_UNIFORMS.overlay, textureData.texture);
      }
    }
  }, {
    key: "setTextureOpacity",
    value: function setTextureOpacity(mesh, opacity) {
      this.__setUniform(mesh, AbstractAdapter.OVERLAY_UNIFORMS.globalOpacity, opacity);

      mesh.material.transparent = opacity < 1;
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(textureData) {
      var _textureData$texture;

      (_textureData$texture = textureData.texture) === null || _textureData$texture === void 0 ? void 0 : _textureData$texture.dispose();
    }
  }, {
    key: "__setUniform",
    value: function __setUniform(mesh, uniform, value) {
      if (mesh.material.uniforms[uniform].value instanceof Texture) {
        mesh.material.uniforms[uniform].value.dispose();
      }

      mesh.material.uniforms[uniform].value = value;
    }
  }]);

  return EquirectangularAdapter;
}(AbstractAdapter);

EquirectangularAdapter.id = "equirectangular";
EquirectangularAdapter.supportsDownload = true;
EquirectangularAdapter.supportsOverlay = true; // src/components/AbstractComponent.ts

var AbstractComponent = /*#__PURE__*/function () {
  function AbstractComponent(parent, config) {
    _classCallCheck(this, AbstractComponent);

    this.parent = parent;
    this.children = [];
    this.container = document.createElement("div");
    this.state = {
      visible: true
    };
    this.viewer = parent instanceof AbstractComponent ? parent.viewer : parent;
    this.container.className = config.className;
    this.parent.children.push(this);
    this.parent.container.appendChild(this.container);
  }

  _createClass(AbstractComponent, [{
    key: "destroy",
    value: function destroy() {
      this.parent.container.removeChild(this.container);
      var childIdx = this.parent.children.indexOf(this);

      if (childIdx !== -1) {
        this.parent.children.splice(childIdx, 1);
      }

      this.children.slice().forEach(function (child) {
        return child.destroy();
      });
      this.children.length = 0;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.isVisible();

      if (!visible) {
        this.hide();
      } else {
        this.show();
      }
    }
  }, {
    key: "hide",
    value: function hide(options) {
      this.container.style.display = "none";
      this.state.visible = false;
    }
  }, {
    key: "show",
    value: function show(options) {
      this.container.style.display = "";
      this.state.visible = true;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.state.visible;
    }
  }]);

  return AbstractComponent;
}(); // src/buttons/AbstractButton.ts


var getConfig2 = _getConfigParser({
  id: null,
  className: null,
  title: null,
  hoverScale: false,
  collapsable: false,
  tabbable: true,
  icon: null,
  iconActive: null
});

var AbstractButton = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(AbstractButton, _AbstractComponent);

  var _super34 = _createSuper(AbstractButton);

  function AbstractButton(navbar, config) {
    var _this31;

    _classCallCheck(this, AbstractButton);

    _this31 = _super34.call(this, navbar, {
      className: "psv-button ".concat(config.hoverScale ? "psv-button--hover-scale" : "", " ").concat(config.className || "")
    });
    _this31.state = {
      visible: true,
      enabled: true,
      supported: true,
      collapsed: false,
      active: false,
      width: 0
    };
    _this31.config = getConfig2(config);
    _this31.config.id = _this31.constructor.id;

    if (config.icon) {
      _this31.__setIcon(config.icon);
    }

    _this31.state.width = _this31.container.offsetWidth;

    if (_this31.config.title) {
      _this31.container.title = _this31.config.title;
    } else if (_this31.id && _this31.id in _this31.viewer.config.lang) {
      _this31.container.title = _this31.viewer.config.lang[_this31.id];
    }

    if (config.tabbable) {
      _this31.container.tabIndex = 0;
    }

    _this31.container.addEventListener("click", function (e) {
      if (_this31.state.enabled) {
        _this31.onClick();
      }

      e.stopPropagation();
    });

    _this31.container.addEventListener("keydown", function (e) {
      if (e.key === _KEY_CODES.Enter && _this31.state.enabled) {
        _this31.onClick();

        e.stopPropagation();
      }
    });

    return _this31;
  }

  _createClass(AbstractButton, [{
    key: "id",
    get: function get() {
      return this.config.id;
    }
  }, {
    key: "title",
    get: function get() {
      return this.container.title;
    }
  }, {
    key: "content",
    get: function get() {
      return this.container.innerHTML;
    }
  }, {
    key: "width",
    get: function get() {
      return this.state.width;
    }
  }, {
    key: "collapsable",
    get: function get() {
      return this.config.collapsable;
    }
  }, {
    key: "show",
    value: function show() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.isVisible()) {
        this.state.visible = true;

        if (!this.state.collapsed) {
          this.container.style.display = "";
        }

        if (refresh) {
          this.viewer.navbar.autoSize();
        }
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.isVisible()) {
        this.state.visible = false;
        this.container.style.display = "none";

        if (refresh) {
          this.viewer.navbar.autoSize();
        }
      }
    }
  }, {
    key: "checkSupported",
    value: function checkSupported() {
      var _this32 = this;

      var supportedOrObject = this.isSupported();

      if (_isPlainObject(supportedOrObject)) {
        if (supportedOrObject.initial === false) {
          this.state.supported = false;
          this.hide();
        }

        supportedOrObject.promise.then(function (supported) {
          if (!_this32.state) {
            return;
          }

          _this32.state.supported = supported;

          _this32.toggle(supported);
        });
      } else {
        this.state.supported = supportedOrObject;

        if (!supportedOrObject) {
          this.hide();
        }
      }
    }
  }, {
    key: "autoSize",
    value: function autoSize() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return true;
    }
  }, {
    key: "toggleActive",
    value: function toggleActive() {
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.active;

      if (active !== this.state.active) {
        this.state.active = active;

        _toggleClass(this.container, "psv-button--active", this.state.active);

        if (this.config.iconActive) {
          this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon);
        }
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      this.container.classList.add("psv-button--disabled");
      this.state.enabled = false;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.container.classList.remove("psv-button--disabled");
      this.state.enabled = true;
    }
  }, {
    key: "collapse",
    value: function collapse() {
      this.state.collapsed = true;
      this.container.style.display = "none";
    }
  }, {
    key: "uncollapse",
    value: function uncollapse() {
      this.state.collapsed = false;

      if (this.state.visible) {
        this.container.style.display = "";
      }
    }
  }, {
    key: "__setIcon",
    value: function __setIcon(icon) {
      this.container.innerHTML = icon;

      _addClasses(this.container.querySelector("svg"), "psv-button-svg");
    }
  }]);

  return AbstractButton;
}(AbstractComponent); // src/buttons/CustomButton.ts


var CustomButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(CustomButton, _AbstractButton);

  var _super35 = _createSuper(CustomButton);

  function CustomButton(navbar, config) {
    var _this33;

    _classCallCheck(this, CustomButton);

    _this33 = _super35.call(this, navbar, {
      className: "psv-custom-button ".concat(config.className || ""),
      hoverScale: false,
      collapsable: config.collapsable !== false,
      tabbable: config.tabbable !== false,
      title: config.title
    });
    _this33.customOnClick = config.onClick;

    if (config.id) {
      _this33.config.id = config.id;
    } else {
      _this33.config.id = "psvButton-" + Math.random().toString(36).substring(2);
    }

    if (config.content) {
      _this33.container.innerHTML = config.content;
    }

    _this33.state.width = _this33.container.offsetWidth;

    if (config.disabled) {
      _this33.disable();
    }

    if (config.visible === false) {
      _this33.hide();
    }

    return _this33;
  }

  _createClass(CustomButton, [{
    key: "onClick",
    value: function onClick() {
      var _this$customOnClick;

      (_this$customOnClick = this.customOnClick) === null || _this$customOnClick === void 0 ? void 0 : _this$customOnClick.call(this, this.viewer);
    }
  }]);

  return CustomButton;
}(AbstractButton); // src/icons/info.svg


var info_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/><!--Created by Arafat Uddin from the Noun Project--></svg>\n'; // src/buttons/DescriptionButton.ts

var DescriptionButton = /*#__PURE__*/function (_AbstractButton2) {
  _inherits(DescriptionButton, _AbstractButton2);

  var _super36 = _createSuper(DescriptionButton);

  function DescriptionButton(navbar) {
    var _this34;

    _classCallCheck(this, DescriptionButton);

    _this34 = _super36.call(this, navbar, {
      className: "psv-description-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: info_default
    });
    _this34.mode = 0
    /* NONE */
    ;

    _this34.viewer.addEventListener(_HideNotificationEvent2.type, _assertThisInitialized(_this34));

    _this34.viewer.addEventListener(_ShowNotificationEvent2.type, _assertThisInitialized(_this34));

    _this34.viewer.addEventListener(_HidePanelEvent2.type, _assertThisInitialized(_this34));

    _this34.viewer.addEventListener(_ShowPanelEvent2.type, _assertThisInitialized(_this34));

    _this34.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this34));

    return _this34;
  }

  _createClass(DescriptionButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_HideNotificationEvent2.type, this);
      this.viewer.removeEventListener(_ShowNotificationEvent2.type, this);
      this.viewer.removeEventListener(_HidePanelEvent2.type, this);
      this.viewer.removeEventListener(_ShowPanelEvent2.type, this);
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);

      _get(_getPrototypeOf(DescriptionButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ConfigChangedEvent2) {
        e.containsOptions("description") && this.autoSize(true);
        return;
      }

      if (!this.mode) {
        return;
      }

      var closed = false;

      if (e instanceof _HideNotificationEvent2) {
        closed = this.mode === 1
        /* NOTIF */
        ;
      } else if (e instanceof _ShowNotificationEvent2) {
        closed = this.mode === 1
        /* NOTIF */
        && e.notificationId !== _IDS.DESCRIPTION;
      } else if (e instanceof _HidePanelEvent2) {
        closed = this.mode === 2
        /* PANEL */
        ;
      } else if (e instanceof _ShowPanelEvent2) {
        closed = this.mode === 2
        /* PANEL */
        && e.panelId !== _IDS.DESCRIPTION;
      }

      if (closed) {
        this.toggleActive(false);
        this.mode = 0
        /* NONE */
        ;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (this.mode) {
        this.__close();
      } else {
        this.__open();
      }
    }
  }, {
    key: "hide",
    value: function hide(refresh) {
      _get(_getPrototypeOf(DescriptionButton.prototype), "hide", this).call(this, refresh);

      if (this.mode) {
        this.__close();
      }
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (refresh) {
        var caption = this.viewer.navbar.getButton("caption", false);
        var captionHidden = caption && !caption.isVisible();
        var hasDescription = !!this.viewer.config.description;

        if (captionHidden || hasDescription) {
          this.show(false);
        } else {
          this.hide(false);
        }
      }
    }
  }, {
    key: "__close",
    value: function __close() {
      switch (this.mode) {
        case 1
        /* NOTIF */
        :
          this.viewer.notification.hide(_IDS.DESCRIPTION);
          break;

        case 2
        /* PANEL */
        :
          this.viewer.panel.hide(_IDS.DESCRIPTION);
          break;
      }
    }
  }, {
    key: "__open",
    value: function __open() {
      this.toggleActive(true);

      if (this.viewer.config.description) {
        this.mode = 2
        /* PANEL */
        ;
        this.viewer.panel.show({
          id: _IDS.DESCRIPTION,
          content: (this.viewer.config.caption ? "<p>".concat(this.viewer.config.caption, "</p>") : "") + this.viewer.config.description
        });
      } else {
        this.mode = 1
        /* NOTIF */
        ;
        this.viewer.notification.show({
          id: _IDS.DESCRIPTION,
          content: this.viewer.config.caption
        });
      }
    }
  }]);

  return DescriptionButton;
}(AbstractButton);

DescriptionButton.id = "description"; // src/icons/download.svg

var download_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/><!--Created by Michael Zenaty from the Noun Project--></svg>\n'; // src/buttons/DownloadButton.ts

var DownloadButton = /*#__PURE__*/function (_AbstractButton3) {
  _inherits(DownloadButton, _AbstractButton3);

  var _super37 = _createSuper(DownloadButton);

  function DownloadButton(navbar) {
    var _this35;

    _classCallCheck(this, DownloadButton);

    _this35 = _super37.call(this, navbar, {
      className: "psv-download-butto",
      hoverScale: true,
      collapsable: true,
      tabbable: true,
      icon: download_default
    });

    _this35.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this35));

    return _this35;
  }

  _createClass(DownloadButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);

      _get(_getPrototypeOf(DownloadButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ConfigChangedEvent2) {
        e.containsOptions("downloadUrl") && this.checkSupported();
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      var _this36 = this;

      var link = document.createElement("a");
      link.href = this.viewer.config.downloadUrl || this.viewer.config.panorama;
      link.download = link.href.split("/").pop();
      this.viewer.container.appendChild(link);
      link.click();
      setTimeout(function () {
        _this36.viewer.container.removeChild(link);
      }, 100);
    }
  }, {
    key: "checkSupported",
    value: function checkSupported() {
      var supported = this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl;

      if (supported) {
        this.show();
      } else {
        this.hide();
      }
    }
  }]);

  return DownloadButton;
}(AbstractButton);

DownloadButton.id = "download"; // src/icons/fullscreen-in.svg

var fullscreen_in_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/><!--Created by Garrett Knoll from the Noun Project--></svg>\n'; // src/icons/fullscreen-out.svg

var fullscreen_out_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/><!--Created by Garrett Knoll from the Noun Project--></svg>\n'; // src/buttons/FullscreenButton.ts

var FullscreenButton = /*#__PURE__*/function (_AbstractButton4) {
  _inherits(FullscreenButton, _AbstractButton4);

  var _super38 = _createSuper(FullscreenButton);

  function FullscreenButton(navbar) {
    var _this37;

    _classCallCheck(this, FullscreenButton);

    _this37 = _super38.call(this, navbar, {
      className: "psv-fullscreen-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: fullscreen_in_default,
      iconActive: fullscreen_out_default
    });

    _this37.viewer.addEventListener(_FullscreenEvent2.type, _assertThisInitialized(_this37));

    return _this37;
  }

  _createClass(FullscreenButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_FullscreenEvent2.type, this);

      _get(_getPrototypeOf(FullscreenButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _FullscreenEvent2) {
        this.toggleActive(e.fullscreenEnabled);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.viewer.toggleFullscreen();
    }
  }]);

  return FullscreenButton;
}(AbstractButton);

FullscreenButton.id = "fullscreen"; // src/icons/menu.svg

var menu_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g><!-- Created by Richard Kun\xE1k from the Noun Project--></svg>\n'; // src/buttons/MenuButton.ts

var BUTTON_DATA = "psvButton";

var MENU_TEMPLATE = function MENU_TEMPLATE(buttons, title) {
  return "\n<div class=\"psv-panel-menu psv-panel-menu--stripped\">\n  <h1 class=\"psv-panel-menu-title\">".concat(menu_default, " ").concat(title, "</h1>\n  <ul class=\"psv-panel-menu-list\">\n    ").concat(buttons.map(function (button) {
    return "\n    <li data-psv-button=\"".concat(button.id, "\" class=\"psv-panel-menu-item\" tabindex=\"0\">\n      <span class=\"psv-panel-menu-item-icon\">").concat(button.content, "</span>\n      <span class=\"psv-panel-menu-item-label\">").concat(button.title, "</span>\n    </li>\n    ");
  }).join(""), "\n  </ul>\n</div>\n");
};

var MenuButton = /*#__PURE__*/function (_AbstractButton5) {
  _inherits(MenuButton, _AbstractButton5);

  var _super39 = _createSuper(MenuButton);

  function MenuButton(navbar) {
    var _thisSuper, _this38;

    _classCallCheck(this, MenuButton);

    _this38 = _super39.call(this, navbar, {
      className: "psv-menu-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: menu_default
    });

    _this38.viewer.addEventListener(_ShowPanelEvent2.type, _assertThisInitialized(_this38));

    _this38.viewer.addEventListener(_HidePanelEvent2.type, _assertThisInitialized(_this38));

    _get((_thisSuper = _assertThisInitialized(_this38), _getPrototypeOf(MenuButton.prototype)), "hide", _thisSuper).call(_thisSuper);

    return _this38;
  }

  _createClass(MenuButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ShowPanelEvent2.type, this);
      this.viewer.removeEventListener(_HidePanelEvent2.type, this);

      _get(_getPrototypeOf(MenuButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ShowPanelEvent2) {
        this.toggleActive(e.panelId === _IDS.MENU);
      } else if (e instanceof _HidePanelEvent2) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (this.state.active) {
        this.__hideMenu();
      } else {
        this.__showMenu();
      }
    }
  }, {
    key: "hide",
    value: function hide(refresh) {
      _get(_getPrototypeOf(MenuButton.prototype), "hide", this).call(this, refresh);

      this.__hideMenu();
    }
  }, {
    key: "show",
    value: function show(refresh) {
      _get(_getPrototypeOf(MenuButton.prototype), "show", this).call(this, refresh);

      if (this.state.active) {
        this.__showMenu();
      }
    }
  }, {
    key: "__showMenu",
    value: function __showMenu() {
      var _this39 = this;

      this.viewer.panel.show({
        id: _IDS.MENU,
        content: MENU_TEMPLATE(this.viewer.navbar.collapsed, this.viewer.config.lang.menu),
        noMargin: true,
        clickHandler: function clickHandler(target) {
          var li = target ? _getClosest(target, "li") : void 0;
          var buttonId = li ? li.dataset[BUTTON_DATA] : void 0;

          if (buttonId) {
            _this39.viewer.navbar.getButton(buttonId).onClick();

            _this39.__hideMenu();
          }
        }
      });
    }
  }, {
    key: "__hideMenu",
    value: function __hideMenu() {
      this.viewer.panel.hide(_IDS.MENU);
    }
  }]);

  return MenuButton;
}(AbstractButton);

MenuButton.id = "menu"; // src/icons/arrow.svg

var arrow_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g><!-- Created by Flatart from the Noun Project --></svg>\n'; // src/utils/PressHandler.ts

var PressHandler = /*#__PURE__*/function () {
  function PressHandler() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;

    _classCallCheck(this, PressHandler);

    this.delay = delay;
    this.time = 0;
    this.delay = delay;
  }

  _createClass(PressHandler, [{
    key: "pending",
    get: function get() {
      return this.time !== 0;
    }
  }, {
    key: "down",
    value: function down() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = void 0;
      }

      this.time = new Date().getTime();
    }
  }, {
    key: "up",
    value: function up(cb) {
      var _this40 = this;

      if (!this.time) {
        return;
      }

      var elapsed = Date.now() - this.time;

      if (elapsed < this.delay) {
        this.timeout = setTimeout(function () {
          cb();
          _this40.timeout = void 0;
          _this40.time = 0;
        }, this.delay);
      } else {
        cb();
        this.time = 0;
      }
    }
  }]);

  return PressHandler;
}(); // src/buttons/AbstractMoveButton.ts


function getIcon(value) {
  var angle = 0;

  switch (value) {
    case 0
    /* UP */
    :
      angle = 90;
      break;

    case 1
    /* DOWN */
    :
      angle = -90;
      break;

    case 3
    /* RIGHT */
    :
      angle = 180;
      break;

    default:
      angle = 0;
      break;
  }

  return arrow_default.replace("rotate(0", "rotate(".concat(angle));
}

var AbstractMoveButton = /*#__PURE__*/function (_AbstractButton6) {
  _inherits(AbstractMoveButton, _AbstractButton6);

  var _super40 = _createSuper(AbstractMoveButton);

  function AbstractMoveButton(navbar, direction) {
    var _this41;

    _classCallCheck(this, AbstractMoveButton);

    _this41 = _super40.call(this, navbar, {
      className: "psv-move-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: getIcon(direction)
    });
    _this41.direction = direction;
    _this41.handler = new PressHandler();

    _this41.container.addEventListener("mousedown", _assertThisInitialized(_this41));

    _this41.container.addEventListener("keydown", _assertThisInitialized(_this41));

    _this41.container.addEventListener("keyup", _assertThisInitialized(_this41));

    _this41.viewer.container.addEventListener("mouseup", _assertThisInitialized(_this41));

    _this41.viewer.container.addEventListener("touchend", _assertThisInitialized(_this41));

    return _this41;
  }

  _createClass(AbstractMoveButton, [{
    key: "destroy",
    value: function destroy() {
      this.__onMouseUp();

      this.viewer.container.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchend", this);

      _get(_getPrototypeOf(AbstractMoveButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.__onMouseDown();

          break;

        case "mouseup":
          this.__onMouseUp();

          break;

        case "touchend":
          this.__onMouseUp();

          break;

        case "keydown":
          e.key === _KEY_CODES.Enter && this.__onMouseDown();
          break;

        case "keyup":
          e.key === _KEY_CODES.Enter && this.__onMouseUp();
          break;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return {
        initial: !SYSTEM.isTouchEnabled.initial,
        promise: SYSTEM.isTouchEnabled.promise.then(function (enabled) {
          return !enabled;
        })
      };
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown() {
      if (!this.state.enabled) {
        return;
      }

      var dynamicRoll = {};

      switch (this.direction) {
        case 0
        /* UP */
        :
          dynamicRoll.pitch = false;
          break;

        case 1
        /* DOWN */
        :
          dynamicRoll.pitch = true;
          break;

        case 3
        /* RIGHT */
        :
          dynamicRoll.yaw = false;
          break;

        default:
          dynamicRoll.yaw = true;
          break;
      }

      this.viewer.stopAll();
      this.viewer.dynamics.position.roll(dynamicRoll);
      this.handler.down();
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp() {
      var _this42 = this;

      if (!this.state.enabled) {
        return;
      }

      this.handler.up(function () {
        _this42.viewer.dynamics.position.stop();

        _this42.viewer.resetIdleTimer();
      });
    }
  }]);

  return AbstractMoveButton;
}(AbstractButton);

AbstractMoveButton.groupId = "move"; // src/buttons/MoveDownButton.ts

var MoveDownButton = /*#__PURE__*/function (_AbstractMoveButton) {
  _inherits(MoveDownButton, _AbstractMoveButton);

  var _super41 = _createSuper(MoveDownButton);

  function MoveDownButton(navbar) {
    _classCallCheck(this, MoveDownButton);

    return _super41.call(this, navbar, 1
    /* DOWN */
    );
  }

  return _createClass(MoveDownButton);
}(AbstractMoveButton);

MoveDownButton.id = "moveDown"; // src/buttons/MoveLeftButton.ts

var MoveLeftButton = /*#__PURE__*/function (_AbstractMoveButton2) {
  _inherits(MoveLeftButton, _AbstractMoveButton2);

  var _super42 = _createSuper(MoveLeftButton);

  function MoveLeftButton(navbar) {
    _classCallCheck(this, MoveLeftButton);

    return _super42.call(this, navbar, 2
    /* LEFT */
    );
  }

  return _createClass(MoveLeftButton);
}(AbstractMoveButton);

MoveLeftButton.id = "moveLeft"; // src/buttons/MoveRightButton.ts

var MoveRightButton = /*#__PURE__*/function (_AbstractMoveButton3) {
  _inherits(MoveRightButton, _AbstractMoveButton3);

  var _super43 = _createSuper(MoveRightButton);

  function MoveRightButton(navbar) {
    _classCallCheck(this, MoveRightButton);

    return _super43.call(this, navbar, 3
    /* RIGHT */
    );
  }

  return _createClass(MoveRightButton);
}(AbstractMoveButton);

MoveRightButton.id = "moveRight"; // src/buttons/MoveUpButton.ts

var MoveUpButton = /*#__PURE__*/function (_AbstractMoveButton4) {
  _inherits(MoveUpButton, _AbstractMoveButton4);

  var _super44 = _createSuper(MoveUpButton);

  function MoveUpButton(navbar) {
    _classCallCheck(this, MoveUpButton);

    return _super44.call(this, navbar, 0
    /* UP */
    );
  }

  return _createClass(MoveUpButton);
}(AbstractMoveButton);

MoveUpButton.id = "moveUp"; // src/icons/zoom-in.svg

var zoom_in_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/><!--Created by Ryan Canning from the Noun Project--></svg>\n'; // src/buttons/AbstractZoomButton.ts

var AbstractZoomButton = /*#__PURE__*/function (_AbstractButton7) {
  _inherits(AbstractZoomButton, _AbstractButton7);

  var _super45 = _createSuper(AbstractZoomButton);

  function AbstractZoomButton(navbar, direction, icon) {
    var _this43;

    _classCallCheck(this, AbstractZoomButton);

    _this43 = _super45.call(this, navbar, {
      className: "psv-zoom-button",
      hoverScale: true,
      collapsable: false,
      tabbable: true,
      icon: icon
    });
    _this43.direction = direction;
    _this43.handler = new PressHandler();

    _this43.container.addEventListener("mousedown", _assertThisInitialized(_this43));

    _this43.container.addEventListener("keydown", _assertThisInitialized(_this43));

    _this43.container.addEventListener("keyup", _assertThisInitialized(_this43));

    _this43.viewer.container.addEventListener("mouseup", _assertThisInitialized(_this43));

    _this43.viewer.container.addEventListener("touchend", _assertThisInitialized(_this43));

    return _this43;
  }

  _createClass(AbstractZoomButton, [{
    key: "destroy",
    value: function destroy() {
      this.__onMouseUp();

      this.viewer.container.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchend", this);

      _get(_getPrototypeOf(AbstractZoomButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.__onMouseDown();

          break;

        case "mouseup":
          this.__onMouseUp();

          break;

        case "touchend":
          this.__onMouseUp();

          break;

        case "keydown":
          e.key === _KEY_CODES.Enter && this.__onMouseDown();
          break;

        case "keyup":
          e.key === _KEY_CODES.Enter && this.__onMouseUp();
          break;
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return {
        initial: !SYSTEM.isTouchEnabled.initial,
        promise: SYSTEM.isTouchEnabled.promise.then(function (enabled) {
          return !enabled;
        })
      };
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown() {
      if (!this.state.enabled) {
        return;
      }

      this.viewer.dynamics.zoom.roll(this.direction === 1
      /* OUT */
      );
      this.handler.down();
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp() {
      var _this44 = this;

      if (!this.state.enabled) {
        return;
      }

      this.handler.up(function () {
        return _this44.viewer.dynamics.zoom.stop();
      });
    }
  }]);

  return AbstractZoomButton;
}(AbstractButton);

AbstractZoomButton.groupId = "zoom"; // src/buttons/ZoomInButton.ts

var ZoomInButton = /*#__PURE__*/function (_AbstractZoomButton) {
  _inherits(ZoomInButton, _AbstractZoomButton);

  var _super46 = _createSuper(ZoomInButton);

  function ZoomInButton(navbar) {
    _classCallCheck(this, ZoomInButton);

    return _super46.call(this, navbar, 0
    /* IN */
    , zoom_in_default);
  }

  return _createClass(ZoomInButton);
}(AbstractZoomButton);

ZoomInButton.id = "zoomIn"; // src/icons/zoom-out.svg

var zoom_out_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/><!--Created by Ryan Canning from the Noun Project--></svg>\n'; // src/buttons/ZoomOutButton.ts

var ZoomOutButton = /*#__PURE__*/function (_AbstractZoomButton2) {
  _inherits(ZoomOutButton, _AbstractZoomButton2);

  var _super47 = _createSuper(ZoomOutButton);

  function ZoomOutButton(navbar) {
    _classCallCheck(this, ZoomOutButton);

    return _super47.call(this, navbar, 1
    /* OUT */
    , zoom_out_default);
  }

  return _createClass(ZoomOutButton);
}(AbstractZoomButton);

ZoomOutButton.id = "zoomOut"; // src/buttons/ZoomRangeButton.ts

var ZoomRangeButton = /*#__PURE__*/function (_AbstractButton8) {
  _inherits(ZoomRangeButton, _AbstractButton8);

  var _super48 = _createSuper(ZoomRangeButton);

  function ZoomRangeButton(navbar) {
    var _this45;

    _classCallCheck(this, ZoomRangeButton);

    _this45 = _super48.call(this, navbar, {
      className: "psv-zoom-range",
      hoverScale: false,
      collapsable: false,
      tabbable: false
    });
    _this45.zoomRange = document.createElement("div");
    _this45.zoomRange.className = "psv-zoom-range-line";

    _this45.container.appendChild(_this45.zoomRange);

    _this45.zoomValue = document.createElement("div");
    _this45.zoomValue.className = "psv-zoom-range-handle";

    _this45.zoomRange.appendChild(_this45.zoomValue);

    _this45.slider = new _Slider(_this45.container, "HORIZONTAL"
    /* HORIZONTAL */
    , function (data) {
      return _this45.__onSliderUpdate(data);
    });
    _this45.mediaMinWidth = parseInt(_getStyle(_this45.container, "maxWidth"), 10);

    _this45.viewer.addEventListener(_ZoomUpdatedEvent2.type, _assertThisInitialized(_this45));

    if (_this45.viewer.state.ready) {
      _this45.__moveZoomValue(_this45.viewer.getZoomLevel());
    } else {
      _this45.viewer.addEventListener(_ReadyEvent2.type, _assertThisInitialized(_this45));
    }

    return _this45;
  }

  _createClass(ZoomRangeButton, [{
    key: "destroy",
    value: function destroy() {
      this.slider.destroy();
      this.viewer.removeEventListener(_ZoomUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_ReadyEvent2.type, this);

      _get(_getPrototypeOf(ZoomRangeButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ZoomUpdatedEvent2) {
        this.__moveZoomValue(e.zoomLevel);
      } else if (e instanceof _ReadyEvent2) {
        this.__moveZoomValue(this.viewer.getZoomLevel());
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      return {
        initial: !SYSTEM.isTouchEnabled.initial,
        promise: SYSTEM.isTouchEnabled.promise.then(function (enabled) {
          return !enabled;
        })
      };
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      if (this.state.supported) {
        if (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible) {
          this.hide(false);
        } else if (this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible) {
          this.show(false);
        }
      }
    }
  }, {
    key: "__moveZoomValue",
    value: function __moveZoomValue(level) {
      this.zoomValue.style.left = level / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
    }
  }, {
    key: "__onSliderUpdate",
    value: function __onSliderUpdate(data) {
      if (data.mousedown) {
        this.viewer.zoom(data.value * 100);
      }
    }
  }]);

  return ZoomRangeButton;
}(AbstractButton);

ZoomRangeButton.id = "zoomRange";
ZoomRangeButton.groupId = "zoom"; // src/plugins/AbstractPlugin.ts

var AbstractPlugin = /*#__PURE__*/function (_TypedEventTarget) {
  _inherits(AbstractPlugin, _TypedEventTarget);

  var _super49 = _createSuper(AbstractPlugin);

  function AbstractPlugin(viewer) {
    var _this46;

    _classCallCheck(this, AbstractPlugin);

    _this46 = _super49.call(this);
    _this46.viewer = viewer;
    return _this46;
  }

  _createClass(AbstractPlugin, [{
    key: "init",
    value: function init() {}
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);

  return AbstractPlugin;
}(TypedEventTarget);

function pluginInterop(plugin) {
  if (plugin) {
    for (var _i15 = 0, _arr3 = [["_", plugin]].concat(_toConsumableArray(Object.entries(plugin))); _i15 < _arr3.length; _i15++) {
      var _arr3$_i = _slicedToArray(_arr3[_i15], 2),
          p = _arr3$_i[1];

      if (p.prototype instanceof AbstractPlugin) {
        return p;
      }
    }
  }

  return null;
} // src/data/config.ts


var DEFAULTS = {
  panorama: null,
  overlay: null,
  overlayOpacity: 1,
  container: null,
  adapter: [EquirectangularAdapter, null],
  plugins: [],
  caption: null,
  description: null,
  downloadUrl: null,
  loadingImg: null,
  loadingTxt: "Loading...",
  size: null,
  fisheye: 0,
  minFov: 30,
  maxFov: 90,
  defaultZoomLvl: 50,
  defaultYaw: 0,
  defaultPitch: 0,
  sphereCorrection: null,
  moveSpeed: 1,
  zoomSpeed: 1,
  moveInertia: true,
  mousewheel: true,
  mousemove: true,
  mousewheelCtrlKey: false,
  touchmoveTwoFingers: false,
  useXmpData: true,
  panoData: null,
  requestHeaders: null,
  canvasBackground: "#000",
  withCredentials: false,
  navbar: ["zoom", "move", "download", "description", "caption", "fullscreen"],
  lang: {
    zoom: "Zoom",
    zoomOut: "Zoom out",
    zoomIn: "Zoom in",
    moveUp: "Move up",
    moveDown: "Move down",
    moveLeft: "Move left",
    moveRight: "Move right",
    download: "Download",
    fullscreen: "Fullscreen",
    menu: "Menu",
    twoFingers: "Use two fingers to navigate",
    ctrlZoom: "Use ctrl + scroll to zoom the image",
    loadError: "The panorama can't be loaded"
  },
  keyboard: (_keyboard = {}, _defineProperty(_keyboard, _KEY_CODES.ArrowUp, "ROTATE_UP"), _defineProperty(_keyboard, _KEY_CODES.ArrowDown, "ROTATE_DOWN"), _defineProperty(_keyboard, _KEY_CODES.ArrowRight, "ROTATE_RIGHT"), _defineProperty(_keyboard, _KEY_CODES.ArrowLeft, "ROTATE_LEFT"), _defineProperty(_keyboard, _KEY_CODES.PageUp, "ZOOM_IN"), _defineProperty(_keyboard, _KEY_CODES.PageDown, "ZOOM_OUT"), _defineProperty(_keyboard, _KEY_CODES.Plus, "ZOOM_IN"), _defineProperty(_keyboard, _KEY_CODES.Minus, "ZOOM_OUT"), _keyboard)
};
var READONLY_OPTIONS = {
  panorama: "Use setPanorama method to change the panorama",
  panoData: "Use setPanorama method to change the panorama",
  overlay: "Use setOverlay method to changer the overlay",
  overlayOpacity: "Use setOverlay method to changer the overlay",
  container: "Cannot change viewer container",
  adapter: "Cannot change adapter",
  plugins: "Cannot change plugins"
};

var autorotateOpt = function autorotateOpt() {
  _logWarn('autorotate option is deprecated, use the "autorotate" plugin instead');

  return null;
};

var CONFIG_PARSERS = {
  container: function container(_container) {
    if (!_container) {
      throw new PSVError("No value given for container.");
    }

    return _container;
  },
  adapter: function adapter(_adapter, _ref11) {
    var defValue = _ref11.defValue;

    if (!_adapter) {
      _adapter = defValue;
    } else if (Array.isArray(_adapter)) {
      _adapter = [adapterInterop(_adapter[0]), _adapter[1]];
    } else {
      _adapter = [adapterInterop(_adapter), null];
    }

    if (!_adapter[0]) {
      throw new PSVError("An undefined value was given for adapter.");
    }

    if (!_adapter[0].id) {
      throw new PSVError("Adapter has no id.");
    }

    return _adapter;
  },
  overlayOpacity: function overlayOpacity(_overlayOpacity) {
    return MathUtils.clamp(_overlayOpacity, 0, 1);
  },
  defaultLong: function defaultLong() {
    _logWarn("defaultLong is deprecated, use defaultYaw instead");

    return null;
  },
  defaultLat: function defaultLat() {
    _logWarn("defaultLat is deprecated, use defaultPitch instead");

    return null;
  },
  defaultYaw: function defaultYaw(_defaultYaw, _ref12) {
    var rawConfig = _ref12.rawConfig;
    return _parseAngle(!_isNil(rawConfig.defaultLong) ? rawConfig.defaultLong : _defaultYaw);
  },
  defaultPitch: function defaultPitch(_defaultPitch, _ref13) {
    var rawConfig = _ref13.rawConfig;
    return _parseAngle(!_isNil(rawConfig.defaultLat) ? rawConfig.defaultLat : _defaultPitch, true);
  },
  defaultZoomLvl: function defaultZoomLvl(_defaultZoomLvl) {
    return MathUtils.clamp(_defaultZoomLvl, 0, 100);
  },
  minFov: function minFov(_minFov, _ref14) {
    var rawConfig = _ref14.rawConfig;

    if (rawConfig.maxFov < _minFov) {
      _logWarn("maxFov cannot be lower than minFov");

      _minFov = rawConfig.maxFov;
    }

    return MathUtils.clamp(_minFov, 1, 179);
  },
  maxFov: function maxFov(_maxFov, _ref15) {
    var rawConfig = _ref15.rawConfig;

    if (_maxFov < rawConfig.minFov) {
      _maxFov = rawConfig.minFov;
    }

    return MathUtils.clamp(_maxFov, 1, 179);
  },
  lang: function lang(_lang) {
    if (Array.isArray(_lang.twoFingers)) {
      _logWarn("lang.twoFingers must not be an array");

      _lang.twoFingers = _lang.twoFingers[0];
    }

    return _objectSpread(_objectSpread({}, DEFAULTS.lang), _lang);
  },
  keyboard: function keyboard(_keyboard2) {
    if (!_keyboard2) {
      return null;
    }

    if (_keyboard2 === true) {
      return _clone(DEFAULTS.keyboard);
    }

    return _keyboard2;
  },
  autorotateLat: autorotateOpt,
  autorotateDelay: autorotateOpt,
  autorotateZoomLvl: autorotateOpt,
  autorotateSpeed: autorotateOpt,
  autorotateIdle: autorotateOpt,
  fisheye: function fisheye(_fisheye) {
    if (_fisheye === true) {
      return 1;
    } else if (_fisheye === false) {
      return 0;
    }

    return _fisheye;
  },
  requestHeaders: function requestHeaders(_requestHeaders) {
    if (_requestHeaders && _typeof(_requestHeaders) === "object") {
      return function () {
        return _requestHeaders;
      };
    }

    if (typeof _requestHeaders === "function") {
      return _requestHeaders;
    }

    return null;
  },
  plugins: function plugins(_plugins) {
    return _plugins.map(function (plugin, i) {
      if (Array.isArray(plugin)) {
        plugin = [pluginInterop(plugin[0]), plugin[1]];
      } else {
        plugin = [pluginInterop(plugin), null];
      }

      if (!plugin[0]) {
        throw new PSVError("An undefined value was given for plugin ".concat(i, "."));
      }

      if (!plugin[0].id) {
        throw new PSVError("Plugin ".concat(i, " has no id."));
      }

      return plugin;
    });
  },
  navbar: function navbar(_navbar) {
    if (_navbar === false) {
      return null;
    }

    if (_navbar === true) {
      return _clone(DEFAULTS.navbar);
    }

    if (typeof _navbar === "string") {
      return _navbar.split(/[ ,]/);
    }

    return _navbar;
  }
};

var getViewerConfig = _getConfigParser(DEFAULTS, CONFIG_PARSERS); // src/components/NavbarCaption.ts


var NavbarCaption = /*#__PURE__*/function (_AbstractButton9) {
  _inherits(NavbarCaption, _AbstractButton9);

  var _super50 = _createSuper(NavbarCaption);

  function NavbarCaption(navbar) {
    var _this47;

    _classCallCheck(this, NavbarCaption);

    _this47 = _super50.call(this, navbar, {
      className: "psv-caption",
      hoverScale: false,
      collapsable: false,
      tabbable: true
    });
    _this47.contentWidth = 0;
    _this47.state.width = 0;
    _this47.contentElt = document.createElement("div");
    _this47.contentElt.className = "psv-caption-content";

    _this47.container.appendChild(_this47.contentElt);

    _this47.setCaption(_this47.viewer.config.caption);

    return _this47;
  }

  _createClass(NavbarCaption, [{
    key: "hide",
    value: function hide() {
      this.contentElt.style.display = "none";
      this.state.visible = false;
    }
  }, {
    key: "show",
    value: function show() {
      this.contentElt.style.display = "";
      this.state.visible = true;
    }
  }, {
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "setCaption",
    value: function setCaption(html) {
      this.show();
      this.contentElt.innerHTML = html !== null && html !== void 0 ? html : "";

      if (this.contentElt.innerHTML) {
        this.contentWidth = this.contentElt.offsetWidth;
      } else {
        this.contentWidth = 0;
      }

      this.autoSize();
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      this.toggle(this.container.offsetWidth >= this.contentWidth);

      this.__refreshButton();
    }
  }, {
    key: "__refreshButton",
    value: function __refreshButton() {
      var _this$viewer$navbar$g;

      (_this$viewer$navbar$g = this.viewer.navbar.getButton(DescriptionButton.id, false)) === null || _this$viewer$navbar$g === void 0 ? void 0 : _this$viewer$navbar$g.autoSize(true);
    }
  }]);

  return NavbarCaption;
}(AbstractButton);

NavbarCaption.id = "caption"; // src/components/Navbar.ts

var AVAILABLE_BUTTONS = {};
var AVAILABLE_GROUPS = {};

function registerButton(button, defaultPosition) {
  if (!button.id) {
    throw new PSVError("Button id is required");
  }

  AVAILABLE_BUTTONS[button.id] = button;

  if (button.groupId) {
    (AVAILABLE_GROUPS[button.groupId] = AVAILABLE_GROUPS[button.groupId] || []).push(button);
  }

  if (defaultPosition) {
    var navbar = DEFAULTS.navbar;

    switch (defaultPosition) {
      case "start":
        navbar.unshift(button.id);
        break;

      case "end":
        navbar.push(button.id);
        break;

      default:
        {
          var _defaultPosition$spli = defaultPosition.split(":"),
              _defaultPosition$spli2 = _slicedToArray(_defaultPosition$spli, 2),
              id = _defaultPosition$spli2[0],
              pos = _defaultPosition$spli2[1];

          var idx = navbar.indexOf(id);

          if (!id || !pos || idx === -1) {
            throw new PSVError("Invalid defaultPosition ".concat(defaultPosition));
          }

          navbar.splice(idx + (pos === "right" ? 1 : 0), 0, button.id);
        }
    }
  }
}

[ZoomOutButton, ZoomRangeButton, ZoomInButton, DescriptionButton, NavbarCaption, DownloadButton, FullscreenButton, MoveLeftButton, MoveRightButton, MoveUpButton, MoveDownButton].forEach(function (btn) {
  return registerButton(btn);
});

var Navbar = /*#__PURE__*/function (_AbstractComponent2) {
  _inherits(Navbar, _AbstractComponent2);

  var _super51 = _createSuper(Navbar);

  function Navbar(viewer) {
    var _this48;

    _classCallCheck(this, Navbar);

    _this48 = _super51.call(this, viewer, {
      className: "psv-navbar psv--capture-event"
    });
    _this48.collapsed = [];
    _this48.state.visible = false;
    return _this48;
  }

  _createClass(Navbar, [{
    key: "show",
    value: function show() {
      this.container.classList.add("psv-navbar--open");
      this.state.visible = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.container.classList.remove("psv-navbar--open");
      this.state.visible = false;
    }
  }, {
    key: "setButtons",
    value: function setButtons(buttons) {
      var _this49 = this;

      this.children.slice().forEach(function (item) {
        return item.destroy();
      });
      this.children.length = 0;

      if (buttons.indexOf(NavbarCaption.id) !== -1 && buttons.indexOf(DescriptionButton.id) === -1) {
        buttons.splice(buttons.indexOf(NavbarCaption.id), 0, DescriptionButton.id);
      }

      buttons.forEach(function (button) {
        if (_typeof(button) === "object") {
          new CustomButton(_this49, button);
        } else if (AVAILABLE_BUTTONS[button]) {
          new AVAILABLE_BUTTONS[button](_this49);
        } else if (AVAILABLE_GROUPS[button]) {
          AVAILABLE_GROUPS[button].forEach(function (buttonCtor) {
            new buttonCtor(_this49);
          });
        } else {
          _logWarn("Unknown button ".concat(button));
        }
      });
      new MenuButton(this);
      this.children.forEach(function (item) {
        if (item instanceof AbstractButton) {
          item.checkSupported();
        }
      });
      this.autoSize();
    }
  }, {
    key: "setCaption",
    value: function setCaption(html) {
      this.children.some(function (item) {
        if (item instanceof NavbarCaption) {
          item.setCaption(html);
          return true;
        }
      });
    }
  }, {
    key: "getButton",
    value: function getButton(id) {
      var warnNotFound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var button = this.children.find(function (item) {
        return item instanceof AbstractButton && item.id === id;
      });

      if (!button && warnNotFound) {
        _logWarn("button \"".concat(id, "\" not found in the navbar"));
      }

      return button;
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      var _this$getButton;

      this.children.forEach(function (child) {
        if (child instanceof AbstractButton) {
          child.autoSize();
        }
      });
      var availableWidth = this.container.offsetWidth;
      var totalWidth = 0;
      var collapsableButtons = [];
      this.children.forEach(function (item) {
        if (item.isVisible() && item instanceof AbstractButton) {
          totalWidth += item.width;

          if (item.collapsable) {
            collapsableButtons.push(item);
          }
        }
      });

      if (totalWidth === 0) {
        return;
      }

      if (availableWidth < totalWidth && collapsableButtons.length > 0) {
        collapsableButtons.forEach(function (item) {
          return item.collapse();
        });
        this.collapsed = collapsableButtons;
        this.getButton(MenuButton.id).show(false);
      } else if (availableWidth >= totalWidth && this.collapsed.length > 0) {
        this.collapsed.forEach(function (item) {
          return item.uncollapse();
        });
        this.collapsed = [];
        this.getButton(MenuButton.id).hide(false);
      }

      (_this$getButton = this.getButton(NavbarCaption.id, false)) === null || _this$getButton === void 0 ? void 0 : _this$getButton.autoSize();
    }
  }]);

  return Navbar;
}(AbstractComponent); // src/components/Loader.ts


var Loader = /*#__PURE__*/function (_AbstractComponent3) {
  _inherits(Loader, _AbstractComponent3);

  var _super52 = _createSuper(Loader);

  function Loader(viewer) {
    var _this50;

    _classCallCheck(this, Loader);

    _this50 = _super52.call(this, viewer, {
      className: "psv-loader-container"
    });
    _this50.loader = document.createElement("div");
    _this50.loader.className = "psv-loader";

    _this50.container.appendChild(_this50.loader);

    _this50.size = _this50.loader.offsetWidth;
    _this50.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    _this50.canvas.setAttribute("class", "psv-loader-canvas");

    _this50.canvas.setAttribute("viewBox", "0 0 ".concat(_this50.size, " ").concat(_this50.size));

    _this50.loader.appendChild(_this50.canvas);

    _this50.textColor = _getStyle(_this50.loader, "color");
    _this50.color = _getStyle(_this50.canvas, "color");
    _this50.border = parseInt(_getStyle(_this50.loader, "outlineWidth"), 10);
    _this50.thickness = parseInt(_getStyle(_this50.canvas, "outlineWidth"), 10);

    _this50.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this50));

    _this50.__updateContent();

    _this50.hide();

    return _this50;
  }

  _createClass(Loader, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);

      _get(_getPrototypeOf(Loader.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ConfigChangedEvent2) {
        e.containsOptions("loadingImg", "loadingTxt") && this.__updateContent();
      }
    }
  }, {
    key: "setProgress",
    value: function setProgress(value) {
      var angle = Math.min(value, 99.999) / 100 * Math.PI * 2;
      var halfSize = this.size / 2;
      var startX = halfSize;
      var startY = this.thickness / 2 + this.border;
      var radius = (this.size - this.thickness) / 2 - this.border;
      var endX = Math.sin(angle) * radius + halfSize;
      var endY = -Math.cos(angle) * radius + halfSize;
      var largeArc = value > 50 ? "1" : "0";
      this.canvas.innerHTML = "\n            <circle cx=\"".concat(halfSize, "\" cy=\"").concat(halfSize, "\" r=\"").concat(halfSize, "\" fill=\"").concat(this.color, "\"/>\n            <path d=\"M ").concat(startX, " ").concat(startY, " A ").concat(radius, " ").concat(radius, " 0 ").concat(largeArc, " 1 ").concat(endX, " ").concat(endY, "\" \n                  fill=\"none\" stroke=\"").concat(this.textColor, "\" stroke-width=\"").concat(this.thickness, "\" stroke-linecap=\"round\"/>\n        ");
      this.viewer.dispatchEvent(new _LoadProgressEvent2(Math.round(value)));
    }
  }, {
    key: "__updateContent",
    value: function __updateContent() {
      var current = this.loader.querySelector(".psv-loader-image, .psv-loader-text");

      if (current) {
        this.loader.removeChild(current);
      }

      var inner;

      if (this.viewer.config.loadingImg) {
        inner = document.createElement("img");
        inner.className = "psv-loader-image";
        inner.src = this.viewer.config.loadingImg;
      } else if (this.viewer.config.loadingTxt) {
        inner = document.createElement("div");
        inner.className = "psv-loader-text";
        inner.innerHTML = this.viewer.config.loadingTxt;
      }

      if (inner) {
        var size = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
        inner.style.maxWidth = size + "px";
        inner.style.maxHeight = size + "px";
        this.loader.appendChild(inner);
      }
    }
  }]);

  return Loader;
}(AbstractComponent); // src/components/Notification.ts


var Notification = /*#__PURE__*/function (_AbstractComponent4) {
  _inherits(Notification, _AbstractComponent4);

  var _super53 = _createSuper(Notification);

  function Notification(viewer) {
    var _this51;

    _classCallCheck(this, Notification);

    _this51 = _super53.call(this, viewer, {
      className: "psv-notification"
    });
    _this51.state = {
      visible: false,
      contentId: null,
      timeout: null
    };
    _this51.content = document.createElement("div");
    _this51.content.className = "psv-notification-content";

    _this51.container.appendChild(_this51.content);

    _this51.content.addEventListener("click", function () {
      return _this51.hide();
    });

    return _this51;
  }

  _createClass(Notification, [{
    key: "isVisible",
    value: function isVisible(id) {
      return this.state.visible && (!id || !this.state.contentId || this.state.contentId === id);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Notification cannot be toggled");
    }
  }, {
    key: "show",
    value: function show(config) {
      var _this52 = this;

      if (this.state.timeout) {
        clearTimeout(this.state.timeout);
        this.state.timeout = null;
      }

      if (typeof config === "string") {
        config = {
          content: config
        };
      }

      this.state.contentId = config.id || null;
      this.content.innerHTML = config.content;
      this.container.classList.add("psv-notification--visible");
      this.state.visible = true;
      this.viewer.dispatchEvent(new _ShowNotificationEvent2(config.id));

      if (config.timeout) {
        this.state.timeout = setTimeout(function () {
          return _this52.hide(_this52.state.contentId);
        }, config.timeout);
      }
    }
  }, {
    key: "hide",
    value: function hide(id) {
      if (this.isVisible(id)) {
        var contentId = this.state.contentId;
        this.container.classList.remove("psv-notification--visible");
        this.state.visible = false;
        this.state.contentId = null;
        this.viewer.dispatchEvent(new _HideNotificationEvent2(contentId));
      }
    }
  }]);

  return Notification;
}(AbstractComponent); // src/components/Overlay.ts


var Overlay = /*#__PURE__*/function (_AbstractComponent5) {
  _inherits(Overlay, _AbstractComponent5);

  var _super54 = _createSuper(Overlay);

  function Overlay(viewer) {
    var _thisSuper2, _this53;

    _classCallCheck(this, Overlay);

    _this53 = _super54.call(this, viewer, {
      className: "psv-overlay"
    });
    _this53.state = {
      visible: false,
      contentId: null,
      dissmisable: true
    };
    _this53.image = document.createElement("div");
    _this53.image.className = "psv-overlay-image";

    _this53.container.appendChild(_this53.image);

    _this53.title = document.createElement("div");
    _this53.title.className = "psv-overlay-title";

    _this53.container.appendChild(_this53.title);

    _this53.text = document.createElement("div");
    _this53.text.className = "psv-overlay-text";

    _this53.container.appendChild(_this53.text);

    _this53.viewer.addEventListener(_ClickEvent2.type, _assertThisInitialized(_this53));

    _this53.viewer.addEventListener(_KeypressEvent2.type, _assertThisInitialized(_this53));

    _get((_thisSuper2 = _assertThisInitialized(_this53), _getPrototypeOf(Overlay.prototype)), "hide", _thisSuper2).call(_thisSuper2);

    return _this53;
  }

  _createClass(Overlay, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_ClickEvent2.type, this);
      this.viewer.removeEventListener(_KeypressEvent2.type, this);

      _get(_getPrototypeOf(Overlay.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ClickEvent2) {
        if (this.isVisible() && this.state.dissmisable) {
          this.hide();
          e.stopPropagation();
        }
      } else if (e instanceof _KeypressEvent2) {
        if (this.isVisible() && this.state.dissmisable && e.key === _KEY_CODES.Escape) {
          this.hide();
          e.preventDefault();
        }
      }
    }
  }, {
    key: "isVisible",
    value: function isVisible(id) {
      return this.state.visible && (!id || !this.state.contentId || this.state.contentId === id);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Overlay cannot be toggled");
    }
  }, {
    key: "show",
    value: function show(config) {
      if (typeof config === "string") {
        config = {
          title: config
        };
      }

      this.state.contentId = config.id || null;
      this.state.dissmisable = config.dissmisable !== false;
      this.image.innerHTML = config.image || "";
      this.title.innerHTML = config.title || "";
      this.text.innerHTML = config.text || "";

      _get(_getPrototypeOf(Overlay.prototype), "show", this).call(this);

      this.viewer.dispatchEvent(new _ShowOverlayEvent2(config.id));
    }
  }, {
    key: "hide",
    value: function hide(id) {
      if (this.isVisible(id)) {
        var contentId = this.state.contentId;

        _get(_getPrototypeOf(Overlay.prototype), "hide", this).call(this);

        this.state.contentId = null;
        this.viewer.dispatchEvent(new _HideOverlayEvent2(contentId));
      }
    }
  }]);

  return Overlay;
}(AbstractComponent); // src/components/Panel.ts


var PANEL_MIN_WIDTH = 200;
var PANEL_CLASS_NO_INTERACTION = "psv-panel-content--no-interaction";

var Panel = /*#__PURE__*/function (_AbstractComponent6) {
  _inherits(Panel, _AbstractComponent6);

  var _super55 = _createSuper(Panel);

  function Panel(viewer) {
    var _this54;

    _classCallCheck(this, Panel);

    _this54 = _super55.call(this, viewer, {
      className: "psv-panel psv--capture-event"
    });
    _this54.state = {
      visible: false,
      contentId: null,
      mouseX: 0,
      mouseY: 0,
      mousedown: false,
      clickHandler: null,
      keyHandler: null,
      width: {}
    };
    var resizer = document.createElement("div");
    resizer.className = "psv-panel-resizer";

    _this54.container.appendChild(resizer);

    var closeBtn = document.createElement("div");
    closeBtn.className = "psv-panel-close-button";

    _this54.container.appendChild(closeBtn);

    _this54.content = document.createElement("div");
    _this54.content.className = "psv-panel-content";

    _this54.container.appendChild(_this54.content);

    _this54.container.addEventListener("wheel", function (e) {
      return e.stopPropagation();
    });

    closeBtn.addEventListener("click", function () {
      return _this54.hide();
    });
    resizer.addEventListener("mousedown", _assertThisInitialized(_this54));
    resizer.addEventListener("touchstart", _assertThisInitialized(_this54));

    _this54.viewer.container.addEventListener("mouseup", _assertThisInitialized(_this54));

    _this54.viewer.container.addEventListener("touchend", _assertThisInitialized(_this54));

    _this54.viewer.container.addEventListener("mousemove", _assertThisInitialized(_this54));

    _this54.viewer.container.addEventListener("touchmove", _assertThisInitialized(_this54));

    _this54.viewer.addEventListener(_KeypressEvent2.type, _assertThisInitialized(_this54));

    return _this54;
  }

  _createClass(Panel, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(_KeypressEvent2.type, this);
      this.viewer.container.removeEventListener("mousemove", this);
      this.viewer.container.removeEventListener("touchmove", this);
      this.viewer.container.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchend", this);

      _get(_getPrototypeOf(Panel.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case "mousedown":
          this.__onMouseDown(e);

          break;

        case "touchstart":
          this.__onTouchStart(e);

          break;

        case "mousemove":
          this.__onMouseMove(e);

          break;

        case "touchmove":
          this.__onTouchMove(e);

          break;

        case "mouseup":
          this.__onMouseUp(e);

          break;

        case "touchend":
          this.__onTouchEnd(e);

          break;

        case _KeypressEvent2.type:
          this.__onKeyPress(e);

          break;
      }
    }
  }, {
    key: "isVisible",
    value: function isVisible(id) {
      return this.state.visible && (!id || !this.state.contentId || this.state.contentId === id);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Panel cannot be toggled");
    }
  }, {
    key: "show",
    value: function show(config) {
      var _this55 = this;

      if (typeof config === "string") {
        config = {
          content: config
        };
      }

      var wasVisible = this.isVisible(config.id);
      this.state.contentId = config.id || null;
      this.state.visible = true;

      if (this.state.clickHandler) {
        this.content.removeEventListener("click", this.state.clickHandler);
        this.content.removeEventListener("keydown", this.state.keyHandler);
        this.state.clickHandler = null;
        this.state.keyHandler = null;
      }

      if (config.id && this.state.width[config.id]) {
        this.container.style.width = this.state.width[config.id];
      } else if (config.width) {
        this.container.style.width = config.width;
      } else {
        this.container.style.width = null;
      }

      this.content.innerHTML = config.content;
      this.content.scrollTop = 0;
      this.container.classList.add("psv-panel--open");

      _toggleClass(this.content, "psv-panel-content--no-margin", config.noMargin === true);

      if (config.clickHandler) {
        this.state.clickHandler = function (e) {
          config.clickHandler(e.target);
        };

        this.state.keyHandler = function (e) {
          if (e.key === _KEY_CODES.Enter) {
            config.clickHandler(e.target);
          }
        };

        this.content.addEventListener("click", this.state.clickHandler);
        this.content.addEventListener("keydown", this.state.keyHandler);

        if (!wasVisible) {
          setTimeout(function () {
            var _this55$content$query;

            (_this55$content$query = _this55.content.querySelector("a,button,[tabindex]")) === null || _this55$content$query === void 0 ? void 0 : _this55$content$query.focus();
          }, 300);
        }
      }

      this.viewer.dispatchEvent(new _ShowPanelEvent2(config.id));
    }
  }, {
    key: "hide",
    value: function hide(id) {
      if (this.isVisible(id)) {
        var contentId = this.state.contentId;
        this.state.visible = false;
        this.state.contentId = null;
        this.content.innerHTML = null;
        this.container.classList.remove("psv-panel--open");

        if (this.state.clickHandler) {
          this.content.removeEventListener("click", this.state.clickHandler);
          this.state.clickHandler = null;
        }

        this.viewer.dispatchEvent(new _HidePanelEvent2(contentId));
      }
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown(evt) {
      evt.stopPropagation();

      this.__startResize(evt.clientX, evt.clientY);
    }
  }, {
    key: "__onTouchStart",
    value: function __onTouchStart(evt) {
      evt.stopPropagation();

      if (evt.touches.length === 1) {
        var touch = evt.touches[0];

        this.__startResize(touch.clientX, touch.clientY);
      }
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp(evt) {
      if (this.state.mousedown) {
        evt.stopPropagation();
        this.state.mousedown = false;
        this.content.classList.remove(PANEL_CLASS_NO_INTERACTION);
      }
    }
  }, {
    key: "__onTouchEnd",
    value: function __onTouchEnd(evt) {
      if (this.state.mousedown) {
        evt.stopPropagation();

        if (evt.touches.length === 0) {
          this.state.mousedown = false;
          this.content.classList.remove(PANEL_CLASS_NO_INTERACTION);
        }
      }
    }
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(evt) {
      if (this.state.mousedown) {
        evt.stopPropagation();

        this.__resize(evt.clientX, evt.clientY);
      }
    }
  }, {
    key: "__onTouchMove",
    value: function __onTouchMove(evt) {
      if (this.state.mousedown) {
        var touch = evt.touches[0];

        this.__resize(touch.clientX, touch.clientY);
      }
    }
  }, {
    key: "__onKeyPress",
    value: function __onKeyPress(evt) {
      if (this.isVisible() && evt.key === _KEY_CODES.Escape) {
        this.hide();
        evt.preventDefault();
      }
    }
  }, {
    key: "__startResize",
    value: function __startResize(clientX, clientY) {
      this.state.mouseX = clientX;
      this.state.mouseY = clientY;
      this.state.mousedown = true;
      this.content.classList.add(PANEL_CLASS_NO_INTERACTION);
    }
  }, {
    key: "__resize",
    value: function __resize(clientX, clientY) {
      var x = clientX;
      var y = clientY;
      var width = Math.max(PANEL_MIN_WIDTH, this.container.offsetWidth - (x - this.state.mouseX)) + "px";

      if (this.state.contentId) {
        this.state.width[this.state.contentId] = width;
      }

      this.container.style.width = width;
      this.state.mouseX = x;
      this.state.mouseY = y;
    }
  }]);

  return Panel;
}(AbstractComponent); // src/components/Tooltip.ts


var Tooltip = /*#__PURE__*/function (_AbstractComponent7) {
  _inherits(Tooltip, _AbstractComponent7);

  var _super56 = _createSuper(Tooltip);

  function Tooltip(viewer, config) {
    var _this56;

    _classCallCheck(this, Tooltip);

    _this56 = _super56.call(this, viewer, {
      className: "psv-tooltip"
    });
    _this56.state = {
      visible: true,
      arrow: 0,
      border: 0,
      state: 0
      /* NONE */
      ,
      width: 0,
      height: 0,
      pos: "",
      config: null,
      data: null
    };
    _this56.content = document.createElement("div");
    _this56.content.className = "psv-tooltip-content";

    _this56.container.appendChild(_this56.content);

    _this56.arrow = document.createElement("div");
    _this56.arrow.className = "psv-tooltip-arrow";

    _this56.container.appendChild(_this56.arrow);

    _this56.container.addEventListener("transitionend", _assertThisInitialized(_this56));

    _this56.container.style.top = "-1000px";
    _this56.container.style.left = "-1000px";

    _this56.show(config);

    return _this56;
  }

  _createClass(Tooltip, [{
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e.type === "transitionend") {
        this.__onTransitionEnd(e);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      delete this.state.data;

      _get(_getPrototypeOf(Tooltip.prototype), "destroy", this).call(this);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      throw new PSVError("Tooltip cannot be toggled");
    }
  }, {
    key: "show",
    value: function show(config) {
      if (this.state.state !== 0
      /* NONE */
      ) {
        throw new PSVError("Initialized tooltip cannot be re-initialized");
      }

      if (config.className) {
        _addClasses(this.container, config.className);
      }

      this.state.state = 3
      /* READY */
      ;
      this.update(config.content, config);
      this.state.data = config.data;
      this.state.state = 1
      /* SHOWING */
      ;
      this.viewer.dispatchEvent(new _ShowTooltipEvent2(this, this.state.data));

      this.__waitImages();
    }
  }, {
    key: "update",
    value: function update(content, config) {
      this.content.innerHTML = content;
      var rect = this.container.getBoundingClientRect();
      this.state.width = rect.right - rect.left;
      this.state.height = rect.bottom - rect.top;
      this.state.arrow = parseInt(_getStyle(this.arrow, "borderTopWidth"), 10);
      this.state.border = parseInt(_getStyle(this.container, "borderTopLeftRadius"), 10);
      this.move(config !== null && config !== void 0 ? config : this.state.config);
    }
  }, {
    key: "move",
    value: function move(config) {
      if (this.state.state !== 1
      /* SHOWING */
      && this.state.state !== 3
      /* READY */
      ) {
        throw new PSVError("Uninitialized tooltip cannot be moved");
      }

      if (!config.box) {
        config.box = {
          width: 0,
          height: 0
        };
      }

      this.state.config = config;
      var t = this.container;
      var a = this.arrow;
      var style = {
        posClass: _cleanCssPosition(config.position, {
          allowCenter: false,
          cssOrder: false
        }) || ["top", "center"],
        width: this.state.width,
        height: this.state.height,
        top: 0,
        left: 0,
        arrowTop: 0,
        arrowLeft: 0
      };

      this.__computeTooltipPosition(style, config);

      var swapY = null;
      var swapX = null;

      if (style.top < 0) {
        swapY = "bottom";
      } else if (style.top + style.height > this.viewer.state.size.height) {
        swapY = "top";
      }

      if (style.left < 0) {
        swapX = "right";
      } else if (style.left + style.width > this.viewer.state.size.width) {
        swapX = "left";
      }

      if (swapX || swapY) {
        var ordered = _cssPositionIsOrdered(style.posClass);

        if (swapY) {
          style.posClass[ordered ? 0 : 1] = swapY;
        }

        if (swapX) {
          style.posClass[ordered ? 1 : 0] = swapX;
        }

        this.__computeTooltipPosition(style, config);
      }

      t.style.top = style.top + "px";
      t.style.left = style.left + "px";
      a.style.top = style.arrowTop + "px";
      a.style.left = style.arrowLeft + "px";
      var newPos = style.posClass.join("-");

      if (newPos !== this.state.pos) {
        t.classList.remove("psv-tooltip--".concat(this.state.pos));
        this.state.pos = newPos;
        t.classList.add("psv-tooltip--".concat(this.state.pos));
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.container.classList.remove("psv-tooltip--visible");
      this.state.state = 2
      /* HIDING */
      ;
      this.viewer.dispatchEvent(new _HideTooltipEvent2(this.state.data));
    }
  }, {
    key: "__onTransitionEnd",
    value: function __onTransitionEnd(e) {
      if (e.propertyName === "transform") {
        switch (this.state.state) {
          case 1
          /* SHOWING */
          :
            this.container.classList.add("psv-tooltip--visible");
            this.state.state = 3
            /* READY */
            ;
            break;

          case 2
          /* HIDING */
          :
            this.state.state = 0
            /* NONE */
            ;
            this.destroy();
            break;
        }
      }
    }
  }, {
    key: "__computeTooltipPosition",
    value: function __computeTooltipPosition(style, config) {
      var arrow = this.state.arrow;
      var top = config.top;
      var height = style.height;
      var left = config.left;
      var width = style.width;
      var offsetSide = arrow + this.state.border;
      var offsetX = config.box.width / 2 + arrow * 2;
      var offsetY = config.box.height / 2 + arrow * 2;

      switch (style.posClass.join("-")) {
        case "top-left":
          style.top = top - offsetY - height;
          style.left = left + offsetSide - width;
          style.arrowTop = height;
          style.arrowLeft = width - offsetSide - arrow;
          break;

        case "top-center":
          style.top = top - offsetY - height;
          style.left = left - width / 2;
          style.arrowTop = height;
          style.arrowLeft = width / 2 - arrow;
          break;

        case "top-right":
          style.top = top - offsetY - height;
          style.left = left - offsetSide;
          style.arrowTop = height;
          style.arrowLeft = arrow;
          break;

        case "bottom-left":
          style.top = top + offsetY;
          style.left = left + offsetSide - width;
          style.arrowTop = -arrow * 2;
          style.arrowLeft = width - offsetSide - arrow;
          break;

        case "bottom-center":
          style.top = top + offsetY;
          style.left = left - width / 2;
          style.arrowTop = -arrow * 2;
          style.arrowLeft = width / 2 - arrow;
          break;

        case "bottom-right":
          style.top = top + offsetY;
          style.left = left - offsetSide;
          style.arrowTop = -arrow * 2;
          style.arrowLeft = arrow;
          break;

        case "left-top":
          style.top = top + offsetSide - height;
          style.left = left - offsetX - width;
          style.arrowTop = height - offsetSide - arrow;
          style.arrowLeft = width;
          break;

        case "center-left":
          style.top = top - height / 2;
          style.left = left - offsetX - width;
          style.arrowTop = height / 2 - arrow;
          style.arrowLeft = width;
          break;

        case "left-bottom":
          style.top = top - offsetSide;
          style.left = left - offsetX - width;
          style.arrowTop = arrow;
          style.arrowLeft = width;
          break;

        case "right-top":
          style.top = top + offsetSide - height;
          style.left = left + offsetX;
          style.arrowTop = height - offsetSide - arrow;
          style.arrowLeft = -arrow * 2;
          break;

        case "center-right":
          style.top = top - height / 2;
          style.left = left + offsetX;
          style.arrowTop = height / 2 - arrow;
          style.arrowLeft = -arrow * 2;
          break;

        case "right-bottom":
          style.top = top - offsetSide;
          style.left = left + offsetX;
          style.arrowTop = arrow;
          style.arrowLeft = -arrow * 2;
          break;
      }
    }
  }, {
    key: "__waitImages",
    value: function __waitImages() {
      var _this57 = this;

      var images = this.content.querySelectorAll("img");

      if (images.length > 0) {
        var promises = [];
        images.forEach(function (image) {
          promises.push(new Promise(function (resolve) {
            image.onload = resolve;
            image.onerror = resolve;
          }));
        });
        Promise.all(promises).then(function () {
          if (_this57.state.state === 1
          /* SHOWING */
          || _this57.state.state === 3
          /* READY */
          ) {
            var rect = _this57.container.getBoundingClientRect();

            _this57.state.width = rect.right - rect.left;
            _this57.state.height = rect.bottom - rect.top;

            _this57.move(_this57.state.config);
          }
        });
      }
    }
  }]);

  return Tooltip;
}(AbstractComponent); // src/icons/error.svg


var error_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/><!--Created by Shastry from the Noun Project--></svg>\n'; // src/services/AbstractService.ts

var AbstractService = /*#__PURE__*/function () {
  function AbstractService(viewer) {
    _classCallCheck(this, AbstractService);

    this.viewer = viewer;
    this.config = viewer.config;
    this.state = viewer.state;
  }

  _createClass(AbstractService, [{
    key: "destroy",
    value: function destroy() {}
  }]);

  return AbstractService;
}(); // src/services/DataHelper.ts


var vector3 = new Vector3();
var EULER_ZERO = new Euler(0, 0, 0, "ZXY");

var DataHelper = /*#__PURE__*/function (_AbstractService) {
  _inherits(DataHelper, _AbstractService);

  var _super57 = _createSuper(DataHelper);

  function DataHelper(viewer) {
    _classCallCheck(this, DataHelper);

    return _super57.call(this, viewer);
  }

  _createClass(DataHelper, [{
    key: "fovToZoomLevel",
    value: function fovToZoomLevel(fov) {
      var temp = Math.round((fov - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
      return temp - 2 * (temp - 50);
    }
  }, {
    key: "zoomLevelToFov",
    value: function zoomLevelToFov(level) {
      return this.config.maxFov + level / 100 * (this.config.minFov - this.config.maxFov);
    }
  }, {
    key: "vFovToHFov",
    value: function vFovToHFov(vFov) {
      return MathUtils.radToDeg(2 * Math.atan(Math.tan(MathUtils.degToRad(vFov) / 2) * this.state.aspect));
    }
  }, {
    key: "speedToDuration",
    value: function speedToDuration(value, angle) {
      if (typeof value !== "number") {
        var speed = _parseSpeed(value);

        return angle / Math.abs(speed) * 1e3;
      } else {
        return Math.abs(value);
      }
    }
  }, {
    key: "textureCoordsToSphericalCoords",
    value: function textureCoordsToSphericalCoords(point) {
      var panoData = this.state.panoData;

      if (!panoData) {
        throw new PSVError("Current adapter does not support texture coordinates.");
      }

      var relativeX = (point.textureX + panoData.croppedX) / panoData.fullWidth * Math.PI * 2;
      var relativeY = (point.textureY + panoData.croppedY) / panoData.fullHeight * Math.PI;
      var result = {
        yaw: relativeX >= Math.PI ? relativeX - Math.PI : relativeX + Math.PI,
        pitch: Math.PI / 2 - relativeY
      };

      if (!EULER_ZERO.equals(this.viewer.renderer.panoramaPose) || !EULER_ZERO.equals(this.viewer.renderer.sphereCorrection)) {
        this.sphericalCoordsToVector3(result, vector3);
        vector3.applyEuler(this.viewer.renderer.panoramaPose);
        vector3.applyEuler(this.viewer.renderer.sphereCorrection);
        return this.vector3ToSphericalCoords(vector3);
      } else {
        return result;
      }
    }
  }, {
    key: "sphericalCoordsToTextureCoords",
    value: function sphericalCoordsToTextureCoords(position) {
      var panoData = this.state.panoData;

      if (!panoData) {
        throw new PSVError("Current adapter does not support texture coordinates.");
      }

      if (!EULER_ZERO.equals(this.viewer.renderer.panoramaPose) || !EULER_ZERO.equals(this.viewer.renderer.sphereCorrection)) {
        this.sphericalCoordsToVector3(position, vector3);

        _applyEulerInverse(vector3, this.viewer.renderer.sphereCorrection);

        _applyEulerInverse(vector3, this.viewer.renderer.panoramaPose);

        position = this.vector3ToSphericalCoords(vector3);
      }

      var relativeLong = position.yaw / Math.PI / 2 * panoData.fullWidth;
      var relativeLat = position.pitch / Math.PI * panoData.fullHeight;
      return {
        textureX: Math.round(position.yaw < Math.PI ? relativeLong + panoData.fullWidth / 2 : relativeLong - panoData.fullWidth / 2) - panoData.croppedX,
        textureY: Math.round(panoData.fullHeight / 2 - relativeLat) - panoData.croppedY
      };
    }
  }, {
    key: "sphericalCoordsToVector3",
    value: function sphericalCoordsToVector3(position, vector) {
      if (!vector) {
        vector = new Vector3();
      }

      vector.x = _SPHERE_RADIUS * -Math.cos(position.pitch) * Math.sin(position.yaw);
      vector.y = _SPHERE_RADIUS * Math.sin(position.pitch);
      vector.z = _SPHERE_RADIUS * Math.cos(position.pitch) * Math.cos(position.yaw);
      return vector;
    }
  }, {
    key: "vector3ToSphericalCoords",
    value: function vector3ToSphericalCoords(vector) {
      var phi = Math.acos(vector.y / Math.sqrt(vector.x * vector.x + vector.y * vector.y + vector.z * vector.z));
      var theta = Math.atan2(vector.x, vector.z);
      return {
        yaw: theta < 0 ? -theta : Math.PI * 2 - theta,
        pitch: Math.PI / 2 - phi
      };
    }
  }, {
    key: "viewerCoordsToVector3",
    value: function viewerCoordsToVector3(viewerPoint) {
      var sphereIntersect = this.viewer.renderer.getIntersections(viewerPoint).filter(function (i) {
        return i.object.userData[_VIEWER_DATA];
      });

      if (sphereIntersect.length) {
        return sphereIntersect[0].point;
      } else {
        return null;
      }
    }
  }, {
    key: "vector3ToViewerCoords",
    value: function vector3ToViewerCoords(vector) {
      var vectorClone = vector.clone();
      vectorClone.project(this.viewer.renderer.camera);
      return {
        x: Math.round((vectorClone.x + 1) / 2 * this.state.size.width),
        y: Math.round((1 - vectorClone.y) / 2 * this.state.size.height)
      };
    }
  }, {
    key: "sphericalCoordsToViewerCoords",
    value: function sphericalCoordsToViewerCoords(position) {
      this.sphericalCoordsToVector3(position, vector3);
      return this.vector3ToViewerCoords(vector3);
    }
  }, {
    key: "cleanPosition",
    value: function cleanPosition(position) {
      if ("x" in position && "y" in position) {
        _logWarn("x/y position is deprecated, use textureX/textureY instead");

        return this.textureCoordsToSphericalCoords({
          textureX: position["x"],
          textureY: position["y"]
        });
      }

      if ("longitude" in position && "latitude" in position) {
        _logWarn("longitude/latitude position is deprecated, use yaw/pitch instead");

        return this.cleanPosition({
          yaw: position["longitude"],
          pitch: position["latitude"]
        });
      }

      if (position.textureX !== void 0 && position.textureY !== void 0) {
        return this.textureCoordsToSphericalCoords(position);
      }

      return {
        yaw: _parseAngle(position.yaw),
        pitch: _parseAngle(position.pitch, !this.state.littlePlanet)
      };
    }
  }, {
    key: "cleanSphereCorrection",
    value: function cleanSphereCorrection(sphereCorrection) {
      return {
        pan: _parseAngle((sphereCorrection === null || sphereCorrection === void 0 ? void 0 : sphereCorrection.pan) || 0),
        tilt: _parseAngle((sphereCorrection === null || sphereCorrection === void 0 ? void 0 : sphereCorrection.tilt) || 0, true),
        roll: _parseAngle((sphereCorrection === null || sphereCorrection === void 0 ? void 0 : sphereCorrection.roll) || 0, true, false)
      };
    }
  }, {
    key: "cleanPanoramaPose",
    value: function cleanPanoramaPose(panoData) {
      return {
        pan: MathUtils.degToRad((panoData === null || panoData === void 0 ? void 0 : panoData.poseHeading) || 0),
        tilt: MathUtils.degToRad((panoData === null || panoData === void 0 ? void 0 : panoData.posePitch) || 0),
        roll: MathUtils.degToRad((panoData === null || panoData === void 0 ? void 0 : panoData.poseRoll) || 0)
      };
    }
  }]);

  return DataHelper;
}(AbstractService); // src/icons/gesture.svg


var gesture_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/><!--Created by AomAm from the Noun Project--></svg>\n'; // src/icons/mousewheel.svg

var mousewheel_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/><!-- Created by Icon Island from the Noun Project --></svg>\n'; // src/services/EventsHandler.ts

var IDLE = 0;
var MOVING = 1;
var INERTIA = 2;

var EventsHandler = /*#__PURE__*/function (_AbstractService2) {
  _inherits(EventsHandler, _AbstractService2);

  var _super58 = _createSuper(EventsHandler);

  function EventsHandler(viewer) {
    var _this58;

    _classCallCheck(this, EventsHandler);

    _this58 = _super58.call(this, viewer);
    _this58.data = {
      step: IDLE,
      mousedown: false,
      startMouseX: 0,
      startMouseY: 0,
      mouseX: 0,
      mouseY: 0,
      mouseHistory: [],
      pinchDist: 0,
      ctrlKeyDown: false,
      dblclickData: null,
      dblclickTimeout: null,
      longtouchTimeout: null,
      twofingersTimeout: null,
      ctrlZoomTimeout: null
    };
    _this58.keyHandler = new PressHandler();
    _this58.resizeObserver = new ResizeObserver(_throttle(function () {
      return _this58.viewer.autoSize();
    }, 50));
    _this58.moveThreshold = _MOVE_THRESHOLD * SYSTEM.pixelRatio;
    return _this58;
  }

  _createClass(EventsHandler, [{
    key: "init",
    value: function init() {
      window.addEventListener("keydown", this, {
        passive: false
      });
      window.addEventListener("keyup", this);
      this.viewer.container.addEventListener("mousedown", this);
      window.addEventListener("mousemove", this, {
        passive: false
      });
      window.addEventListener("mouseup", this);
      this.viewer.container.addEventListener("touchstart", this, {
        passive: false
      });
      window.addEventListener("touchmove", this, {
        passive: false
      });
      window.addEventListener("touchend", this, {
        passive: false
      });
      this.viewer.container.addEventListener("wheel", this, {
        passive: false
      });
      document.addEventListener("fullscreenchange", this);
      this.resizeObserver.observe(this.viewer.container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("keydown", this);
      window.removeEventListener("keyup", this);
      this.viewer.container.removeEventListener("mousedown", this);
      window.removeEventListener("mousemove", this);
      window.removeEventListener("mouseup", this);
      this.viewer.container.removeEventListener("touchstart", this);
      window.removeEventListener("touchmove", this);
      window.removeEventListener("touchend", this);
      this.viewer.container.removeEventListener("wheel", this);
      document.removeEventListener("fullscreenchange", this);
      this.resizeObserver.disconnect();
      clearTimeout(this.data.dblclickTimeout);
      clearTimeout(this.data.longtouchTimeout);
      clearTimeout(this.data.twofingersTimeout);
      clearTimeout(this.data.ctrlZoomTimeout);

      _get(_getPrototypeOf(EventsHandler.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(evt) {
      switch (evt.type) {
        case "keydown":
          this.__onKeyDown(evt);

          break;

        case "keyup":
          this.__onKeyUp();

          break;

        case "mousemove":
          this.__onMouseMove(evt);

          break;

        case "mouseup":
          this.__onMouseUp(evt);

          break;

        case "touchmove":
          this.__onTouchMove(evt);

          break;

        case "touchend":
          this.__onTouchEnd(evt);

          break;

        case "fullscreenchange":
          this.__onFullscreenChange();

          break;
      }

      if (!_getClosest(evt.target, ".psv--capture-event")) {
        switch (evt.type) {
          case "mousedown":
            this.__onMouseDown(evt);

            break;

          case "touchstart":
            this.__onTouchStart(evt);

            break;

          case "wheel":
            this.__onMouseWheel(evt);

            break;
        }
      }
    }
  }, {
    key: "__onKeyDown",
    value: function __onKeyDown(e) {
      if (this.config.mousewheelCtrlKey) {
        this.data.ctrlKeyDown = e.key === _KEY_CODES.Control;

        if (this.data.ctrlKeyDown) {
          clearTimeout(this.data.ctrlZoomTimeout);
          this.viewer.overlay.hide(_IDS.CTRL_ZOOM);
        }
      }

      if (!this.viewer.dispatchEvent(new _KeypressEvent2(e.key))) {
        return;
      }

      if (!this.state.keyboardEnabled) {
        return;
      }

      var action = this.config.keyboard[e.key];

      if (action && !this.keyHandler.pending) {
        if (action !== "ZOOM_IN"
        /* ZOOM_IN */
        && action !== "ZOOM_OUT"
        /* ZOOM_OUT */
        ) {
          this.viewer.stopAll();
        }

        switch (action) {
          case "ROTATE_UP"
          /* ROTATE_UP */
          :
            this.viewer.dynamics.position.roll({
              pitch: false
            });
            break;

          case "ROTATE_DOWN"
          /* ROTATE_DOWN */
          :
            this.viewer.dynamics.position.roll({
              pitch: true
            });
            break;

          case "ROTATE_RIGHT"
          /* ROTATE_RIGHT */
          :
            this.viewer.dynamics.position.roll({
              yaw: false
            });
            break;

          case "ROTATE_LEFT"
          /* ROTATE_LEFT */
          :
            this.viewer.dynamics.position.roll({
              yaw: true
            });
            break;

          case "ZOOM_IN"
          /* ZOOM_IN */
          :
            this.viewer.dynamics.zoom.roll(false);
            break;

          case "ZOOM_OUT"
          /* ZOOM_OUT */
          :
            this.viewer.dynamics.zoom.roll(true);
            break;
        }

        this.keyHandler.down();
        e.preventDefault();
      }
    }
  }, {
    key: "__onKeyUp",
    value: function __onKeyUp() {
      var _this59 = this;

      this.data.ctrlKeyDown = false;

      if (!this.state.keyboardEnabled) {
        return;
      }

      this.keyHandler.up(function () {
        _this59.viewer.dynamics.position.stop();

        _this59.viewer.dynamics.zoom.stop();

        _this59.viewer.resetIdleTimer();
      });
    }
  }, {
    key: "__onMouseDown",
    value: function __onMouseDown(evt) {
      this.data.mousedown = true;
      this.data.startMouseX = evt.clientX;
      this.data.startMouseY = evt.clientY;
    }
  }, {
    key: "__onMouseUp",
    value: function __onMouseUp(evt) {
      if (this.data.mousedown || this.data.step === MOVING) {
        this.__stopMove(evt.clientX, evt.clientY, evt.target, evt.button === 2);
      }
    }
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(evt) {
      if (this.config.mousemove && (this.data.mousedown || this.data.step === MOVING)) {
        evt.preventDefault();

        this.__doMove(evt.clientX, evt.clientY);
      }

      this.__handleObjectsEvents(evt);
    }
  }, {
    key: "__onTouchStart",
    value: function __onTouchStart(evt) {
      var _this60 = this;

      if (evt.touches.length === 1) {
        this.data.mousedown = true;
        this.data.startMouseX = evt.touches[0].clientX;
        this.data.startMouseY = evt.touches[0].clientY;

        if (!this.data.longtouchTimeout) {
          this.data.longtouchTimeout = setTimeout(function () {
            var touch = evt.touches[0];

            _this60.__stopMove(touch.clientX, touch.clientY, touch.target, true);

            _this60.data.longtouchTimeout = null;
          }, _LONGTOUCH_DELAY);
        }
      } else if (evt.touches.length === 2) {
        this.data.mousedown = false;

        this.__cancelLongTouch();

        if (this.config.mousemove) {
          this.__cancelTwoFingersOverlay();

          this.__startMoveZoom(evt);

          evt.preventDefault();
        }
      }
    }
  }, {
    key: "__onTouchEnd",
    value: function __onTouchEnd(evt) {
      this.__cancelLongTouch();

      if (this.data.mousedown || this.data.step === MOVING) {
        evt.preventDefault();

        this.__cancelTwoFingersOverlay();

        if (evt.touches.length === 1) {
          this.__stopMove(this.data.mouseX, this.data.mouseY);
        } else if (evt.touches.length === 0) {
          var touch = evt.changedTouches[0];

          this.__stopMove(touch.clientX, touch.clientY, touch.target);
        }
      }
    }
  }, {
    key: "__onTouchMove",
    value: function __onTouchMove(evt) {
      var _this61 = this;

      this.__cancelLongTouch();

      if (!this.config.mousemove) {
        return;
      }

      if (evt.touches.length === 1) {
        if (this.config.touchmoveTwoFingers) {
          if (this.data.mousedown && !this.data.twofingersTimeout) {
            this.data.twofingersTimeout = setTimeout(function () {
              _this61.viewer.overlay.show({
                id: _IDS.TWO_FINGERS,
                image: gesture_default,
                title: _this61.config.lang.twoFingers
              });
            }, _TWOFINGERSOVERLAY_DELAY);
          }
        } else if (this.data.mousedown || this.data.step === MOVING) {
          evt.preventDefault();
          var touch = evt.touches[0];

          this.__doMove(touch.clientX, touch.clientY);
        }
      } else {
        this.__doMoveZoom(evt);

        this.__cancelTwoFingersOverlay();
      }
    }
  }, {
    key: "__cancelLongTouch",
    value: function __cancelLongTouch() {
      if (this.data.longtouchTimeout) {
        clearTimeout(this.data.longtouchTimeout);
        this.data.longtouchTimeout = null;
      }
    }
  }, {
    key: "__cancelTwoFingersOverlay",
    value: function __cancelTwoFingersOverlay() {
      if (this.config.touchmoveTwoFingers) {
        if (this.data.twofingersTimeout) {
          clearTimeout(this.data.twofingersTimeout);
          this.data.twofingersTimeout = null;
        }

        this.viewer.overlay.hide(_IDS.TWO_FINGERS);
      }
    }
  }, {
    key: "__onMouseWheel",
    value: function __onMouseWheel(evt) {
      var _this62 = this;

      if (!this.config.mousewheel) {
        return;
      }

      if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) {
        this.viewer.overlay.show({
          id: _IDS.CTRL_ZOOM,
          image: mousewheel_default,
          title: this.config.lang.ctrlZoom
        });
        clearTimeout(this.data.ctrlZoomTimeout);
        this.data.ctrlZoomTimeout = setTimeout(function () {
          return _this62.viewer.overlay.hide(_IDS.CTRL_ZOOM);
        }, _CTRLZOOM_TIMEOUT);
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();
      var delta = evt.deltaY / Math.abs(evt.deltaY) * 5 * this.config.zoomSpeed;

      if (delta !== 0) {
        this.viewer.dynamics.zoom.step(-delta, 5);
      }
    }
  }, {
    key: "__onFullscreenChange",
    value: function __onFullscreenChange() {
      var fullscreen = this.viewer.isFullscreenEnabled();

      if (this.config.keyboard) {
        if (fullscreen) {
          this.viewer.startKeyboardControl();
        } else {
          this.viewer.stopKeyboardControl();
        }
      }

      this.viewer.dispatchEvent(new _FullscreenEvent2(fullscreen));
    }
  }, {
    key: "__resetMove",
    value: function __resetMove() {
      this.data.step = IDLE;
      this.data.mousedown = false;
      this.data.mouseX = 0;
      this.data.mouseY = 0;
      this.data.startMouseX = 0;
      this.data.startMouseY = 0;
      this.data.mouseHistory.length = 0;
    }
  }, {
    key: "__startMoveZoom",
    value: function __startMoveZoom(evt) {
      this.viewer.stopAll();

      this.__resetMove();

      var p1 = {
        x: evt.touches[0].clientX,
        y: evt.touches[0].clientY
      };
      var p2 = {
        x: evt.touches[1].clientX,
        y: evt.touches[1].clientY
      };
      this.data.step = MOVING;
      this.data.pinchDist = _distance(p1, p2);
      this.data.mouseX = (p1.x + p2.x) / 2;
      this.data.mouseY = (p1.y + p2.y) / 2;

      this.__logMouseMove(this.data.mouseX, this.data.mouseY);
    }
  }, {
    key: "__stopMove",
    value: function __stopMove(clientX, clientY, target) {
      var rightclick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (this.data.step === MOVING) {
        if (this.config.moveInertia) {
          this.__logMouseMove(clientX, clientY);

          this.__stopMoveInertia(clientX, clientY);
        } else {
          this.__resetMove();

          this.viewer.resetIdleTimer();
        }
      } else if (this.data.mousedown) {
        this.viewer.stopAnimation();

        this.__doClick(clientX, clientY, target, rightclick);

        this.__resetMove();

        this.viewer.resetIdleTimer();
      }
    }
  }, {
    key: "__stopMoveInertia",
    value: function __stopMoveInertia(clientX, clientY) {
      var _this63 = this;

      var curve = new SplineCurve(this.data.mouseHistory.map(function (_ref16) {
        var _ref17 = _slicedToArray(_ref16, 3),
            x = _ref17[1],
            y = _ref17[2];

        return new Vector2(x, y);
      }));
      var direction = curve.getTangent(1);
      var speed = this.data.mouseHistory.reduce(function (_ref18, curr) {
        var total = _ref18.total,
            prev = _ref18.prev;
        return {
          total: !prev ? 0 : total + _distance({
            x: prev[1],
            y: prev[2]
          }, {
            x: curr[1],
            y: curr[2]
          }) / (curr[0] - prev[0]),
          prev: curr
        };
      }, {
        total: 0,
        prev: null
      }).total / this.data.mouseHistory.length;

      if (!speed) {
        this.__resetMove();

        this.viewer.resetIdleTimer();
        return;
      }

      this.data.step = INERTIA;
      var currentClientX = clientX;
      var currentClientY = clientY;
      this.state.animation = new _Animation({
        properties: {
          speed: {
            start: speed,
            end: 0
          }
        },
        duration: 1e3,
        easing: "outQuad",
        onTick: function onTick(properties) {
          currentClientX += properties.speed * direction.x * 3 * SYSTEM.pixelRatio;
          currentClientY += properties.speed * direction.y * 3 * SYSTEM.pixelRatio;

          _this63.__applyMove(currentClientX, currentClientY);
        }
      });
      this.state.animation.then(function (done) {
        _this63.state.animation = null;

        if (done) {
          _this63.__resetMove();

          _this63.viewer.resetIdleTimer();
        }
      });
    }
  }, {
    key: "__doClick",
    value: function __doClick(clientX, clientY, target) {
      var _this64 = this;

      var rightclick = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var boundingRect = this.viewer.container.getBoundingClientRect();
      var viewerX = clientX - boundingRect.left;
      var viewerY = clientY - boundingRect.top;
      var intersections = this.viewer.renderer.getIntersections({
        x: viewerX,
        y: viewerY
      });
      var sphereIntersection = intersections.find(function (i) {
        return i.object.userData[_VIEWER_DATA];
      });

      if (sphereIntersection) {
        var sphericalCoords = this.viewer.dataHelper.vector3ToSphericalCoords(sphereIntersection.point);
        var data = {
          rightclick: rightclick,
          target: target,
          clientX: clientX,
          clientY: clientY,
          viewerX: viewerX,
          viewerY: viewerY,
          yaw: sphericalCoords.yaw,
          pitch: sphericalCoords.pitch,
          objects: intersections.map(function (i) {
            return i.object;
          }).filter(function (o) {
            return !o.userData[_VIEWER_DATA];
          })
        };

        try {
          var textureCoords = this.viewer.dataHelper.sphericalCoordsToTextureCoords(data);
          data.textureX = textureCoords.textureX;
          data.textureY = textureCoords.textureY;
        } catch (e) {
          data.textureX = NaN;
          data.textureY = NaN;
        }

        if (!this.data.dblclickTimeout) {
          this.viewer.dispatchEvent(new _ClickEvent2(_positionCompat(data)));
          this.data.dblclickData = _clone(data);
          this.data.dblclickTimeout = setTimeout(function () {
            _this64.data.dblclickTimeout = null;
            _this64.data.dblclickData = null;
          }, _DBLCLICK_DELAY);
        } else {
          if (Math.abs(this.data.dblclickData.clientX - data.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - data.clientY) < this.moveThreshold) {
            this.viewer.dispatchEvent(new _DoubleClickEvent2(_positionCompat(this.data.dblclickData)));
          }

          clearTimeout(this.data.dblclickTimeout);
          this.data.dblclickTimeout = null;
          this.data.dblclickData = null;
        }
      }
    }
  }, {
    key: "__handleObjectsEvents",
    value: function __handleObjectsEvents(evt) {
      var _this65 = this;

      if (!_isEmpty(this.state.objectsObservers) && _hasParent(evt.target, this.viewer.container)) {
        var viewerPos = _getPosition(this.viewer.container);

        var viewerPoint = {
          x: evt.clientX - viewerPos.x,
          y: evt.clientY - viewerPos.y
        };
        var intersections = this.viewer.renderer.getIntersections(viewerPoint);

        var emit = function emit(object, key, evtCtor) {
          _this65.viewer.dispatchEvent(new evtCtor(evt, object, viewerPoint, key));
        };

        var _loop = function _loop() {
          var _Object$entries8$_i = _slicedToArray(_Object$entries8[_i16], 2),
              key = _Object$entries8$_i[0],
              object = _Object$entries8$_i[1];

          var intersection = intersections.find(function (i) {
            return i.object.userData[key];
          });

          if (intersection) {
            if (object && intersection.object !== object) {
              emit(object, key, _ObjectLeaveEvent2);
              _this65.state.objectsObservers[key] = null;
            }

            if (!object) {
              _this65.state.objectsObservers[key] = intersection.object;
              emit(intersection.object, key, _ObjectEnterEvent2);
            } else {
              emit(intersection.object, key, _ObjectHoverEvent2);
            }
          } else if (object) {
            emit(object, key, _ObjectLeaveEvent2);
            _this65.state.objectsObservers[key] = null;
          }
        };

        for (var _i16 = 0, _Object$entries8 = Object.entries(this.state.objectsObservers); _i16 < _Object$entries8.length; _i16++) {
          _loop();
        }
      }
    }
  }, {
    key: "__doMove",
    value: function __doMove(clientX, clientY) {
      if (this.data.mousedown && (Math.abs(clientX - this.data.startMouseX) >= this.moveThreshold || Math.abs(clientY - this.data.startMouseY) >= this.moveThreshold)) {
        this.viewer.stopAll();

        this.__resetMove();

        this.data.step = MOVING;
        this.data.mouseX = clientX;
        this.data.mouseY = clientY;

        this.__logMouseMove(clientX, clientY);
      } else if (this.data.step === MOVING) {
        this.__applyMove(clientX, clientY);

        this.__logMouseMove(clientX, clientY);
      }
    }
  }, {
    key: "__applyMove",
    value: function __applyMove(clientX, clientY) {
      var rotation = {
        yaw: this.config.moveSpeed * ((clientX - this.data.mouseX) / this.state.size.width) * MathUtils.degToRad(this.state.littlePlanet ? 90 : this.state.hFov),
        pitch: this.config.moveSpeed * ((clientY - this.data.mouseY) / this.state.size.height) * MathUtils.degToRad(this.state.littlePlanet ? 90 : this.state.vFov)
      };
      var currentPosition = this.viewer.getPosition();
      this.viewer.rotate({
        yaw: currentPosition.yaw - rotation.yaw,
        pitch: currentPosition.pitch + rotation.pitch
      });
      this.data.mouseX = clientX;
      this.data.mouseY = clientY;
    }
  }, {
    key: "__doMoveZoom",
    value: function __doMoveZoom(evt) {
      if (this.data.step === MOVING) {
        evt.preventDefault();
        var p1 = {
          x: evt.touches[0].clientX,
          y: evt.touches[0].clientY
        };
        var p2 = {
          x: evt.touches[1].clientX,
          y: evt.touches[1].clientY
        };

        var p = _distance(p1, p2);

        var delta = (p - this.data.pinchDist) / SYSTEM.pixelRatio * this.config.zoomSpeed;
        this.viewer.zoom(this.viewer.getZoomLevel() + delta);

        this.__doMove((p1.x + p2.x) / 2, (p1.y + p2.y) / 2);

        this.data.pinchDist = p;
      }
    }
  }, {
    key: "__logMouseMove",
    value: function __logMouseMove(clientX, clientY) {
      var now = Date.now();
      var last = this.data.mouseHistory.length ? this.data.mouseHistory[this.data.mouseHistory.length - 1] : [0, -1, -1];

      if (last[1] === clientX && last[2] === clientY) {
        last[0] = now;
      } else if (now === last[0]) {
        last[1] = clientX;
        last[2] = clientY;
      } else {
        this.data.mouseHistory.push([now, clientX, clientY]);
      }

      var previous = null;

      for (var i = 0; i < this.data.mouseHistory.length;) {
        if (this.data.mouseHistory[i][0] < now - _INERTIA_WINDOW) {
          this.data.mouseHistory.splice(i, 1);
        } else if (previous && this.data.mouseHistory[i][0] - previous > _INERTIA_WINDOW / 10) {
          this.data.mouseHistory.splice(0, i);
          i = 0;
          previous = this.data.mouseHistory[i][0];
        } else {
          previous = this.data.mouseHistory[i][0];
          i++;
        }
      }
    }
  }]);

  return EventsHandler;
}(AbstractService);

var vector2 = new Vector2();

var Renderer = /*#__PURE__*/function (_AbstractService3) {
  _inherits(Renderer, _AbstractService3);

  var _super59 = _createSuper(Renderer);

  function Renderer(viewer) {
    var _this66;

    _classCallCheck(this, Renderer);

    _this66 = _super59.call(this, viewer);
    _this66.renderer = new WebGLRenderer({
      alpha: true,
      antialias: true
    });

    _this66.renderer.setPixelRatio(SYSTEM.pixelRatio);

    _this66.renderer.domElement.className = "psv-canvas";
    _this66.scene = new Scene();
    _this66.camera = new PerspectiveCamera(50, 16 / 9, 0.1, 2 * _SPHERE_RADIUS);
    _this66.mesh = _this66.viewer.adapter.createMesh();
    _this66.mesh.userData = _defineProperty({}, _VIEWER_DATA, true);
    _this66.meshContainer = new Group();

    _this66.meshContainer.add(_this66.mesh);

    _this66.scene.add(_this66.meshContainer);

    _this66.raycaster = new Raycaster();
    _this66.container = document.createElement("div");
    _this66.container.className = "psv-canvas-container";
    _this66.container.style.background = _this66.config.canvasBackground;

    _this66.container.appendChild(_this66.renderer.domElement);

    _this66.viewer.container.appendChild(_this66.container);

    _this66.viewer.addEventListener(_SizeUpdatedEvent2.type, _assertThisInitialized(_this66));

    _this66.viewer.addEventListener(_ZoomUpdatedEvent2.type, _assertThisInitialized(_this66));

    _this66.viewer.addEventListener(_PositionUpdatedEvent2.type, _assertThisInitialized(_this66));

    _this66.viewer.addEventListener(_ConfigChangedEvent2.type, _assertThisInitialized(_this66));

    _this66.hide();

    return _this66;
  }

  _createClass(Renderer, [{
    key: "panoramaPose",
    get: function get() {
      return this.mesh.rotation;
    }
  }, {
    key: "sphereCorrection",
    get: function get() {
      return this.meshContainer.rotation;
    }
  }, {
    key: "init",
    value: function init() {
      var _this67 = this;

      if (this.config.mousemove) {
        this.container.style.cursor = "move";
      }

      this.show();
      this.renderer.setAnimationLoop(function (t) {
        return _this67.__renderLoop(t);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer.setAnimationLoop(null);
      this.cleanScene(this.scene);
      this.viewer.container.removeChild(this.container);
      this.viewer.removeEventListener(_SizeUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_ZoomUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_PositionUpdatedEvent2.type, this);
      this.viewer.removeEventListener(_ConfigChangedEvent2.type, this);

      _get(_getPrototypeOf(Renderer.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case _SizeUpdatedEvent2.type:
          this.__onSizeUpdated();

          break;

        case _ZoomUpdatedEvent2.type:
          this.__onZoomUpdated();

          break;

        case _PositionUpdatedEvent2.type:
          this.__onPositionUpdated();

          break;

        case _ConfigChangedEvent2.type:
          if (e.containsOptions("fisheye")) {
            this.__onPositionUpdated();
          }

          if (e.containsOptions("mousemove")) {
            this.container.style.cursor = this.config.mousemove ? "move" : "default";
          }

          if (e.containsOptions("canvasBackground")) {
            this.container.style.background = this.config.canvasBackground;
          }

          break;
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.container.style.opacity = "0";
    }
  }, {
    key: "show",
    value: function show() {
      this.container.style.opacity = "1";
    }
  }, {
    key: "setCustomRenderer",
    value: function setCustomRenderer(factory) {
      if (factory) {
        this.customRenderer = factory(this.renderer);
      } else {
        this.customRenderer = null;
      }

      this.viewer.needsUpdate();
    }
  }, {
    key: "__onSizeUpdated",
    value: function __onSizeUpdated() {
      this.renderer.setSize(this.state.size.width, this.state.size.height);
      this.camera.aspect = this.state.aspect;
      this.camera.updateProjectionMatrix();
      this.viewer.needsUpdate();
    }
  }, {
    key: "__onZoomUpdated",
    value: function __onZoomUpdated() {
      this.camera.fov = this.state.vFov;
      this.camera.updateProjectionMatrix();
      this.viewer.needsUpdate();
    }
  }, {
    key: "__onPositionUpdated",
    value: function __onPositionUpdated() {
      this.camera.position.set(0, 0, 0);
      this.camera.lookAt(this.state.direction);

      if (this.config.fisheye) {
        this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate();
      }

      this.viewer.needsUpdate();
    }
  }, {
    key: "__renderLoop",
    value: function __renderLoop(timestamp) {
      var elapsed = !this.timestamp ? 0 : timestamp - this.timestamp;
      this.timestamp = timestamp;
      this.viewer.dispatchEvent(new _BeforeRenderEvent2(timestamp, elapsed));
      this.viewer.dynamics.update(elapsed);

      if (this.state.needsUpdate) {
        (this.customRenderer || this.renderer).render(this.scene, this.camera);
        this.viewer.dispatchEvent(new _RenderEvent2());
        this.state.needsUpdate = false;
      }
    }
  }, {
    key: "setTexture",
    value: function setTexture(textureData) {
      this.state.panoData = textureData.panoData;
      this.viewer.adapter.setTexture(this.mesh, textureData);
      this.viewer.needsUpdate();
    }
  }, {
    key: "setOverlay",
    value: function setOverlay(textureData, opacity) {
      this.viewer.adapter.setOverlay(this.mesh, textureData, opacity);
      this.viewer.needsUpdate();
    }
  }, {
    key: "setPanoramaPose",
    value: function setPanoramaPose(panoData) {
      var mesh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mesh;
      var cleanCorrection = this.viewer.dataHelper.cleanPanoramaPose(panoData);
      mesh.rotation.set(-cleanCorrection.tilt, -cleanCorrection.pan, -cleanCorrection.roll, "ZXY");
    }
  }, {
    key: "setSphereCorrection",
    value: function setSphereCorrection(sphereCorrection) {
      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.meshContainer;
      var cleanCorrection = this.viewer.dataHelper.cleanSphereCorrection(sphereCorrection);
      group.rotation.set(cleanCorrection.tilt, cleanCorrection.pan, cleanCorrection.roll, "ZXY");
    }
  }, {
    key: "transition",
    value: function transition(textureData, options) {
      var _this68 = this;

      var positionProvided = _isExtendedPosition(options);

      var zoomProvided = ("zoom" in options);
      var group = new Group();
      var mesh = this.viewer.adapter.createMesh(0.5);
      this.viewer.adapter.setTexture(mesh, textureData, true);
      this.viewer.adapter.setTextureOpacity(mesh, 0);
      this.setPanoramaPose(textureData.panoData, mesh);
      this.setSphereCorrection(options.sphereCorrection, group);

      if (positionProvided) {
        var cleanPosition = this.viewer.dataHelper.cleanPosition(options);
        var currentPosition = this.viewer.getPosition();
        var verticalAxis = new Vector3(0, 1, 0);
        group.rotateOnWorldAxis(verticalAxis, cleanPosition.yaw - currentPosition.yaw);
        var horizontalAxis = new Vector3(0, 1, 0).cross(this.camera.getWorldDirection(new Vector3())).normalize();
        group.rotateOnWorldAxis(horizontalAxis, cleanPosition.pitch - currentPosition.pitch);
      }

      group.add(mesh);
      this.scene.add(group);
      var animation = new _Animation({
        properties: {
          opacity: {
            start: 0,
            end: 1
          },
          zoom: zoomProvided ? {
            start: this.viewer.getZoomLevel(),
            end: options.zoom
          } : void 0
        },
        duration: options.transition,
        easing: "outCubic",
        onTick: function onTick(properties) {
          _this68.viewer.adapter.setTextureOpacity(mesh, properties.opacity);

          _this68.viewer.adapter.setTextureOpacity(_this68.mesh, 1 - properties.opacity);

          if (zoomProvided) {
            _this68.viewer.zoom(properties.zoom);
          }

          _this68.viewer.needsUpdate();
        }
      });
      animation.then(function (completed) {
        if (completed) {
          _this68.setTexture(textureData);

          _this68.viewer.adapter.setTextureOpacity(_this68.mesh, 1);

          _this68.setPanoramaPose(textureData.panoData);

          _this68.setSphereCorrection(options.sphereCorrection);

          if (positionProvided) {
            _this68.viewer.rotate(options);
          }
        } else {
          _this68.viewer.adapter.disposeTexture(textureData);
        }

        _this68.scene.remove(group);

        mesh.geometry.dispose();
        mesh.geometry = null;
      });
      return animation;
    }
  }, {
    key: "getIntersections",
    value: function getIntersections(viewerPoint) {
      vector2.x = 2 * viewerPoint.x / this.state.size.width - 1;
      vector2.y = -2 * viewerPoint.y / this.state.size.height + 1;
      this.raycaster.setFromCamera(vector2, this.camera);
      return this.raycaster.intersectObjects(this.scene.children, true).filter(function (i) {
        return i.object.isMesh && !!i.object.userData;
      });
    }
  }, {
    key: "addObject",
    value: function addObject(object) {
      this.scene.add(object);
    }
  }, {
    key: "removeObject",
    value: function removeObject(object) {
      this.scene.remove(object);
    }
  }, {
    key: "cleanScene",
    value: function cleanScene(object) {
      var _this69 = this;

      object.traverse(function (item) {
        if (item.geometry) {
          item.geometry.dispose();
        }

        if (item.material) {
          if (Array.isArray(item.material)) {
            item.material.forEach(function (material) {
              if (material.map) {
                material.map.dispose();
              }

              material.dispose();
            });
          } else {
            if (item.material.map) {
              item.material.map.dispose();
            }

            item.material.dispose();
          }
        }

        if (item.dispose && !(item instanceof Scene)) {
          item.dispose();
        }

        if (item !== object) {
          _this69.cleanScene(item);
        }
      });
    }
  }]);

  return Renderer;
}(AbstractService);

var TextureLoader = /*#__PURE__*/function (_AbstractService4) {
  _inherits(TextureLoader, _AbstractService4);

  var _super60 = _createSuper(TextureLoader);

  function TextureLoader(viewer) {
    var _this70;

    _classCallCheck(this, TextureLoader);

    _this70 = _super60.call(this, viewer);
    _this70.loader = new FileLoader();

    _this70.loader.setResponseType("blob");

    if (_this70.config.withCredentials) {
      _this70.loader.setWithCredentials(true);
    }

    return _this70;
  }

  _createClass(TextureLoader, [{
    key: "destroy",
    value: function destroy() {
      this.abortLoading();

      _get(_getPrototypeOf(TextureLoader.prototype), "destroy", this).call(this);
    }
  }, {
    key: "abortLoading",
    value: function abortLoading() {}
  }, {
    key: "loadFile",
    value: function loadFile(url, onProgress) {
      var _this71 = this;

      if (this.config.requestHeaders) {
        this.loader.setRequestHeader(this.config.requestHeaders(url));
      }

      return new Promise(function (resolve, reject) {
        var progress = 0;
        onProgress === null || onProgress === void 0 ? void 0 : onProgress(progress);

        _this71.loader.load(url, function (result) {
          progress = 100;
          onProgress === null || onProgress === void 0 ? void 0 : onProgress(progress);
          resolve(result);
        }, function (e) {
          if (e.lengthComputable) {
            var newProgress = e.loaded / e.total * 100;

            if (newProgress > progress) {
              progress = newProgress;
              onProgress === null || onProgress === void 0 ? void 0 : onProgress(progress);
            }
          }
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "loadImage",
    value: function loadImage(url, onProgress) {
      return this.loadFile(url, onProgress).then(function (result) {
        return new Promise(function (resolve, reject) {
          var img = document.createElement("img");

          img.onload = function () {
            URL.revokeObjectURL(img.src);
            resolve(img);
          };

          img.onerror = reject;
          img.src = URL.createObjectURL(result);
        });
      });
    }
  }, {
    key: "preloadPanorama",
    value: function preloadPanorama(panorama) {
      if (this.viewer.adapter.supportsPreload(panorama)) {
        return this.viewer.adapter.loadTexture(panorama);
      } else {
        return Promise.reject(new PSVError("Current adapter does not support preload"));
      }
    }
  }]);

  return TextureLoader;
}(AbstractService);

var ViewerDynamics = /*#__PURE__*/function (_AbstractService5) {
  _inherits(ViewerDynamics, _AbstractService5);

  var _super61 = _createSuper(ViewerDynamics);

  function ViewerDynamics(viewer) {
    var _this72;

    _classCallCheck(this, ViewerDynamics);

    _this72 = _super61.call(this, viewer);
    _this72.zoom = new _Dynamic(function (zoomLevel) {
      _this72.viewer.state.vFov = _this72.viewer.dataHelper.zoomLevelToFov(zoomLevel);
      _this72.viewer.state.hFov = _this72.viewer.dataHelper.vFovToHFov(_this72.viewer.state.vFov);

      _this72.viewer.dispatchEvent(new _ZoomUpdatedEvent2(zoomLevel));
    }, {
      defaultValue: _this72.viewer.config.defaultZoomLvl,
      min: 0,
      max: 100,
      wrap: false
    });
    _this72.position = new _MultiDynamic(function (position) {
      _this72.viewer.dataHelper.sphericalCoordsToVector3(position, _this72.viewer.state.direction);

      _this72.viewer.dispatchEvent(new _PositionUpdatedEvent2(_positionCompat(position)));
    }, {
      yaw: new _Dynamic(null, {
        defaultValue: _this72.config.defaultYaw,
        min: 0,
        max: 2 * Math.PI,
        wrap: true
      }),
      pitch: new _Dynamic(null, {
        defaultValue: _this72.config.defaultPitch,
        min: !_this72.viewer.state.littlePlanet ? -Math.PI / 2 : 0,
        max: !_this72.viewer.state.littlePlanet ? Math.PI / 2 : Math.PI * 2,
        wrap: _this72.viewer.state.littlePlanet
      })
    });

    _this72.updateSpeeds();

    return _this72;
  }

  _createClass(ViewerDynamics, [{
    key: "updateSpeeds",
    value: function updateSpeeds() {
      this.zoom.setSpeed(this.config.zoomSpeed * 50);
      this.position.setSpeed(MathUtils.degToRad(this.config.moveSpeed * 50));
    }
  }, {
    key: "update",
    value: function update(elapsed) {
      this.zoom.update(elapsed);
      this.position.update(elapsed);
    }
  }]);

  return ViewerDynamics;
}(AbstractService);

var ViewerState = /*#__PURE__*/_createClass(function ViewerState() {
  _classCallCheck(this, ViewerState);

  this.ready = false;
  this.needsUpdate = false;
  this.keyboardEnabled = false;
  this.direction = new Vector3(0, 0, _SPHERE_RADIUS);
  this.vFov = 60;
  this.hFov = 60;
  this.aspect = 1;
  this.animation = null;
  this.transitionAnimation = null;
  this.loadingPromise = null;
  this.littlePlanet = false;
  this.idleTime = -1;
  this.objectsObservers = {};
  this.size = {
    width: 0,
    height: 0
  };
  this.panoData = {
    fullWidth: 0,
    fullHeight: 0,
    croppedWidth: 0,
    croppedHeight: 0,
    croppedX: 0,
    croppedY: 0,
    poseHeading: 0,
    posePitch: 0,
    poseRoll: 0
  };
}); // src/Viewer.ts


var Viewer = /*#__PURE__*/function (_TypedEventTarget2) {
  _inherits(Viewer, _TypedEventTarget2);

  var _super62 = _createSuper(Viewer);

  function Viewer(config) {
    var _this73;

    _classCallCheck(this, Viewer);

    _this73 = _super62.call(this);
    _this73.plugins = {};
    _this73.children = [];
    _this73.onResize = _throttle(function () {
      return _this73.navbar.autoSize();
    }, 500);
    _this73.tooltip = {
      create: function create(config) {
        _logWarn("tooltip.create() is deprecated, use createTooltip() instead");

        return _this73.createTooltip(config);
      }
    };
    SYSTEM.load();
    _this73.state = new ViewerState();
    _this73.config = getViewerConfig(config);
    _this73.parent = _getElement(config.container);
    _this73.parent[_VIEWER_DATA] = _assertThisInitialized(_this73);
    _this73.container = document.createElement("div");

    _this73.container.classList.add("psv-container");

    _this73.parent.appendChild(_this73.container);

    _this73.adapter = new _this73.config.adapter[0](_assertThisInitialized(_this73), _this73.config.adapter[1]);
    _this73.renderer = new Renderer(_assertThisInitialized(_this73));
    _this73.textureLoader = new TextureLoader(_assertThisInitialized(_this73));
    _this73.eventsHandler = new EventsHandler(_assertThisInitialized(_this73));
    _this73.dataHelper = new DataHelper(_assertThisInitialized(_this73));
    _this73.dynamics = new ViewerDynamics(_assertThisInitialized(_this73));
    _this73.loader = new Loader(_assertThisInitialized(_this73));
    _this73.navbar = new Navbar(_assertThisInitialized(_this73));
    _this73.panel = new Panel(_assertThisInitialized(_this73));
    _this73.notification = new Notification(_assertThisInitialized(_this73));
    _this73.overlay = new Overlay(_assertThisInitialized(_this73));

    _this73.resize(_this73.config.size);

    _toggleClass(_this73.container, "psv--is-touch", SYSTEM.isTouchEnabled.initial);

    SYSTEM.isTouchEnabled.promise.then(function (enabled) {
      return _toggleClass(_this73.container, "psv--is-touch", enabled);
    });

    _this73.config.plugins.forEach(function (_ref19) {
      var _ref20 = _slicedToArray(_ref19, 2),
          plugin = _ref20[0],
          opts = _ref20[1];

      _this73.plugins[plugin.id] = new plugin(_assertThisInitialized(_this73), opts);
    });

    for (var _i17 = 0, _Object$values4 = Object.values(_this73.plugins); _i17 < _Object$values4.length; _i17++) {
      var _plugin$init;

      var plugin = _Object$values4[_i17];
      (_plugin$init = plugin.init) === null || _plugin$init === void 0 ? void 0 : _plugin$init.call(plugin);
    }

    if (_this73.config.navbar) {
      _this73.navbar.setButtons(_this73.config.navbar);
    }

    if (_this73.config.panorama) {
      _this73.setPanorama(_this73.config.panorama);
    } else {
      _this73.loader.show();
    }

    return _this73;
  }

  _createClass(Viewer, [{
    key: "destroy",
    value: function destroy() {
      this.stopAll();
      this.stopKeyboardControl();
      this.exitFullscreen();

      for (var _i18 = 0, _Object$entries9 = Object.entries(this.plugins); _i18 < _Object$entries9.length; _i18++) {
        var _Object$entries9$_i = _slicedToArray(_Object$entries9[_i18], 2),
            id = _Object$entries9$_i[0],
            plugin = _Object$entries9$_i[1];

        plugin.destroy();
        delete this.plugins[id];
      }

      this.children.slice().forEach(function (child) {
        return child.destroy();
      });
      this.children.length = 0;
      this.eventsHandler.destroy();
      this.renderer.destroy();
      this.textureLoader.destroy();
      this.dataHelper.destroy();
      this.adapter.destroy();
      this.dynamics.destroy();
      this.parent.removeChild(this.container);
      delete this.parent[_VIEWER_DATA];
    }
  }, {
    key: "init",
    value: function init() {
      this.eventsHandler.init();
      this.renderer.init();

      if (this.config.navbar) {
        this.container.classList.add("psv--has-navbar");
        this.navbar.show();
      }

      this.resetIdleTimer();
      this.state.ready = true;
      this.dispatchEvent(new _ReadyEvent2());
    }
  }, {
    key: "resetIdleTimer",
    value: function resetIdleTimer() {
      this.state.idleTime = performance.now();
    }
  }, {
    key: "disableIdleTimer",
    value: function disableIdleTimer() {
      this.state.idleTime = -1;
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(pluginId) {
      if (typeof pluginId === "string") {
        return this.plugins[pluginId];
      } else {
        var pluginCtor = pluginInterop(pluginId);
        return pluginCtor ? this.plugins[pluginCtor.id] : null;
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return _positionCompat(this.dataHelper.cleanPosition(this.dynamics.position.current));
    }
  }, {
    key: "getZoomLevel",
    value: function getZoomLevel() {
      return this.dynamics.zoom.current;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return _objectSpread({}, this.state.size);
    }
  }, {
    key: "isFullscreenEnabled",
    value: function isFullscreenEnabled() {
      return document.fullscreenElement === this.container;
    }
  }, {
    key: "needsUpdate",
    value: function needsUpdate() {
      this.state.needsUpdate = true;
    }
  }, {
    key: "autoSize",
    value: function autoSize() {
      if (this.container.clientWidth !== this.state.size.width || this.container.clientHeight !== this.state.size.height) {
        this.state.size.width = Math.round(this.container.clientWidth);
        this.state.size.height = Math.round(this.container.clientHeight);
        this.state.aspect = this.state.size.width / this.state.size.height;
        this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov);
        this.dispatchEvent(new _SizeUpdatedEvent2(this.getSize()));
        this.onResize();
      }
    }
  }, {
    key: "setPanorama",
    value: function setPanorama(path) {
      var _this$state$transitio,
          _this74 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.textureLoader.abortLoading();
      (_this$state$transitio = this.state.transitionAnimation) === null || _this$state$transitio === void 0 ? void 0 : _this$state$transitio.cancel();

      if (!this.state.ready) {
        ["sphereCorrection", "panoData", "overlay", "overlayOpacity"].forEach(function (opt) {
          if (!(opt in options)) {
            options[opt] = _this74.config[opt];
          }
        });
      }

      if (options.transition === void 0 || options.transition === true) {
        options.transition = _DEFAULT_TRANSITION;
      }

      if (options.showLoader === void 0) {
        options.showLoader = true;
      }

      if (options.caption === void 0) {
        options.caption = this.config.caption;
      }

      if (options.description === void 0) {
        options.description = this.config.description;
      }

      if (!options.panoData && typeof this.config.panoData === "function") {
        options.panoData = this.config.panoData;
      }

      var positionProvided = _isExtendedPosition(options);

      var zoomProvided = ("zoom" in options);

      if (positionProvided || zoomProvided) {
        this.stopAll();
      }

      this.hideError();
      this.resetIdleTimer();
      this.config.panorama = path;
      this.config.caption = options.caption;
      this.config.description = options.description;

      var done = function done(err) {
        _this74.loader.hide();

        _this74.state.loadingPromise = null;

        if (_isAbortError(err)) {
          return false;
        } else if (err) {
          _this74.navbar.setCaption("");

          _this74.showError(_this74.config.lang.loadError);

          console.error(err);
          throw err;
        } else {
          _this74.setOverlay(options.overlay, options.overlayOpacity);

          _this74.navbar.setCaption(_this74.config.caption);

          return true;
        }
      };

      this.navbar.setCaption("<em>".concat(this.config.loadingTxt || "", "</em>"));

      if (options.showLoader || !this.state.ready) {
        this.loader.show();
      }

      var loadingPromise = this.adapter.loadTexture(this.config.panorama, options.panoData).then(function (textureData) {
        if (textureData.panorama !== _this74.config.panorama) {
          _this74.adapter.disposeTexture(textureData);

          throw _getAbortError();
        }

        return textureData;
      });

      if (!options.transition || !this.state.ready || !this.adapter.supportsTransition(this.config.panorama)) {
        this.state.loadingPromise = loadingPromise.then(function (textureData) {
          _this74.renderer.show();

          _this74.renderer.setTexture(textureData);

          _this74.renderer.setPanoramaPose(textureData.panoData);

          _this74.renderer.setSphereCorrection(options.sphereCorrection);

          _this74.dispatchEvent(new _PanoramaLoadedEvent2(textureData));

          if (zoomProvided) {
            _this74.zoom(options.zoom);
          }

          if (positionProvided) {
            _this74.rotate(options);
          }

          if (!_this74.state.ready) {
            _this74.init();
          }
        }).then(function () {
          return done();
        }, function (err) {
          return done(err);
        });
      } else {
        this.state.loadingPromise = loadingPromise.then(function (textureData) {
          _this74.loader.hide();

          _this74.state.transitionAnimation = _this74.renderer.transition(textureData, options);
          return _this74.state.transitionAnimation;
        }).then(function (completed) {
          _this74.state.transitionAnimation = null;

          if (!completed) {
            throw _getAbortError();
          }
        }).then(function () {
          return done();
        }, function (err) {
          return done(err);
        });
      }

      return this.state.loadingPromise;
    }
  }, {
    key: "setOverlay",
    value: function setOverlay(path) {
      var _this75 = this;

      var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.config.overlayOpacity;
      var supportsOverlay = this.adapter.constructor.supportsOverlay;

      if (!path) {
        if (supportsOverlay) {
          this.renderer.setOverlay(null, 0);
        }

        return Promise.resolve();
      } else {
        if (!supportsOverlay) {
          return Promise.reject(new PSVError("Current adapter does not supports overlay"));
        }

        return this.adapter.loadTexture(path, function (image) {
          var p = _this75.state.panoData;
          var r = image.width / p.croppedWidth;
          return {
            fullWidth: r * p.fullWidth,
            fullHeight: r * p.fullHeight,
            croppedWidth: r * p.croppedWidth,
            croppedHeight: r * p.croppedHeight,
            croppedX: r * p.croppedX,
            croppedY: r * p.croppedY
          };
        }, false).then(function (textureData) {
          _this75.renderer.setOverlay(textureData, opacity);
        });
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var rawConfig = _objectSpread(_objectSpread({}, this.config), options);

      for (var _i19 = 0, _Object$entries10 = Object.entries(options); _i19 < _Object$entries10.length; _i19++) {
        var _Object$entries10$_i = _slicedToArray(_Object$entries10[_i19], 2),
            key = _Object$entries10$_i[0],
            value = _Object$entries10$_i[1];

        if (!(key in DEFAULTS)) {
          _logWarn("Unknown option ".concat(key));

          continue;
        }

        if (key in READONLY_OPTIONS) {
          _logWarn(READONLY_OPTIONS[key]);

          continue;
        }

        if (key in CONFIG_PARSERS) {
          value = CONFIG_PARSERS[key](value, {
            rawConfig: rawConfig,
            defValue: DEFAULTS[key]
          });
        }

        this.config[key] = value;

        switch (key) {
          case "caption":
            this.navbar.setCaption(this.config.caption);
            break;

          case "size":
            this.resize(this.config.size);
            break;

          case "sphereCorrection":
            this.renderer.setSphereCorrection(this.config.sphereCorrection);
            break;

          case "navbar":
          case "lang":
            this.navbar.setButtons(this.config.navbar);
            break;

          case "moveSpeed":
          case "zoomSpeed":
            this.dynamics.updateSpeeds();
            break;

          case "minFov":
          case "maxFov":
            this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov));
            this.dispatchEvent(new _ZoomUpdatedEvent2(this.getZoomLevel()));
            break;
        }
      }

      this.needsUpdate();
      this.dispatchEvent(new _ConfigChangedEvent2(Object.keys(options)));
    }
  }, {
    key: "setOption",
    value: function setOption(option, value) {
      this.setOptions(_defineProperty({}, option, value));
    }
  }, {
    key: "showError",
    value: function showError(message) {
      this.overlay.show({
        id: _IDS.ERROR,
        image: error_default,
        title: message,
        dissmisable: false
      });
    }
  }, {
    key: "hideError",
    value: function hideError() {
      this.overlay.hide(_IDS.ERROR);
    }
  }, {
    key: "rotate",
    value: function rotate(position) {
      var e = new _BeforeRotateEvent2(this.dataHelper.cleanPosition(position));
      this.dispatchEvent(e);

      if (e.defaultPrevented) {
        return;
      }

      this.dynamics.position.setValue(e.position);
    }
  }, {
    key: "zoom",
    value: function zoom(level) {
      this.dynamics.zoom.setValue(level);
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.dynamics.zoom.step(step);
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.dynamics.zoom.step(-step);
    }
  }, {
    key: "animate",
    value: function animate(options) {
      var _this76 = this;

      var positionProvided = _isExtendedPosition(options);

      var zoomProvided = options.zoom !== void 0;
      var e = new _BeforeAnimateEvent2(positionProvided ? this.dataHelper.cleanPosition(options) : void 0, options.zoom);
      this.dispatchEvent(e);

      if (e.defaultPrevented) {
        return;
      }

      var cleanPosition = e.position;
      var cleanZoom = e.zoomLevel;
      this.stopAll();
      var animProperties = {};
      var duration;

      if (positionProvided) {
        var currentPosition = this.getPosition();

        var tOffset = _getShortestArc(currentPosition.yaw, cleanPosition.yaw);

        animProperties.yaw = {
          start: currentPosition.yaw,
          end: currentPosition.yaw + tOffset
        };
        animProperties.pitch = {
          start: currentPosition.pitch,
          end: cleanPosition.pitch
        };
        duration = this.dataHelper.speedToDuration(options.speed, _getAngle(currentPosition, cleanPosition));
      }

      if (zoomProvided) {
        var dZoom = Math.abs(cleanZoom - this.getZoomLevel());
        animProperties.zoom = {
          start: this.getZoomLevel(),
          end: cleanZoom
        };

        if (!duration) {
          duration = this.dataHelper.speedToDuration(options.speed, Math.PI / 4 * dZoom / 100);
        }
      }

      if (!duration) {
        if (positionProvided) {
          this.rotate(cleanPosition);
        }

        if (zoomProvided) {
          this.zoom(cleanZoom);
        }

        return new _Animation(null);
      }

      this.state.animation = new _Animation({
        properties: animProperties,
        duration: Math.max(_ANIMATION_MIN_DURATION, duration),
        easing: "inOutSine",
        onTick: function onTick(properties) {
          if (positionProvided) {
            _this76.dynamics.position.setValue({
              yaw: properties.yaw,
              pitch: properties.pitch
            });
          }

          if (zoomProvided) {
            _this76.dynamics.zoom.setValue(properties.zoom);
          }
        }
      });
      this.state.animation.then(function () {
        _this76.state.animation = null;

        _this76.resetIdleTimer();
      });
      return this.state.animation;
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      if (this.state.animation) {
        this.state.animation.cancel();
        return this.state.animation;
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "resize",
    value: function resize(size) {
      var _this77 = this;

      var s = size;
      ["width", "height"].forEach(function (dim) {
        if (size && s[dim]) {
          if (/^[0-9.]+$/.test(s[dim])) {
            s[dim] += "px";
          }

          _this77.parent.style[dim] = s[dim];
        }
      });
      this.autoSize();
    }
  }, {
    key: "enterFullscreen",
    value: function enterFullscreen() {
      if (!this.isFullscreenEnabled()) {
        this.container.requestFullscreen();
      }
    }
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (this.isFullscreenEnabled()) {
        document.exitFullscreen();
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      if (!this.isFullscreenEnabled()) {
        this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    }
  }, {
    key: "startKeyboardControl",
    value: function startKeyboardControl() {
      this.state.keyboardEnabled = true;
    }
  }, {
    key: "stopKeyboardControl",
    value: function stopKeyboardControl() {
      this.state.keyboardEnabled = false;
    }
  }, {
    key: "createTooltip",
    value: function createTooltip(config) {
      return new Tooltip(this, config);
    }
  }, {
    key: "observeObjects",
    value: function observeObjects(userDataKey) {
      this.state.objectsObservers[userDataKey] = null;
    }
  }, {
    key: "unobserveObjects",
    value: function unobserveObjects(userDataKey) {
      delete this.state.objectsObservers[userDataKey];
    }
  }, {
    key: "stopAll",
    value: function stopAll() {
      this.dispatchEvent(new _StopAllEvent2());
      this.disableIdleTimer();
      return this.stopAnimation();
    }
  }]);

  return Viewer;
}(TypedEventTarget);

export { AbstractAdapter, AbstractButton, AbstractComponent, AbstractPlugin, constants_exports as CONSTANTS, DEFAULTS, EquirectangularAdapter, PSVError, SYSTEM, TypedEvent, Viewer, events_exports as events, registerButton, utils_exports as utils };
//# sourceMappingURL=index.module.js.map
